// This file is auto-generated by @hey-api/openapi-ts

import { type DefaultError, type InfiniteData, infiniteQueryOptions, queryOptions, type UseMutationOptions } from '@tanstack/react-query';

import { client } from '../client.gen';
import { authorizationV1AuthorizeApiToken, authorizationV1AuthorizeApiToken2, authorizationV1Heartbeat, authorizationV1TestStateMismatch, dbAdminLegacyDbDiagram, dbAdminLegacyDbDiagram2, dbAdminLegacyDbDiagramPost, dbAdminLegacyDbDiagramPost2, dbAdminLegacyFulfillments, dbAdminLegacyFulfillments2, dbAdminLegacyFulfillments3, dbAdminLegacyTokenValidation, dbAdminV1DbDiagram, dbAdminV1DbDiagram2, dbAdminV1DbDiagramPost, dbAdminV1DbDiagramPost2, dbAdminV1Fulfillments, dbAdminV1Fulfillments2, dbAdminV1Fulfillments3, dbAdminV1TokenValidation, esignatureV1EventCallback, esignatureV1OnScreenSign, esignatureV1RefreshOrderEsignature, esignatureV1RequestOrderEsignature, getServicesV1FrontrunnerV1MongoDiscoveryEvent, insuranceV1CategoriesV1Details, insuranceV1CategoriesV1Heartbeat, insuranceV1CategoriesV1Search, insuranceV1CategoriesV1Search2, insuranceV1Details, insuranceV1Heartbeat, insuranceV1Search, insuranceV1Search2, insuranceV2BulkUploadPlanFeeSchedules, insuranceV2GetCarrierProduct, insuranceV2GetCarrierProductLegacy, insuranceV2GetCarrierProducts, insuranceV2GetCarriersByState, insuranceV2GetCoverageZones, insuranceV2GetPlanFeeSchedules, insuranceV2GetPlanFeeScheduleTemplateSources, insuranceV2GetPrimaryIcds, insuranceV2Heartbeat, insuranceV2Refills, insuranceV2SearchIcds, insuranceV2SeedPlanFeeSchedules, insuranceV3CardUploadUrl, insuranceV3CarrierStatusesV3ListCarrierStatuses, insuranceV3CarriersV3CreateCarrier, insuranceV3CarriersV3SearchCarriers, insuranceV3CarriersV3UpdateCarrier, insuranceV3CodeEligibilityOverridesV3CreateCodeEligibilityOverride, insuranceV3CodeEligibilityOverridesV3DeleteCodeEligibilityOverride, insuranceV3CodeEligibilityOverridesV3ListCodeEligibilityOverrides, insuranceV3CodeEligibilityOverridesV3UpdateCodeEligibilityOverride, insuranceV3CodesV3SearchCodes, insuranceV3CoverageZonesV3ListCoverageZones, insuranceV3Discovery, insuranceV3GetCarriersByState, insuranceV3Heartbeat, insuranceV3Mappy, insuranceV3NetworkStatusDesignationsV3CreateNetworkStatusDesignation, insuranceV3NetworkStatusDesignationsV3DeleteNetworkStatusDesignation, insuranceV3NetworkStatusDesignationsV3ListNetworkStatusDesignations, insuranceV3NetworkStatusDesignationsV3UpdateNetworkStatusDesignation, insuranceV3OrderDiscovery, insuranceV3OrderEligibility, insuranceV3PlanCodesV3CreatePlanCode, insuranceV3PlanCodesV3GetPlanCode, insuranceV3PlanCodesV3SearchPlanCodes, insuranceV3PlanCodesV3UpdatePlanCode, insuranceV3PlansV3CreatePlan, insuranceV3PlansV3GetPlan, insuranceV3PlansV3SearchCandidPayers, insuranceV3PlansV3SearchEhrPlans, insuranceV3PlansV3SearchPlans, insuranceV3PlansV3UpdatePlan, insuranceV3PutCards, insuranceV3SupplierBillingAssignmentsV3CreateSupplierBillingAssignment, insuranceV3SupplierBillingAssignmentsV3DeleteSupplierBillingAssignment, insuranceV3SupplierBillingAssignmentsV3ListSupplierBillingAssignments, insuranceV3SupplierBillingAssignmentsV3UpdateSupplierBillingAssignment, insuranceV3TestVerificationKey, insuranceV3Verification, insuranceV4PlansV4CreatePlanAdmin, insuranceV4PlansV4GetPlanAdmin, insuranceV4PlansV4SearchPlansAdmin, insuranceV4PlansV4UpdatePlanAdmin, managementV1DbV1DbExport, managementV1DbV1DbExportManifest, managementV1DbV1DbExportPrune, managementV1DbV1DbImport, managementV1FeeScheduleV1CreateFeeScheduleRoute, managementV1FeeScheduleV1UpdateFeeSchedule, npiV1GetProvider, npiV1SearchProviders, npiV2AddProviderAddress, npiV2GetProvider, npiV2SearchProviders, npiV2ToggleProviderAddress, npiV2UpdateProvider, npiV2UpdateProviderAddress, type Options, orderLookupV1Check, orderLookupV1Start, ordersV1AcceptOrder, ordersV1AssignOrderInsurances, ordersV1Authorize, ordersV1AuthRecovery, ordersV1BackfillRxDate, ordersV1Billing, ordersV1CreateOrderEndpoint, ordersV1DeleteOrderFile, ordersV1DeleteOrderProducts, ordersV1DuplicateOrderEndpoint, ordersV1GetCarrierCoverageZoneProducts, ordersV1GetChangeReasons, ordersV1GetFulfillments, ordersV1GetIneligibilityReasons, ordersV1GetInsuranceCardDownloadUrl, ordersV1GetOnHoldReasons, ordersV1GetOrderFeeSchedules, ordersV1GetOrderFile, ordersV1GetOrderFiles, ordersV1GetRejectionReasons, ordersV1GetTelehealthErrorReasons, ordersV1MoveTempFilesToOrder, ordersV1OrderDetails, ordersV1OrderList, ordersV1OrderScheduleResupply, ordersV1RejectOrder, ordersV1RequestOrderChanges, ordersV1ReviewAuthSubmission, ordersV1SearchPatientsWithOrders, ordersV1SkipOrder, ordersV1SkipOrder2, ordersV1ToggleFulfillmentActive, ordersV1ToggleFulfillmentInactive, ordersV1UpdateFulfillment, ordersV1UpdateFulfillmentAssignee, ordersV1UpdateOrderAssignee, ordersV1UpdateOrderClinicalDocs, ordersV1UpdateOrderContact, ordersV1UpdateOrderInsurance, ordersV1UpdateOrderPatient, ordersV1UpdateOrderPhysician, ordersV1UpdateOrderProducts, ordersV1UpdateOrderReferral, ordersV1UpdateOrderShippingAddress, ordersV1UpdateOrderSupplier, ordersV1UpdateRxDate, ordersV1UploadOrderFile, ordersV1UploadOrderTmpFile, ordersV2DuplicateOrderV2, ordersV2GetOrderStatusesV2, ordersV2MoveOrderToBilling, ordersV2MoveOrderToCantReachPatient, ordersV2MoveOrderToDone, ordersV2MoveOrderToInProgressWithSupplier, ordersV2MoveOrderToOnHoldWithSupplier, ordersV2MoveOrderToPendingAuthorization, ordersV2MoveOrderToPendingReroute, ordersV2MoveOrderToPendingSupplierAcceptance, ordersV2MoveOrderToPreparingShipment, ordersV2MoveOrderToSupplierCompleted, ordersV2MoveOrderToSupplierShipped, ordersV2MoveOrderToTelehealthChasingClinicals, ordersV2MoveOrderToTelehealthCompleted, ordersV2MoveOrderToTelehealthContactingPatient, ordersV2MoveOrderToTelehealthNeedsRescheduling, ordersV2MoveOrderToTelehealthOnHold, ordersV2MoveOrderToTelehealthPostVisitCompleted, ordersV2MoveOrderToTelehealthUpcoming, ordersV2RefreshEsignature, ordersV2RequestEsignature, ordersV4CloseRetellConversations, ordersV4CreateOrderDtcEndpoint, ordersV4CreateOrderMcpEndpoint, ordersV4EscalateMcpOrder, ordersV4PatchConfirmationStatus, ordersV4PatchManualVerification, ordersV4PostConfirmationRequest, ordersV5Billing, ordersV5CancelOrder, ordersV5ListActionReasons, ordersV5MessagesV5CreateMessage, ordersV5MessagesV5DeleteMessage, ordersV5MessagesV5GetOrderMessage, ordersV5MessagesV5MarkMessagesSeen, ordersV5NotificationsV5ListNotifications, ordersV5NotificationsV5MarkNotificationsSeen, ordersV5OrderDetails, ordersV5TimelineV5GetOrderTimeline, ordersV5TriggerRentalClaimsEndpoint, ordersV5UncancelOrders, organizationsV1CreateOrganization, organizationsV1GetOrganization, organizationsV1SearchOrganizations, organizationsV1UpdateOrganization, patientsV2GetContactFieldOptions, patientsV2Heartbeat, patientsV2PatientAddresses, patientsV2PatientContacts, patientsV2PatientCustomerioProfile, patientsV2PatientDetails, patientsV2PatientInsurances, patientsV2PatientOrders, patientsV2ReassignPatient, patientsV2SearchPatients, postProductsV2CartV2CreateUpdateCart, postServicesV1FrontrunnerV1MongoDiscoveryEvent, productsV1CategoriesV1Heartbeat, productsV1CategoriesV1Search, productsV1Heartbeat, productsV1ProductDetails, productsV1SearchProducts, productsV2CarrierCoverageZoneProductsV2CreateCarrierCoverageZoneProduct, productsV2CarrierCoverageZoneProductsV2DeleteCarrierCoverageZoneProduct, productsV2CarrierCoverageZoneProductsV2EditCarrierCoverageZoneProduct, productsV2CarrierCoverageZoneProductsV2GetCarrierCoverageZoneProductDetails, productsV2CarrierCoverageZoneProductsV2Heartbeat, productsV2CartV2DeleteCart, productsV2CartV2GetCart, productsV2CategoriesV2GetAllCategories, productsV2CategoriesV2Heartbeat, productsV2CategoriesV2SearchCategories, productsV2EditProduct, productsV2FoldProducts, productsV2FoldProducts2, productsV2FoldProducts3, productsV2FoldProducts4, productsV2GetProductDetails, productsV2Heartbeat, productsV2SearchProducts, productsV3ExportCatalog, productsV3ExportCatalog2, productsV3GetCategories, productsV3GetCoverageZones, productsV3GetProducts, productsV3Heartbeat, productsV4GetAllCategories, productsV4GetCarriers, productsV4GetCatalogProduct, productsV4GetCatalogProducts, productsV4GetCoverageZones, productsV4GetFeeSchedule, productsV4GetProductAudit, productsV4GetProductDetail, productsV4SearchCategories, productsV4SearchProducts, productsV5CreateBundleItemRoute, productsV5CreateProductRoute, productsV5DeleteBundleItemRoute, productsV5DeleteProductPhotoRoute, productsV5DeleteProductRoute, productsV5GetAdminCatalog, productsV5GetAdminCategories, productsV5GetAdminPlans, productsV5GetAdminProductStates, productsV5GetBundleTypesRoute, productsV5GetProductBundleItems, productsV5PatchProductPhotosRoute, productsV5UpdateProductRoute, putProductsV2CartV2CreateUpdateCart, schedulingV3CalcomWebhook, schedulingV3GetSlots, schedulingV3ReserveSlot, schedulingV4BookSelfScheduledAppointment, schedulingV4CancelAppointment, schedulingV4GetAppointment, schedulingV4GetDays, schedulingV4GetSlots, schedulingV4RequestSelfSchedule, schedulingV4RescheduleAppointment, schedulingV4ScheduleOrRescheduleAppointment, schedulingV4VerifyPatientBooking, servicesV1Auth0V1DuplicateAuth0Users, servicesV1Auth0V1ExportAuth0Users, servicesV1Auth0V1GetAuth0User, servicesV1Auth0V1Heartbeat, servicesV1Auth0V1ListAuth0Users, servicesV1Auth0V1ListAuth0Users2, servicesV1CandidV1GenerateEncounterPayload, servicesV1CandidV1Heartbeat, servicesV1CandidV1SearchOrderEncounter, servicesV1CandidV1SyncFulfillmentByOrder, servicesV1CandidV1SyncRentalClaims, servicesV1CustomerioV1PostCreateTicket, servicesV1EpacesV1CancelPriorAuthorizationsForOrder, servicesV1EpacesV1CancelPriorAuthorizationsForOrder2, servicesV1EpacesV1GetEligibilityResponses, servicesV1EpacesV1GetPriorAuthorizationResponses, servicesV1EpacesV1GetPriorAuthorizationResponsesForOrder, servicesV1EpacesV1Heartbeat, servicesV1EpacesV1SubmitPriorAuthorizationForOrder, servicesV1EpacesV1SubmitPriorAuthorizationForOrder2, servicesV1FrontrunnerV1DiscoveryByOrderEndpoint, servicesV1FrontrunnerV1DiscoveryByPatientEndpoint, servicesV1FrontrunnerV1EligibilityByOrderEndpoint, servicesV1FrontrunnerV1EligibilityByOrderEndpoint2, servicesV1FrontrunnerV1EligibilityByPatientEndpoint, servicesV1FrontrunnerV1Heartbeat, servicesV1FrontrunnerV1MockDiscovery, servicesV1FrontrunnerV1MongoDiscoverySource, servicesV1FrontrunnerV1MongoEligibilityEvent, servicesV1FrontrunnerV1MongoEligibilityEvent2, servicesV1FrontrunnerV1MongoEligibilitySource, servicesV1FrontrunnerV1MongoEligibilitySource2, servicesV1FrontrunnerV1PrioritizedDiscoveryByOrderEndpoint, servicesV1FrontrunnerV1PrioritizedDiscoveryByPatientEndpoint, servicesV1FrontrunnerV1PrioritizedEligibilityByOrderEndpoint, servicesV1FrontrunnerV1PrioritizedEligibilityByOrderEndpoint2, servicesV1FrontrunnerV1PrioritizedEligibilityByPatientEndpoint, servicesV1Heartbeat, servicesV1HubspotV1Contacts, servicesV1HubspotV1Heartbeat, servicesV1HubspotV1IngestContacts, servicesV1HubspotV1IngestOrders, servicesV1HubspotV1Orders, servicesV1HubspotV1Products, servicesV1IntercomV1IntercomSendReply, servicesV1LuminaV1Heartbeat, servicesV1LuminaV1SubmitOrder, servicesV1MedlineV1PostShipmentReport, servicesV1SlackV1SlackPost, servicesV2FrontrunnerV2Heartbeat, servicesV2FrontrunnerV2PipelineReplay, servicesV2FrontrunnerV2PlanDetails, servicesV2Heartbeat, sessionsV3PreviewSession, sessionsV3SaveSession, sessionsV3VerifySession, suppliersV1Details, suppliersV1GetAllSuppliers, suppliersV1Heartbeat, suppliersV1Search, suppliersV1Search2, suppliersV2Details, suppliersV2GetAllSuppliers, suppliersV2Heartbeat, suppliersV2Search, suppliersV2Search2, systemV1AggregateLegacyContacts, systemV1AnalyzeProgressNoteRoute, systemV1AxiomStatus, systemV1BackfillAftershipShipmentsRoute, systemV1BackfillFulfillmentHcpcsCodesRoute, systemV1BackfillInsurancePlanUuidRoute, systemV1ClearAxiom, systemV1CurrentAxiom, systemV1DisableCurrentAxiomOrder, systemV1Epaces, systemV1FailedFulfillmentResupply, systemV1GenerateLomnRoute, systemV1Heartbeat, systemV1LomnHistory, systemV1LomnPdf, systemV1LomnRequirements, systemV1LomnRequirementsPopulate, systemV1MessageConversionEvents, systemV1MigrateLegacyPatientRoute, systemV1MigrateMongoOrderAncestry, systemV1MigrateMongoOrdersRoute, systemV1MongoHealth, systemV1OrdersMissingOt, systemV1PdfReader, systemV1ProduceMessage, systemV1PromoteToConfirmOrder, systemV1RerunInsuranceDiscovery, systemV1SyncCioOrdersById, systemV1SyncIntercomConvoById, systemV1SyncMongoOrdersById, systemV1TriggerResupplyReport, trackingV4VerifyAndGetTracking, usersV1ActivateUser, usersV1CreateUser, usersV1DeleteUser, usersV1GetUser, usersV1ListCommunicationPreferences, usersV1SearchUsers, usersV1UpdateCommunicationPreferences, usersV1UpdateUser, verifyV3Check, verifyV3Start } from '../sdk.gen';
import type { AuthorizationV1AuthorizeApiToken2Data, AuthorizationV1AuthorizeApiToken2Response, AuthorizationV1AuthorizeApiTokenData, AuthorizationV1AuthorizeApiTokenResponse, AuthorizationV1HeartbeatData, AuthorizationV1HeartbeatResponse, AuthorizationV1TestStateMismatchData, AuthorizationV1TestStateMismatchResponse, DbAdminLegacyDbDiagram2Data, DbAdminLegacyDbDiagram2Response, DbAdminLegacyDbDiagramData, DbAdminLegacyDbDiagramPost2Data, DbAdminLegacyDbDiagramPost2Response, DbAdminLegacyDbDiagramPostData, DbAdminLegacyDbDiagramPostResponse, DbAdminLegacyDbDiagramResponse, DbAdminLegacyFulfillments2Data, DbAdminLegacyFulfillments2Response, DbAdminLegacyFulfillments3Data, DbAdminLegacyFulfillments3Response, DbAdminLegacyFulfillmentsData, DbAdminLegacyFulfillmentsResponse, DbAdminLegacyTokenValidationData, DbAdminLegacyTokenValidationResponse, DbAdminV1DbDiagram2Data, DbAdminV1DbDiagram2Response, DbAdminV1DbDiagramData, DbAdminV1DbDiagramPost2Data, DbAdminV1DbDiagramPost2Response, DbAdminV1DbDiagramPostData, DbAdminV1DbDiagramPostResponse, DbAdminV1DbDiagramResponse, DbAdminV1Fulfillments2Data, DbAdminV1Fulfillments2Response, DbAdminV1Fulfillments3Data, DbAdminV1Fulfillments3Response, DbAdminV1FulfillmentsData, DbAdminV1FulfillmentsResponse, DbAdminV1TokenValidationData, DbAdminV1TokenValidationResponse, EsignatureV1EventCallbackData, EsignatureV1EventCallbackResponse, EsignatureV1OnScreenSignData, EsignatureV1OnScreenSignResponse, EsignatureV1RefreshOrderEsignatureData, EsignatureV1RefreshOrderEsignatureResponse, EsignatureV1RequestOrderEsignatureData, EsignatureV1RequestOrderEsignatureResponse, GetServicesV1FrontrunnerV1MongoDiscoveryEventData, GetServicesV1FrontrunnerV1MongoDiscoveryEventResponse, InsuranceV1CategoriesV1DetailsData, InsuranceV1CategoriesV1DetailsResponse, InsuranceV1CategoriesV1HeartbeatData, InsuranceV1CategoriesV1HeartbeatResponse, InsuranceV1CategoriesV1Search2Data, InsuranceV1CategoriesV1Search2Response, InsuranceV1CategoriesV1SearchData, InsuranceV1CategoriesV1SearchResponse, InsuranceV1DetailsData, InsuranceV1DetailsResponse, InsuranceV1HeartbeatData, InsuranceV1HeartbeatResponse, InsuranceV1Search2Data, InsuranceV1Search2Response, InsuranceV1SearchData, InsuranceV1SearchResponse, InsuranceV2BulkUploadPlanFeeSchedulesData, InsuranceV2BulkUploadPlanFeeSchedulesResponse, InsuranceV2GetCarrierProductData, InsuranceV2GetCarrierProductLegacyData, InsuranceV2GetCarrierProductLegacyResponse, InsuranceV2GetCarrierProductResponse, InsuranceV2GetCarrierProductsData, InsuranceV2GetCarrierProductsResponse, InsuranceV2GetCarriersByStateData, InsuranceV2GetCarriersByStateResponse, InsuranceV2GetCoverageZonesData, InsuranceV2GetCoverageZonesResponse, InsuranceV2GetPlanFeeSchedulesData, InsuranceV2GetPlanFeeSchedulesResponse, InsuranceV2GetPlanFeeScheduleTemplateSourcesData, InsuranceV2GetPlanFeeScheduleTemplateSourcesResponse, InsuranceV2GetPrimaryIcdsData, InsuranceV2GetPrimaryIcdsResponse, InsuranceV2HeartbeatData, InsuranceV2HeartbeatResponse, InsuranceV2RefillsData, InsuranceV2RefillsResponse, InsuranceV2SearchIcdsData, InsuranceV2SearchIcdsResponse, InsuranceV2SeedPlanFeeSchedulesData, InsuranceV2SeedPlanFeeSchedulesResponse, InsuranceV3CardUploadUrlData, InsuranceV3CardUploadUrlResponse, InsuranceV3CarrierStatusesV3ListCarrierStatusesData, InsuranceV3CarrierStatusesV3ListCarrierStatusesResponse, InsuranceV3CarriersV3CreateCarrierData, InsuranceV3CarriersV3CreateCarrierResponse, InsuranceV3CarriersV3SearchCarriersData, InsuranceV3CarriersV3SearchCarriersResponse, InsuranceV3CarriersV3UpdateCarrierData, InsuranceV3CarriersV3UpdateCarrierResponse, InsuranceV3CodeEligibilityOverridesV3CreateCodeEligibilityOverrideData, InsuranceV3CodeEligibilityOverridesV3CreateCodeEligibilityOverrideResponse, InsuranceV3CodeEligibilityOverridesV3DeleteCodeEligibilityOverrideData, InsuranceV3CodeEligibilityOverridesV3DeleteCodeEligibilityOverrideResponse, InsuranceV3CodeEligibilityOverridesV3ListCodeEligibilityOverridesData, InsuranceV3CodeEligibilityOverridesV3ListCodeEligibilityOverridesResponse, InsuranceV3CodeEligibilityOverridesV3UpdateCodeEligibilityOverrideData, InsuranceV3CodeEligibilityOverridesV3UpdateCodeEligibilityOverrideResponse, InsuranceV3CodesV3SearchCodesData, InsuranceV3CodesV3SearchCodesResponse, InsuranceV3CoverageZonesV3ListCoverageZonesData, InsuranceV3CoverageZonesV3ListCoverageZonesResponse, InsuranceV3DiscoveryData, InsuranceV3DiscoveryResponse, InsuranceV3GetCarriersByStateData, InsuranceV3GetCarriersByStateResponse, InsuranceV3HeartbeatData, InsuranceV3HeartbeatResponse, InsuranceV3MappyData, InsuranceV3MappyResponse, InsuranceV3NetworkStatusDesignationsV3CreateNetworkStatusDesignationData, InsuranceV3NetworkStatusDesignationsV3CreateNetworkStatusDesignationResponse, InsuranceV3NetworkStatusDesignationsV3DeleteNetworkStatusDesignationData, InsuranceV3NetworkStatusDesignationsV3DeleteNetworkStatusDesignationResponse, InsuranceV3NetworkStatusDesignationsV3ListNetworkStatusDesignationsData, InsuranceV3NetworkStatusDesignationsV3ListNetworkStatusDesignationsResponse, InsuranceV3NetworkStatusDesignationsV3UpdateNetworkStatusDesignationData, InsuranceV3NetworkStatusDesignationsV3UpdateNetworkStatusDesignationResponse, InsuranceV3OrderDiscoveryData, InsuranceV3OrderEligibilityData, InsuranceV3PlanCodesV3CreatePlanCodeData, InsuranceV3PlanCodesV3CreatePlanCodeResponse, InsuranceV3PlanCodesV3GetPlanCodeData, InsuranceV3PlanCodesV3GetPlanCodeResponse, InsuranceV3PlanCodesV3SearchPlanCodesData, InsuranceV3PlanCodesV3SearchPlanCodesResponse, InsuranceV3PlanCodesV3UpdatePlanCodeData, InsuranceV3PlanCodesV3UpdatePlanCodeResponse, InsuranceV3PlansV3CreatePlanData, InsuranceV3PlansV3CreatePlanResponse, InsuranceV3PlansV3GetPlanData, InsuranceV3PlansV3GetPlanResponse, InsuranceV3PlansV3SearchCandidPayersData, InsuranceV3PlansV3SearchCandidPayersResponse, InsuranceV3PlansV3SearchEhrPlansData, InsuranceV3PlansV3SearchEhrPlansResponse, InsuranceV3PlansV3SearchPlansData, InsuranceV3PlansV3SearchPlansResponse, InsuranceV3PlansV3UpdatePlanData, InsuranceV3PlansV3UpdatePlanResponse, InsuranceV3PutCardsData, InsuranceV3PutCardsResponse, InsuranceV3SupplierBillingAssignmentsV3CreateSupplierBillingAssignmentData, InsuranceV3SupplierBillingAssignmentsV3CreateSupplierBillingAssignmentResponse, InsuranceV3SupplierBillingAssignmentsV3DeleteSupplierBillingAssignmentData, InsuranceV3SupplierBillingAssignmentsV3DeleteSupplierBillingAssignmentResponse, InsuranceV3SupplierBillingAssignmentsV3ListSupplierBillingAssignmentsData, InsuranceV3SupplierBillingAssignmentsV3ListSupplierBillingAssignmentsResponse, InsuranceV3SupplierBillingAssignmentsV3UpdateSupplierBillingAssignmentData, InsuranceV3SupplierBillingAssignmentsV3UpdateSupplierBillingAssignmentResponse, InsuranceV3TestVerificationKeyData, InsuranceV3TestVerificationKeyResponse, InsuranceV3VerificationData, InsuranceV3VerificationResponse, InsuranceV4PlansV4CreatePlanAdminData, InsuranceV4PlansV4CreatePlanAdminResponse, InsuranceV4PlansV4GetPlanAdminData, InsuranceV4PlansV4GetPlanAdminResponse, InsuranceV4PlansV4SearchPlansAdminData, InsuranceV4PlansV4SearchPlansAdminResponse, InsuranceV4PlansV4UpdatePlanAdminData, InsuranceV4PlansV4UpdatePlanAdminResponse, ManagementV1DbV1DbExportData, ManagementV1DbV1DbExportManifestData, ManagementV1DbV1DbExportManifestResponse, ManagementV1DbV1DbExportPruneData, ManagementV1DbV1DbExportPruneResponse, ManagementV1DbV1DbExportResponse, ManagementV1DbV1DbImportData, ManagementV1DbV1DbImportResponse, ManagementV1FeeScheduleV1CreateFeeScheduleRouteData, ManagementV1FeeScheduleV1CreateFeeScheduleRouteResponse, ManagementV1FeeScheduleV1UpdateFeeScheduleData, ManagementV1FeeScheduleV1UpdateFeeScheduleResponse, NpiV1GetProviderData, NpiV1GetProviderResponse, NpiV1SearchProvidersData, NpiV1SearchProvidersResponse, NpiV2AddProviderAddressData, NpiV2AddProviderAddressResponse, NpiV2GetProviderData, NpiV2GetProviderResponse, NpiV2SearchProvidersData, NpiV2SearchProvidersResponse, NpiV2ToggleProviderAddressData, NpiV2ToggleProviderAddressResponse, NpiV2UpdateProviderAddressData, NpiV2UpdateProviderAddressResponse, NpiV2UpdateProviderData, NpiV2UpdateProviderResponse, OrderLookupV1CheckData, OrderLookupV1CheckResponse, OrderLookupV1StartData, OrderLookupV1StartResponse, OrdersV1AcceptOrderData, OrdersV1AcceptOrderResponse, OrdersV1AssignOrderInsurancesData, OrdersV1AssignOrderInsurancesResponse, OrdersV1AuthorizeData, OrdersV1AuthorizeResponse, OrdersV1AuthRecoveryData, OrdersV1AuthRecoveryResponse, OrdersV1BackfillRxDateData, OrdersV1BackfillRxDateResponse, OrdersV1BillingData, OrdersV1BillingResponse, OrdersV1CreateOrderEndpointData, OrdersV1CreateOrderEndpointResponse, OrdersV1DeleteOrderFileData, OrdersV1DeleteOrderFileResponse, OrdersV1DeleteOrderProductsData, OrdersV1DeleteOrderProductsResponse, OrdersV1DuplicateOrderEndpointData, OrdersV1DuplicateOrderEndpointResponse, OrdersV1GetCarrierCoverageZoneProductsData, OrdersV1GetCarrierCoverageZoneProductsResponse, OrdersV1GetChangeReasonsData, OrdersV1GetChangeReasonsResponse, OrdersV1GetFulfillmentsData, OrdersV1GetFulfillmentsResponse, OrdersV1GetIneligibilityReasonsData, OrdersV1GetIneligibilityReasonsResponse, OrdersV1GetInsuranceCardDownloadUrlData, OrdersV1GetInsuranceCardDownloadUrlResponse, OrdersV1GetOnHoldReasonsData, OrdersV1GetOnHoldReasonsResponse, OrdersV1GetOrderFeeSchedulesData, OrdersV1GetOrderFeeSchedulesResponse, OrdersV1GetOrderFileData, OrdersV1GetOrderFileResponse, OrdersV1GetOrderFilesData, OrdersV1GetOrderFilesResponse, OrdersV1GetRejectionReasonsData, OrdersV1GetRejectionReasonsResponse, OrdersV1GetTelehealthErrorReasonsData, OrdersV1GetTelehealthErrorReasonsResponse, OrdersV1MoveTempFilesToOrderData, OrdersV1MoveTempFilesToOrderResponse, OrdersV1OrderDetailsData, OrdersV1OrderDetailsResponse, OrdersV1OrderListData, OrdersV1OrderListResponse, OrdersV1OrderScheduleResupplyData, OrdersV1OrderScheduleResupplyResponse, OrdersV1RejectOrderData, OrdersV1RejectOrderResponse, OrdersV1RequestOrderChangesData, OrdersV1RequestOrderChangesResponse, OrdersV1ReviewAuthSubmissionData, OrdersV1ReviewAuthSubmissionResponse, OrdersV1SearchPatientsWithOrdersData, OrdersV1SearchPatientsWithOrdersResponse, OrdersV1SkipOrder2Data, OrdersV1SkipOrder2Response, OrdersV1SkipOrderData, OrdersV1SkipOrderResponse, OrdersV1ToggleFulfillmentActiveData, OrdersV1ToggleFulfillmentActiveResponse, OrdersV1ToggleFulfillmentInactiveData, OrdersV1ToggleFulfillmentInactiveResponse, OrdersV1UpdateFulfillmentAssigneeData, OrdersV1UpdateFulfillmentAssigneeResponse, OrdersV1UpdateFulfillmentData, OrdersV1UpdateFulfillmentResponse, OrdersV1UpdateOrderAssigneeData, OrdersV1UpdateOrderAssigneeResponse, OrdersV1UpdateOrderClinicalDocsData, OrdersV1UpdateOrderClinicalDocsResponse, OrdersV1UpdateOrderContactData, OrdersV1UpdateOrderContactResponse, OrdersV1UpdateOrderInsuranceData, OrdersV1UpdateOrderInsuranceResponse, OrdersV1UpdateOrderPatientData, OrdersV1UpdateOrderPatientResponse, OrdersV1UpdateOrderPhysicianData, OrdersV1UpdateOrderPhysicianResponse, OrdersV1UpdateOrderProductsData, OrdersV1UpdateOrderProductsResponse, OrdersV1UpdateOrderReferralData, OrdersV1UpdateOrderReferralResponse, OrdersV1UpdateOrderShippingAddressData, OrdersV1UpdateOrderShippingAddressResponse, OrdersV1UpdateOrderSupplierData, OrdersV1UpdateOrderSupplierResponse, OrdersV1UpdateRxDateData, OrdersV1UpdateRxDateResponse, OrdersV1UploadOrderFileData, OrdersV1UploadOrderFileResponse, OrdersV1UploadOrderTmpFileData, OrdersV1UploadOrderTmpFileResponse, OrdersV2DuplicateOrderV2Data, OrdersV2DuplicateOrderV2Response, OrdersV2GetOrderStatusesV2Data, OrdersV2GetOrderStatusesV2Response, OrdersV2MoveOrderToBillingData, OrdersV2MoveOrderToBillingResponse, OrdersV2MoveOrderToCantReachPatientData, OrdersV2MoveOrderToCantReachPatientResponse, OrdersV2MoveOrderToDoneData, OrdersV2MoveOrderToDoneResponse, OrdersV2MoveOrderToInProgressWithSupplierData, OrdersV2MoveOrderToInProgressWithSupplierResponse, OrdersV2MoveOrderToOnHoldWithSupplierData, OrdersV2MoveOrderToOnHoldWithSupplierResponse, OrdersV2MoveOrderToPendingAuthorizationData, OrdersV2MoveOrderToPendingAuthorizationResponse, OrdersV2MoveOrderToPendingRerouteData, OrdersV2MoveOrderToPendingRerouteResponse, OrdersV2MoveOrderToPendingSupplierAcceptanceData, OrdersV2MoveOrderToPendingSupplierAcceptanceResponse, OrdersV2MoveOrderToPreparingShipmentData, OrdersV2MoveOrderToPreparingShipmentResponse, OrdersV2MoveOrderToSupplierCompletedData, OrdersV2MoveOrderToSupplierCompletedResponse, OrdersV2MoveOrderToSupplierShippedData, OrdersV2MoveOrderToSupplierShippedResponse, OrdersV2MoveOrderToTelehealthChasingClinicalsData, OrdersV2MoveOrderToTelehealthChasingClinicalsResponse, OrdersV2MoveOrderToTelehealthCompletedData, OrdersV2MoveOrderToTelehealthCompletedResponse, OrdersV2MoveOrderToTelehealthContactingPatientData, OrdersV2MoveOrderToTelehealthContactingPatientResponse, OrdersV2MoveOrderToTelehealthNeedsReschedulingData, OrdersV2MoveOrderToTelehealthNeedsReschedulingResponse, OrdersV2MoveOrderToTelehealthOnHoldData, OrdersV2MoveOrderToTelehealthOnHoldResponse, OrdersV2MoveOrderToTelehealthPostVisitCompletedData, OrdersV2MoveOrderToTelehealthPostVisitCompletedResponse, OrdersV2MoveOrderToTelehealthUpcomingData, OrdersV2MoveOrderToTelehealthUpcomingResponse, OrdersV2RefreshEsignatureData, OrdersV2RefreshEsignatureResponse, OrdersV2RequestEsignatureData, OrdersV2RequestEsignatureResponse, OrdersV4CloseRetellConversationsData, OrdersV4CreateOrderDtcEndpointData, OrdersV4CreateOrderDtcEndpointResponse, OrdersV4CreateOrderMcpEndpointData, OrdersV4CreateOrderMcpEndpointResponse, OrdersV4EscalateMcpOrderData, OrdersV4EscalateMcpOrderResponse, OrdersV4PatchConfirmationStatusData, OrdersV4PatchConfirmationStatusResponse, OrdersV4PatchManualVerificationData, OrdersV4PatchManualVerificationResponse, OrdersV4PostConfirmationRequestData, OrdersV4PostConfirmationRequestResponse, OrdersV5BillingData, OrdersV5CancelOrderData, OrdersV5CancelOrderResponse, OrdersV5ListActionReasonsData, OrdersV5ListActionReasonsResponse, OrdersV5MessagesV5CreateMessageData, OrdersV5MessagesV5CreateMessageResponse, OrdersV5MessagesV5DeleteMessageData, OrdersV5MessagesV5DeleteMessageResponse, OrdersV5MessagesV5GetOrderMessageData, OrdersV5MessagesV5GetOrderMessageResponse, OrdersV5MessagesV5MarkMessagesSeenData, OrdersV5MessagesV5MarkMessagesSeenResponse, OrdersV5NotificationsV5ListNotificationsData, OrdersV5NotificationsV5ListNotificationsResponse, OrdersV5NotificationsV5MarkNotificationsSeenData, OrdersV5NotificationsV5MarkNotificationsSeenResponse, OrdersV5OrderDetailsData, OrdersV5OrderDetailsResponse, OrdersV5TimelineV5GetOrderTimelineData, OrdersV5TimelineV5GetOrderTimelineResponse, OrdersV5TriggerRentalClaimsEndpointData, OrdersV5UncancelOrdersData, OrganizationsV1CreateOrganizationData, OrganizationsV1CreateOrganizationResponse, OrganizationsV1GetOrganizationData, OrganizationsV1GetOrganizationResponse, OrganizationsV1SearchOrganizationsData, OrganizationsV1SearchOrganizationsResponse, OrganizationsV1UpdateOrganizationData, OrganizationsV1UpdateOrganizationResponse, PatientsV2GetContactFieldOptionsData, PatientsV2GetContactFieldOptionsResponse, PatientsV2HeartbeatData, PatientsV2HeartbeatResponse, PatientsV2PatientAddressesData, PatientsV2PatientAddressesResponse, PatientsV2PatientContactsData, PatientsV2PatientContactsResponse, PatientsV2PatientCustomerioProfileData, PatientsV2PatientCustomerioProfileResponse, PatientsV2PatientDetailsData, PatientsV2PatientDetailsResponse, PatientsV2PatientInsurancesData, PatientsV2PatientInsurancesResponse, PatientsV2PatientOrdersData, PatientsV2PatientOrdersResponse, PatientsV2ReassignPatientData, PatientsV2ReassignPatientResponse, PatientsV2SearchPatientsData, PatientsV2SearchPatientsResponse, PostProductsV2CartV2CreateUpdateCartData, PostProductsV2CartV2CreateUpdateCartResponse, PostServicesV1FrontrunnerV1MongoDiscoveryEventData, PostServicesV1FrontrunnerV1MongoDiscoveryEventResponse, ProductsV1CategoriesV1HeartbeatData, ProductsV1CategoriesV1HeartbeatResponse, ProductsV1CategoriesV1SearchData, ProductsV1CategoriesV1SearchResponse, ProductsV1HeartbeatData, ProductsV1HeartbeatResponse, ProductsV1ProductDetailsData, ProductsV1ProductDetailsResponse, ProductsV1SearchProductsData, ProductsV1SearchProductsResponse, ProductsV2CarrierCoverageZoneProductsV2CreateCarrierCoverageZoneProductData, ProductsV2CarrierCoverageZoneProductsV2CreateCarrierCoverageZoneProductResponse, ProductsV2CarrierCoverageZoneProductsV2DeleteCarrierCoverageZoneProductData, ProductsV2CarrierCoverageZoneProductsV2DeleteCarrierCoverageZoneProductResponse, ProductsV2CarrierCoverageZoneProductsV2EditCarrierCoverageZoneProductData, ProductsV2CarrierCoverageZoneProductsV2EditCarrierCoverageZoneProductResponse, ProductsV2CarrierCoverageZoneProductsV2GetCarrierCoverageZoneProductDetailsData, ProductsV2CarrierCoverageZoneProductsV2GetCarrierCoverageZoneProductDetailsResponse, ProductsV2CarrierCoverageZoneProductsV2HeartbeatData, ProductsV2CarrierCoverageZoneProductsV2HeartbeatResponse, ProductsV2CartV2DeleteCartData, ProductsV2CartV2DeleteCartResponse, ProductsV2CartV2GetCartData, ProductsV2CartV2GetCartResponse, ProductsV2CategoriesV2GetAllCategoriesData, ProductsV2CategoriesV2GetAllCategoriesResponse, ProductsV2CategoriesV2HeartbeatData, ProductsV2CategoriesV2HeartbeatResponse, ProductsV2CategoriesV2SearchCategoriesData, ProductsV2CategoriesV2SearchCategoriesResponse, ProductsV2EditProductData, ProductsV2EditProductResponse, ProductsV2FoldProducts2Data, ProductsV2FoldProducts2Response, ProductsV2FoldProducts3Data, ProductsV2FoldProducts3Response, ProductsV2FoldProducts4Data, ProductsV2FoldProducts4Response, ProductsV2FoldProductsData, ProductsV2FoldProductsResponse, ProductsV2GetProductDetailsData, ProductsV2GetProductDetailsResponse, ProductsV2HeartbeatData, ProductsV2HeartbeatResponse, ProductsV2SearchProductsData, ProductsV2SearchProductsResponse, ProductsV3ExportCatalog2Data, ProductsV3ExportCatalog2Response, ProductsV3ExportCatalogData, ProductsV3ExportCatalogResponse, ProductsV3GetCategoriesData, ProductsV3GetCategoriesResponse, ProductsV3GetCoverageZonesData, ProductsV3GetCoverageZonesResponse, ProductsV3GetProductsData, ProductsV3GetProductsResponse, ProductsV3HeartbeatData, ProductsV3HeartbeatResponse, ProductsV4GetAllCategoriesData, ProductsV4GetAllCategoriesResponse, ProductsV4GetCarriersData, ProductsV4GetCarriersResponse, ProductsV4GetCatalogProductData, ProductsV4GetCatalogProductResponse, ProductsV4GetCatalogProductsData, ProductsV4GetCatalogProductsResponse, ProductsV4GetCoverageZonesData, ProductsV4GetCoverageZonesResponse, ProductsV4GetFeeScheduleData, ProductsV4GetFeeScheduleResponse, ProductsV4GetProductAuditData, ProductsV4GetProductAuditResponse, ProductsV4GetProductDetailData, ProductsV4GetProductDetailResponse, ProductsV4SearchCategoriesData, ProductsV4SearchCategoriesResponse, ProductsV4SearchProductsData, ProductsV4SearchProductsResponse, ProductsV5CreateBundleItemRouteData, ProductsV5CreateBundleItemRouteResponse, ProductsV5CreateProductRouteData, ProductsV5CreateProductRouteResponse, ProductsV5DeleteBundleItemRouteData, ProductsV5DeleteBundleItemRouteResponse, ProductsV5DeleteProductPhotoRouteData, ProductsV5DeleteProductPhotoRouteResponse, ProductsV5DeleteProductRouteData, ProductsV5DeleteProductRouteResponse, ProductsV5GetAdminCatalogData, ProductsV5GetAdminCatalogResponse, ProductsV5GetAdminCategoriesData, ProductsV5GetAdminCategoriesResponse, ProductsV5GetAdminPlansData, ProductsV5GetAdminPlansResponse, ProductsV5GetAdminProductStatesData, ProductsV5GetAdminProductStatesResponse, ProductsV5GetBundleTypesRouteData, ProductsV5GetBundleTypesRouteResponse, ProductsV5GetProductBundleItemsData, ProductsV5GetProductBundleItemsResponse, ProductsV5PatchProductPhotosRouteData, ProductsV5PatchProductPhotosRouteResponse, ProductsV5UpdateProductRouteData, ProductsV5UpdateProductRouteResponse, PutProductsV2CartV2CreateUpdateCartData, PutProductsV2CartV2CreateUpdateCartResponse, SchedulingV3CalcomWebhookData, SchedulingV3CalcomWebhookResponse, SchedulingV3GetSlotsData, SchedulingV3GetSlotsResponse, SchedulingV3ReserveSlotData, SchedulingV3ReserveSlotResponse, SchedulingV4BookSelfScheduledAppointmentData, SchedulingV4BookSelfScheduledAppointmentResponse, SchedulingV4CancelAppointmentData, SchedulingV4CancelAppointmentResponse, SchedulingV4GetAppointmentData, SchedulingV4GetAppointmentResponse, SchedulingV4GetDaysData, SchedulingV4GetDaysResponse, SchedulingV4GetSlotsData, SchedulingV4GetSlotsResponse, SchedulingV4RequestSelfScheduleData, SchedulingV4RequestSelfScheduleResponse, SchedulingV4RescheduleAppointmentData, SchedulingV4RescheduleAppointmentResponse, SchedulingV4ScheduleOrRescheduleAppointmentData, SchedulingV4ScheduleOrRescheduleAppointmentResponse, SchedulingV4VerifyPatientBookingData, SchedulingV4VerifyPatientBookingResponse, ServicesV1Auth0V1DuplicateAuth0UsersData, ServicesV1Auth0V1DuplicateAuth0UsersResponse, ServicesV1Auth0V1ExportAuth0UsersData, ServicesV1Auth0V1ExportAuth0UsersResponse, ServicesV1Auth0V1GetAuth0UserData, ServicesV1Auth0V1GetAuth0UserResponse, ServicesV1Auth0V1HeartbeatData, ServicesV1Auth0V1HeartbeatResponse, ServicesV1Auth0V1ListAuth0Users2Data, ServicesV1Auth0V1ListAuth0Users2Response, ServicesV1Auth0V1ListAuth0UsersData, ServicesV1Auth0V1ListAuth0UsersResponse, ServicesV1CandidV1GenerateEncounterPayloadData, ServicesV1CandidV1GenerateEncounterPayloadResponse, ServicesV1CandidV1HeartbeatData, ServicesV1CandidV1HeartbeatResponse, ServicesV1CandidV1SearchOrderEncounterData, ServicesV1CandidV1SearchOrderEncounterResponse, ServicesV1CandidV1SyncFulfillmentByOrderData, ServicesV1CandidV1SyncFulfillmentByOrderResponse, ServicesV1CandidV1SyncRentalClaimsData, ServicesV1CandidV1SyncRentalClaimsResponse, ServicesV1CustomerioV1PostCreateTicketData, ServicesV1CustomerioV1PostCreateTicketResponse, ServicesV1EpacesV1CancelPriorAuthorizationsForOrder2Data, ServicesV1EpacesV1CancelPriorAuthorizationsForOrder2Response, ServicesV1EpacesV1CancelPriorAuthorizationsForOrderData, ServicesV1EpacesV1CancelPriorAuthorizationsForOrderResponse, ServicesV1EpacesV1GetEligibilityResponsesData, ServicesV1EpacesV1GetEligibilityResponsesResponse, ServicesV1EpacesV1GetPriorAuthorizationResponsesData, ServicesV1EpacesV1GetPriorAuthorizationResponsesForOrderData, ServicesV1EpacesV1GetPriorAuthorizationResponsesForOrderResponse, ServicesV1EpacesV1GetPriorAuthorizationResponsesResponse, ServicesV1EpacesV1HeartbeatData, ServicesV1EpacesV1HeartbeatResponse, ServicesV1EpacesV1SubmitPriorAuthorizationForOrder2Data, ServicesV1EpacesV1SubmitPriorAuthorizationForOrder2Response, ServicesV1EpacesV1SubmitPriorAuthorizationForOrderData, ServicesV1EpacesV1SubmitPriorAuthorizationForOrderResponse, ServicesV1FrontrunnerV1DiscoveryByOrderEndpointData, ServicesV1FrontrunnerV1DiscoveryByOrderEndpointResponse, ServicesV1FrontrunnerV1DiscoveryByPatientEndpointData, ServicesV1FrontrunnerV1DiscoveryByPatientEndpointResponse, ServicesV1FrontrunnerV1EligibilityByOrderEndpoint2Data, ServicesV1FrontrunnerV1EligibilityByOrderEndpoint2Response, ServicesV1FrontrunnerV1EligibilityByOrderEndpointData, ServicesV1FrontrunnerV1EligibilityByOrderEndpointResponse, ServicesV1FrontrunnerV1EligibilityByPatientEndpointData, ServicesV1FrontrunnerV1EligibilityByPatientEndpointResponse, ServicesV1FrontrunnerV1HeartbeatData, ServicesV1FrontrunnerV1HeartbeatResponse, ServicesV1FrontrunnerV1MockDiscoveryData, ServicesV1FrontrunnerV1MockDiscoveryResponse, ServicesV1FrontrunnerV1MongoDiscoverySourceData, ServicesV1FrontrunnerV1MongoDiscoverySourceResponse, ServicesV1FrontrunnerV1MongoEligibilityEvent2Data, ServicesV1FrontrunnerV1MongoEligibilityEvent2Response, ServicesV1FrontrunnerV1MongoEligibilityEventData, ServicesV1FrontrunnerV1MongoEligibilityEventResponse, ServicesV1FrontrunnerV1MongoEligibilitySource2Data, ServicesV1FrontrunnerV1MongoEligibilitySource2Response, ServicesV1FrontrunnerV1MongoEligibilitySourceData, ServicesV1FrontrunnerV1MongoEligibilitySourceResponse, ServicesV1FrontrunnerV1PrioritizedDiscoveryByOrderEndpointData, ServicesV1FrontrunnerV1PrioritizedDiscoveryByOrderEndpointResponse, ServicesV1FrontrunnerV1PrioritizedDiscoveryByPatientEndpointData, ServicesV1FrontrunnerV1PrioritizedDiscoveryByPatientEndpointResponse, ServicesV1FrontrunnerV1PrioritizedEligibilityByOrderEndpoint2Data, ServicesV1FrontrunnerV1PrioritizedEligibilityByOrderEndpoint2Response, ServicesV1FrontrunnerV1PrioritizedEligibilityByOrderEndpointData, ServicesV1FrontrunnerV1PrioritizedEligibilityByOrderEndpointResponse, ServicesV1FrontrunnerV1PrioritizedEligibilityByPatientEndpointData, ServicesV1FrontrunnerV1PrioritizedEligibilityByPatientEndpointResponse, ServicesV1HeartbeatData, ServicesV1HeartbeatResponse, ServicesV1HubspotV1ContactsData, ServicesV1HubspotV1ContactsResponse, ServicesV1HubspotV1HeartbeatData, ServicesV1HubspotV1HeartbeatResponse, ServicesV1HubspotV1IngestContactsData, ServicesV1HubspotV1IngestContactsResponse, ServicesV1HubspotV1IngestOrdersData, ServicesV1HubspotV1IngestOrdersResponse, ServicesV1HubspotV1OrdersData, ServicesV1HubspotV1OrdersResponse, ServicesV1HubspotV1ProductsData, ServicesV1HubspotV1ProductsResponse, ServicesV1IntercomV1IntercomSendReplyData, ServicesV1IntercomV1IntercomSendReplyResponse, ServicesV1LuminaV1HeartbeatData, ServicesV1LuminaV1HeartbeatResponse, ServicesV1LuminaV1SubmitOrderData, ServicesV1LuminaV1SubmitOrderResponse, ServicesV1MedlineV1PostShipmentReportData, ServicesV1MedlineV1PostShipmentReportResponse, ServicesV1SlackV1SlackPostData, ServicesV1SlackV1SlackPostResponse, ServicesV2FrontrunnerV2HeartbeatData, ServicesV2FrontrunnerV2HeartbeatResponse, ServicesV2FrontrunnerV2PipelineReplayData, ServicesV2FrontrunnerV2PipelineReplayResponse, ServicesV2FrontrunnerV2PlanDetailsData, ServicesV2FrontrunnerV2PlanDetailsResponse, ServicesV2HeartbeatData, ServicesV2HeartbeatResponse, SessionsV3PreviewSessionData, SessionsV3PreviewSessionResponse, SessionsV3SaveSessionData, SessionsV3SaveSessionResponse, SessionsV3VerifySessionData, SessionsV3VerifySessionResponse, SuppliersV1DetailsData, SuppliersV1DetailsResponse, SuppliersV1GetAllSuppliersData, SuppliersV1GetAllSuppliersResponse, SuppliersV1HeartbeatData, SuppliersV1HeartbeatResponse, SuppliersV1Search2Data, SuppliersV1Search2Response, SuppliersV1SearchData, SuppliersV1SearchResponse, SuppliersV2DetailsData, SuppliersV2DetailsResponse, SuppliersV2GetAllSuppliersData, SuppliersV2GetAllSuppliersResponse, SuppliersV2HeartbeatData, SuppliersV2HeartbeatResponse, SuppliersV2Search2Data, SuppliersV2Search2Response, SuppliersV2SearchData, SuppliersV2SearchResponse, SystemV1AggregateLegacyContactsData, SystemV1AggregateLegacyContactsResponse, SystemV1AnalyzeProgressNoteRouteData, SystemV1AnalyzeProgressNoteRouteResponse, SystemV1AxiomStatusData, SystemV1AxiomStatusResponse, SystemV1BackfillAftershipShipmentsRouteData, SystemV1BackfillAftershipShipmentsRouteResponse, SystemV1BackfillFulfillmentHcpcsCodesRouteData, SystemV1BackfillFulfillmentHcpcsCodesRouteResponse, SystemV1BackfillInsurancePlanUuidRouteData, SystemV1BackfillInsurancePlanUuidRouteResponse, SystemV1ClearAxiomData, SystemV1ClearAxiomResponse, SystemV1CurrentAxiomData, SystemV1CurrentAxiomResponse, SystemV1DisableCurrentAxiomOrderData, SystemV1DisableCurrentAxiomOrderResponse, SystemV1EpacesData, SystemV1EpacesResponse, SystemV1FailedFulfillmentResupplyData, SystemV1FailedFulfillmentResupplyResponse, SystemV1GenerateLomnRouteData, SystemV1GenerateLomnRouteResponse, SystemV1HeartbeatData, SystemV1HeartbeatResponse, SystemV1LomnHistoryData, SystemV1LomnHistoryResponse, SystemV1LomnPdfData, SystemV1LomnPdfResponse, SystemV1LomnRequirementsData, SystemV1LomnRequirementsPopulateData, SystemV1LomnRequirementsPopulateResponse, SystemV1LomnRequirementsResponse, SystemV1MessageConversionEventsData, SystemV1MessageConversionEventsResponse, SystemV1MigrateLegacyPatientRouteData, SystemV1MigrateLegacyPatientRouteResponse, SystemV1MigrateMongoOrderAncestryData, SystemV1MigrateMongoOrderAncestryResponse, SystemV1MigrateMongoOrdersRouteData, SystemV1MigrateMongoOrdersRouteResponse, SystemV1MongoHealthData, SystemV1MongoHealthResponse, SystemV1OrdersMissingOtData, SystemV1OrdersMissingOtResponse, SystemV1PdfReaderData, SystemV1PdfReaderResponse, SystemV1ProduceMessageData, SystemV1ProduceMessageResponse, SystemV1PromoteToConfirmOrderData, SystemV1PromoteToConfirmOrderResponse, SystemV1RerunInsuranceDiscoveryData, SystemV1RerunInsuranceDiscoveryResponse, SystemV1SyncCioOrdersByIdData, SystemV1SyncCioOrdersByIdResponse, SystemV1SyncIntercomConvoByIdData, SystemV1SyncIntercomConvoByIdResponse, SystemV1SyncMongoOrdersByIdData, SystemV1SyncMongoOrdersByIdResponse, SystemV1TriggerResupplyReportData, SystemV1TriggerResupplyReportResponse, TrackingV4VerifyAndGetTrackingData, TrackingV4VerifyAndGetTrackingResponse, UsersV1ActivateUserData, UsersV1ActivateUserResponse, UsersV1CreateUserData, UsersV1CreateUserResponse, UsersV1DeleteUserData, UsersV1DeleteUserResponse, UsersV1GetUserData, UsersV1GetUserResponse, UsersV1ListCommunicationPreferencesData, UsersV1ListCommunicationPreferencesResponse, UsersV1SearchUsersData, UsersV1SearchUsersResponse, UsersV1UpdateCommunicationPreferencesData, UsersV1UpdateCommunicationPreferencesResponse, UsersV1UpdateUserData, UsersV1UpdateUserResponse, VerifyV3CheckData, VerifyV3CheckResponse, VerifyV3StartData, VerifyV3StartResponse } from '../types.gen';

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};

export const dbAdminLegacyDbDiagramQueryKey = (options?: Options<DbAdminLegacyDbDiagramData>) => createQueryKey('dbAdminLegacyDbDiagram', options);

/**
 * Generate DB ERD
 *
 * Generate and DB entity relationship diagram for the given bind_key
 */
export const dbAdminLegacyDbDiagramOptions = (options?: Options<DbAdminLegacyDbDiagramData>) => queryOptions<DbAdminLegacyDbDiagramResponse, DefaultError, DbAdminLegacyDbDiagramResponse, ReturnType<typeof dbAdminLegacyDbDiagramQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await dbAdminLegacyDbDiagram({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: dbAdminLegacyDbDiagramQueryKey(options)
});

/**
 * Generate DB ERD
 *
 * Generate and DB entity relationship diagram for the given bind_key
 */
export const dbAdminLegacyDbDiagramPostMutation = (options?: Partial<Options<DbAdminLegacyDbDiagramPostData>>): UseMutationOptions<DbAdminLegacyDbDiagramPostResponse, DefaultError, Options<DbAdminLegacyDbDiagramPostData>> => {
    const mutationOptions: UseMutationOptions<DbAdminLegacyDbDiagramPostResponse, DefaultError, Options<DbAdminLegacyDbDiagramPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await dbAdminLegacyDbDiagramPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const dbAdminLegacyDbDiagram2QueryKey = (options: Options<DbAdminLegacyDbDiagram2Data>) => createQueryKey('dbAdminLegacyDbDiagram2', options);

/**
 * Generate DB ERD
 *
 * Generate and DB entity relationship diagram for the given bind_key
 */
export const dbAdminLegacyDbDiagram2Options = (options: Options<DbAdminLegacyDbDiagram2Data>) => queryOptions<DbAdminLegacyDbDiagram2Response, DefaultError, DbAdminLegacyDbDiagram2Response, ReturnType<typeof dbAdminLegacyDbDiagram2QueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await dbAdminLegacyDbDiagram2({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: dbAdminLegacyDbDiagram2QueryKey(options)
});

/**
 * Generate DB ERD
 *
 * Generate and DB entity relationship diagram for the given bind_key
 */
export const dbAdminLegacyDbDiagramPost2Mutation = (options?: Partial<Options<DbAdminLegacyDbDiagramPost2Data>>): UseMutationOptions<DbAdminLegacyDbDiagramPost2Response, DefaultError, Options<DbAdminLegacyDbDiagramPost2Data>> => {
    const mutationOptions: UseMutationOptions<DbAdminLegacyDbDiagramPost2Response, DefaultError, Options<DbAdminLegacyDbDiagramPost2Data>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await dbAdminLegacyDbDiagramPost2({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const dbAdminLegacyFulfillmentsQueryKey = (options?: Options<DbAdminLegacyFulfillmentsData>) => createQueryKey('dbAdminLegacyFulfillments', options);

export const dbAdminLegacyFulfillmentsOptions = (options?: Options<DbAdminLegacyFulfillmentsData>) => queryOptions<DbAdminLegacyFulfillmentsResponse, DefaultError, DbAdminLegacyFulfillmentsResponse, ReturnType<typeof dbAdminLegacyFulfillmentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await dbAdminLegacyFulfillments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: dbAdminLegacyFulfillmentsQueryKey(options)
});

export const dbAdminLegacyFulfillments2QueryKey = (options: Options<DbAdminLegacyFulfillments2Data>) => createQueryKey('dbAdminLegacyFulfillments2', options);

export const dbAdminLegacyFulfillments2Options = (options: Options<DbAdminLegacyFulfillments2Data>) => queryOptions<DbAdminLegacyFulfillments2Response, DefaultError, DbAdminLegacyFulfillments2Response, ReturnType<typeof dbAdminLegacyFulfillments2QueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await dbAdminLegacyFulfillments2({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: dbAdminLegacyFulfillments2QueryKey(options)
});

export const dbAdminLegacyFulfillments3QueryKey = (options: Options<DbAdminLegacyFulfillments3Data>) => createQueryKey('dbAdminLegacyFulfillments3', options);

export const dbAdminLegacyFulfillments3Options = (options: Options<DbAdminLegacyFulfillments3Data>) => queryOptions<DbAdminLegacyFulfillments3Response, DefaultError, DbAdminLegacyFulfillments3Response, ReturnType<typeof dbAdminLegacyFulfillments3QueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await dbAdminLegacyFulfillments3({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: dbAdminLegacyFulfillments3QueryKey(options)
});

/**
 * Validate Token
 *
 * Token testing
 */
export const dbAdminLegacyTokenValidationMutation = (options?: Partial<Options<DbAdminLegacyTokenValidationData>>): UseMutationOptions<DbAdminLegacyTokenValidationResponse, DefaultError, Options<DbAdminLegacyTokenValidationData>> => {
    const mutationOptions: UseMutationOptions<DbAdminLegacyTokenValidationResponse, DefaultError, Options<DbAdminLegacyTokenValidationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await dbAdminLegacyTokenValidation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const authorizationV1AuthorizeApiTokenQueryKey = (options?: Options<AuthorizationV1AuthorizeApiTokenData>) => createQueryKey('authorizationV1AuthorizeApiToken', options);

export const authorizationV1AuthorizeApiTokenOptions = (options?: Options<AuthorizationV1AuthorizeApiTokenData>) => queryOptions<AuthorizationV1AuthorizeApiTokenResponse, DefaultError, AuthorizationV1AuthorizeApiTokenResponse, ReturnType<typeof authorizationV1AuthorizeApiTokenQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await authorizationV1AuthorizeApiToken({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: authorizationV1AuthorizeApiTokenQueryKey(options)
});

export const authorizationV1AuthorizeApiToken2QueryKey = (options: Options<AuthorizationV1AuthorizeApiToken2Data>) => createQueryKey('authorizationV1AuthorizeApiToken2', options);

export const authorizationV1AuthorizeApiToken2Options = (options: Options<AuthorizationV1AuthorizeApiToken2Data>) => queryOptions<AuthorizationV1AuthorizeApiToken2Response, DefaultError, AuthorizationV1AuthorizeApiToken2Response, ReturnType<typeof authorizationV1AuthorizeApiToken2QueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await authorizationV1AuthorizeApiToken2({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: authorizationV1AuthorizeApiToken2QueryKey(options)
});

export const authorizationV1HeartbeatQueryKey = (options?: Options<AuthorizationV1HeartbeatData>) => createQueryKey('authorizationV1Heartbeat', options);

/**
 * Heartbeat
 *
 * Base validation for the heartbeat endpoint
 */
export const authorizationV1HeartbeatOptions = (options?: Options<AuthorizationV1HeartbeatData>) => queryOptions<AuthorizationV1HeartbeatResponse, DefaultError, AuthorizationV1HeartbeatResponse, ReturnType<typeof authorizationV1HeartbeatQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await authorizationV1Heartbeat({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: authorizationV1HeartbeatQueryKey(options)
});

export const authorizationV1TestStateMismatchQueryKey = (options?: Options<AuthorizationV1TestStateMismatchData>) => createQueryKey('authorizationV1TestStateMismatch', options);

/**
 * Test endpoint to simulate mismatching_state error.
 *
 * This endpoint clears the session and then redirects to the callback
 * with fake OAuth parameters, triggering a state mismatch.
 */
export const authorizationV1TestStateMismatchOptions = (options?: Options<AuthorizationV1TestStateMismatchData>) => queryOptions<AuthorizationV1TestStateMismatchResponse, DefaultError, AuthorizationV1TestStateMismatchResponse, ReturnType<typeof authorizationV1TestStateMismatchQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await authorizationV1TestStateMismatch({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: authorizationV1TestStateMismatchQueryKey(options)
});

export const dbAdminV1DbDiagramQueryKey = (options?: Options<DbAdminV1DbDiagramData>) => createQueryKey('dbAdminV1DbDiagram', options);

/**
 * Generate DB ERD
 *
 * Generate and DB entity relationship diagram for the given bind_key
 */
export const dbAdminV1DbDiagramOptions = (options?: Options<DbAdminV1DbDiagramData>) => queryOptions<DbAdminV1DbDiagramResponse, DefaultError, DbAdminV1DbDiagramResponse, ReturnType<typeof dbAdminV1DbDiagramQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await dbAdminV1DbDiagram({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: dbAdminV1DbDiagramQueryKey(options)
});

/**
 * Generate DB ERD
 *
 * Generate and DB entity relationship diagram for the given bind_key
 */
export const dbAdminV1DbDiagramPostMutation = (options?: Partial<Options<DbAdminV1DbDiagramPostData>>): UseMutationOptions<DbAdminV1DbDiagramPostResponse, DefaultError, Options<DbAdminV1DbDiagramPostData>> => {
    const mutationOptions: UseMutationOptions<DbAdminV1DbDiagramPostResponse, DefaultError, Options<DbAdminV1DbDiagramPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await dbAdminV1DbDiagramPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const dbAdminV1DbDiagram2QueryKey = (options: Options<DbAdminV1DbDiagram2Data>) => createQueryKey('dbAdminV1DbDiagram2', options);

/**
 * Generate DB ERD
 *
 * Generate and DB entity relationship diagram for the given bind_key
 */
export const dbAdminV1DbDiagram2Options = (options: Options<DbAdminV1DbDiagram2Data>) => queryOptions<DbAdminV1DbDiagram2Response, DefaultError, DbAdminV1DbDiagram2Response, ReturnType<typeof dbAdminV1DbDiagram2QueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await dbAdminV1DbDiagram2({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: dbAdminV1DbDiagram2QueryKey(options)
});

/**
 * Generate DB ERD
 *
 * Generate and DB entity relationship diagram for the given bind_key
 */
export const dbAdminV1DbDiagramPost2Mutation = (options?: Partial<Options<DbAdminV1DbDiagramPost2Data>>): UseMutationOptions<DbAdminV1DbDiagramPost2Response, DefaultError, Options<DbAdminV1DbDiagramPost2Data>> => {
    const mutationOptions: UseMutationOptions<DbAdminV1DbDiagramPost2Response, DefaultError, Options<DbAdminV1DbDiagramPost2Data>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await dbAdminV1DbDiagramPost2({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const dbAdminV1FulfillmentsQueryKey = (options?: Options<DbAdminV1FulfillmentsData>) => createQueryKey('dbAdminV1Fulfillments', options);

export const dbAdminV1FulfillmentsOptions = (options?: Options<DbAdminV1FulfillmentsData>) => queryOptions<DbAdminV1FulfillmentsResponse, DefaultError, DbAdminV1FulfillmentsResponse, ReturnType<typeof dbAdminV1FulfillmentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await dbAdminV1Fulfillments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: dbAdminV1FulfillmentsQueryKey(options)
});

export const dbAdminV1Fulfillments2QueryKey = (options: Options<DbAdminV1Fulfillments2Data>) => createQueryKey('dbAdminV1Fulfillments2', options);

export const dbAdminV1Fulfillments2Options = (options: Options<DbAdminV1Fulfillments2Data>) => queryOptions<DbAdminV1Fulfillments2Response, DefaultError, DbAdminV1Fulfillments2Response, ReturnType<typeof dbAdminV1Fulfillments2QueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await dbAdminV1Fulfillments2({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: dbAdminV1Fulfillments2QueryKey(options)
});

export const dbAdminV1Fulfillments3QueryKey = (options: Options<DbAdminV1Fulfillments3Data>) => createQueryKey('dbAdminV1Fulfillments3', options);

export const dbAdminV1Fulfillments3Options = (options: Options<DbAdminV1Fulfillments3Data>) => queryOptions<DbAdminV1Fulfillments3Response, DefaultError, DbAdminV1Fulfillments3Response, ReturnType<typeof dbAdminV1Fulfillments3QueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await dbAdminV1Fulfillments3({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: dbAdminV1Fulfillments3QueryKey(options)
});

/**
 * Validate Token
 *
 * Token testing
 */
export const dbAdminV1TokenValidationMutation = (options?: Partial<Options<DbAdminV1TokenValidationData>>): UseMutationOptions<DbAdminV1TokenValidationResponse, DefaultError, Options<DbAdminV1TokenValidationData>> => {
    const mutationOptions: UseMutationOptions<DbAdminV1TokenValidationResponse, DefaultError, Options<DbAdminV1TokenValidationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await dbAdminV1TokenValidation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const esignatureV1EventCallbackMutation = (options?: Partial<Options<EsignatureV1EventCallbackData>>): UseMutationOptions<EsignatureV1EventCallbackResponse, DefaultError, Options<EsignatureV1EventCallbackData>> => {
    const mutationOptions: UseMutationOptions<EsignatureV1EventCallbackResponse, DefaultError, Options<EsignatureV1EventCallbackData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await esignatureV1EventCallback({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const esignatureV1OnScreenSignQueryKey = (options: Options<EsignatureV1OnScreenSignData>) => createQueryKey('esignatureV1OnScreenSign', options);

export const esignatureV1OnScreenSignOptions = (options: Options<EsignatureV1OnScreenSignData>) => queryOptions<EsignatureV1OnScreenSignResponse, DefaultError, EsignatureV1OnScreenSignResponse, ReturnType<typeof esignatureV1OnScreenSignQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await esignatureV1OnScreenSign({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: esignatureV1OnScreenSignQueryKey(options)
});

export const esignatureV1RequestOrderEsignatureMutation = (options?: Partial<Options<EsignatureV1RequestOrderEsignatureData>>): UseMutationOptions<EsignatureV1RequestOrderEsignatureResponse, DefaultError, Options<EsignatureV1RequestOrderEsignatureData>> => {
    const mutationOptions: UseMutationOptions<EsignatureV1RequestOrderEsignatureResponse, DefaultError, Options<EsignatureV1RequestOrderEsignatureData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await esignatureV1RequestOrderEsignature({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const esignatureV1RefreshOrderEsignatureMutation = (options?: Partial<Options<EsignatureV1RefreshOrderEsignatureData>>): UseMutationOptions<EsignatureV1RefreshOrderEsignatureResponse, DefaultError, Options<EsignatureV1RefreshOrderEsignatureData>> => {
    const mutationOptions: UseMutationOptions<EsignatureV1RefreshOrderEsignatureResponse, DefaultError, Options<EsignatureV1RefreshOrderEsignatureData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await esignatureV1RefreshOrderEsignature({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const insuranceV1CategoriesV1DetailsQueryKey = (options: Options<InsuranceV1CategoriesV1DetailsData>) => createQueryKey('insuranceV1CategoriesV1Details', options);

/**
 * Details
 *
 * Retrieve the extended Code Category record by uuid
 */
export const insuranceV1CategoriesV1DetailsOptions = (options: Options<InsuranceV1CategoriesV1DetailsData>) => queryOptions<InsuranceV1CategoriesV1DetailsResponse, DefaultError, InsuranceV1CategoriesV1DetailsResponse, ReturnType<typeof insuranceV1CategoriesV1DetailsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await insuranceV1CategoriesV1Details({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: insuranceV1CategoriesV1DetailsQueryKey(options)
});

export const insuranceV1CategoriesV1HeartbeatQueryKey = (options?: Options<InsuranceV1CategoriesV1HeartbeatData>) => createQueryKey('insuranceV1CategoriesV1Heartbeat', options);

/**
 * Heartbeat
 *
 * Base validation for the heartbeat endpoint
 */
export const insuranceV1CategoriesV1HeartbeatOptions = (options?: Options<InsuranceV1CategoriesV1HeartbeatData>) => queryOptions<InsuranceV1CategoriesV1HeartbeatResponse, DefaultError, InsuranceV1CategoriesV1HeartbeatResponse, ReturnType<typeof insuranceV1CategoriesV1HeartbeatQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await insuranceV1CategoriesV1Heartbeat({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: insuranceV1CategoriesV1HeartbeatQueryKey(options)
});

export const insuranceV1CategoriesV1SearchQueryKey = (options?: Options<InsuranceV1CategoriesV1SearchData>) => createQueryKey('insuranceV1CategoriesV1Search', options);

/**
 * Search
 *
 * Retrieve list of records by query term and/or template type (Medicaid/Medicare)
 */
export const insuranceV1CategoriesV1SearchOptions = (options?: Options<InsuranceV1CategoriesV1SearchData>) => queryOptions<InsuranceV1CategoriesV1SearchResponse, DefaultError, InsuranceV1CategoriesV1SearchResponse, ReturnType<typeof insuranceV1CategoriesV1SearchQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await insuranceV1CategoriesV1Search({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: insuranceV1CategoriesV1SearchQueryKey(options)
});

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>>(queryKey: QueryKey<Options>, page: K) => {
    const params = { ...queryKey[0] };
    if (page.body) {
        params.body = {
            ...queryKey[0].body as any,
            ...page.body as any
        };
    }
    if (page.headers) {
        params.headers = {
            ...queryKey[0].headers,
            ...page.headers
        };
    }
    if (page.path) {
        params.path = {
            ...queryKey[0].path as any,
            ...page.path as any
        };
    }
    if (page.query) {
        params.query = {
            ...queryKey[0].query as any,
            ...page.query as any
        };
    }
    return params as unknown as typeof page;
};

export const insuranceV1CategoriesV1SearchInfiniteQueryKey = (options?: Options<InsuranceV1CategoriesV1SearchData>): QueryKey<Options<InsuranceV1CategoriesV1SearchData>> => createQueryKey('insuranceV1CategoriesV1Search', options, true);

/**
 * Search
 *
 * Retrieve list of records by query term and/or template type (Medicaid/Medicare)
 */
export const insuranceV1CategoriesV1SearchInfiniteOptions = (options?: Options<InsuranceV1CategoriesV1SearchData>) => infiniteQueryOptions<InsuranceV1CategoriesV1SearchResponse, DefaultError, InfiniteData<InsuranceV1CategoriesV1SearchResponse>, QueryKey<Options<InsuranceV1CategoriesV1SearchData>>, number | Pick<QueryKey<Options<InsuranceV1CategoriesV1SearchData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<InsuranceV1CategoriesV1SearchData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await insuranceV1CategoriesV1Search({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: insuranceV1CategoriesV1SearchInfiniteQueryKey(options)
});

export const insuranceV1CategoriesV1Search2QueryKey = (options: Options<InsuranceV1CategoriesV1Search2Data>) => createQueryKey('insuranceV1CategoriesV1Search2', options);

/**
 * Search
 *
 * Retrieve list of records by query term and/or template type (Medicaid/Medicare)
 */
export const insuranceV1CategoriesV1Search2Options = (options: Options<InsuranceV1CategoriesV1Search2Data>) => queryOptions<InsuranceV1CategoriesV1Search2Response, DefaultError, InsuranceV1CategoriesV1Search2Response, ReturnType<typeof insuranceV1CategoriesV1Search2QueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await insuranceV1CategoriesV1Search2({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: insuranceV1CategoriesV1Search2QueryKey(options)
});

export const insuranceV1CategoriesV1Search2InfiniteQueryKey = (options: Options<InsuranceV1CategoriesV1Search2Data>): QueryKey<Options<InsuranceV1CategoriesV1Search2Data>> => createQueryKey('insuranceV1CategoriesV1Search2', options, true);

/**
 * Search
 *
 * Retrieve list of records by query term and/or template type (Medicaid/Medicare)
 */
export const insuranceV1CategoriesV1Search2InfiniteOptions = (options: Options<InsuranceV1CategoriesV1Search2Data>) => infiniteQueryOptions<InsuranceV1CategoriesV1Search2Response, DefaultError, InfiniteData<InsuranceV1CategoriesV1Search2Response>, QueryKey<Options<InsuranceV1CategoriesV1Search2Data>>, number | Pick<QueryKey<Options<InsuranceV1CategoriesV1Search2Data>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<InsuranceV1CategoriesV1Search2Data>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await insuranceV1CategoriesV1Search2({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: insuranceV1CategoriesV1Search2InfiniteQueryKey(options)
});

export const insuranceV1DetailsQueryKey = (options: Options<InsuranceV1DetailsData>) => createQueryKey('insuranceV1Details', options);

/**
 * Details
 *
 * Retrieve the extended Insurance record by uuid
 */
export const insuranceV1DetailsOptions = (options: Options<InsuranceV1DetailsData>) => queryOptions<InsuranceV1DetailsResponse, DefaultError, InsuranceV1DetailsResponse, ReturnType<typeof insuranceV1DetailsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await insuranceV1Details({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: insuranceV1DetailsQueryKey(options)
});

export const insuranceV1HeartbeatQueryKey = (options?: Options<InsuranceV1HeartbeatData>) => createQueryKey('insuranceV1Heartbeat', options);

/**
 * Heartbeat
 *
 * Base validation for the heartbeat endpoint
 */
export const insuranceV1HeartbeatOptions = (options?: Options<InsuranceV1HeartbeatData>) => queryOptions<InsuranceV1HeartbeatResponse, DefaultError, InsuranceV1HeartbeatResponse, ReturnType<typeof insuranceV1HeartbeatQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await insuranceV1Heartbeat({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: insuranceV1HeartbeatQueryKey(options)
});

export const insuranceV1SearchQueryKey = (options?: Options<InsuranceV1SearchData>) => createQueryKey('insuranceV1Search', options);

/**
 * Search
 *
 * Retrieve list of records by query term and/or template type (Medicaid/Medicare)
 */
export const insuranceV1SearchOptions = (options?: Options<InsuranceV1SearchData>) => queryOptions<InsuranceV1SearchResponse, DefaultError, InsuranceV1SearchResponse, ReturnType<typeof insuranceV1SearchQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await insuranceV1Search({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: insuranceV1SearchQueryKey(options)
});

export const insuranceV1SearchInfiniteQueryKey = (options?: Options<InsuranceV1SearchData>): QueryKey<Options<InsuranceV1SearchData>> => createQueryKey('insuranceV1Search', options, true);

/**
 * Search
 *
 * Retrieve list of records by query term and/or template type (Medicaid/Medicare)
 */
export const insuranceV1SearchInfiniteOptions = (options?: Options<InsuranceV1SearchData>) => infiniteQueryOptions<InsuranceV1SearchResponse, DefaultError, InfiniteData<InsuranceV1SearchResponse>, QueryKey<Options<InsuranceV1SearchData>>, number | Pick<QueryKey<Options<InsuranceV1SearchData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<InsuranceV1SearchData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await insuranceV1Search({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: insuranceV1SearchInfiniteQueryKey(options)
});

export const insuranceV1Search2QueryKey = (options: Options<InsuranceV1Search2Data>) => createQueryKey('insuranceV1Search2', options);

/**
 * Search
 *
 * Retrieve list of records by query term and/or template type (Medicaid/Medicare)
 */
export const insuranceV1Search2Options = (options: Options<InsuranceV1Search2Data>) => queryOptions<InsuranceV1Search2Response, DefaultError, InsuranceV1Search2Response, ReturnType<typeof insuranceV1Search2QueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await insuranceV1Search2({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: insuranceV1Search2QueryKey(options)
});

export const insuranceV1Search2InfiniteQueryKey = (options: Options<InsuranceV1Search2Data>): QueryKey<Options<InsuranceV1Search2Data>> => createQueryKey('insuranceV1Search2', options, true);

/**
 * Search
 *
 * Retrieve list of records by query term and/or template type (Medicaid/Medicare)
 */
export const insuranceV1Search2InfiniteOptions = (options: Options<InsuranceV1Search2Data>) => infiniteQueryOptions<InsuranceV1Search2Response, DefaultError, InfiniteData<InsuranceV1Search2Response>, QueryKey<Options<InsuranceV1Search2Data>>, number | Pick<QueryKey<Options<InsuranceV1Search2Data>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<InsuranceV1Search2Data>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await insuranceV1Search2({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: insuranceV1Search2InfiniteQueryKey(options)
});

/**
 * Enqueue an ad hoc Postgres export to S3. Returns 202 with the Celery task ID.
 */
export const managementV1DbV1DbExportMutation = (options?: Partial<Options<ManagementV1DbV1DbExportData>>): UseMutationOptions<ManagementV1DbV1DbExportResponse, DefaultError, Options<ManagementV1DbV1DbExportData>> => {
    const mutationOptions: UseMutationOptions<ManagementV1DbV1DbExportResponse, DefaultError, Options<ManagementV1DbV1DbExportData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await managementV1DbV1DbExport({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Enqueue a partial Postgres restore from S3. Returns 202 with the Celery task ID.
 *
 * Monitor task progress in Flower or Sentry. If the task fails with a
 * ``RestoreError``, the most likely cause locally is a failed ``flask db upgrade``
 * step at the end of the restore. Connect to the api service and run
 * ``flask db upgrade`` manually to apply any pending migrations.
 */
export const managementV1DbV1DbImportMutation = (options?: Partial<Options<ManagementV1DbV1DbImportData>>): UseMutationOptions<ManagementV1DbV1DbImportResponse, DefaultError, Options<ManagementV1DbV1DbImportData>> => {
    const mutationOptions: UseMutationOptions<ManagementV1DbV1DbImportResponse, DefaultError, Options<ManagementV1DbV1DbImportData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await managementV1DbV1DbImport({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const managementV1DbV1DbExportManifestQueryKey = (options?: Options<ManagementV1DbV1DbExportManifestData>) => createQueryKey('managementV1DbV1DbExportManifest', options);

/**
 * Return the S3 export manifest. 404 if no exports have run yet.
 */
export const managementV1DbV1DbExportManifestOptions = (options?: Options<ManagementV1DbV1DbExportManifestData>) => queryOptions<ManagementV1DbV1DbExportManifestResponse, DefaultError, ManagementV1DbV1DbExportManifestResponse, ReturnType<typeof managementV1DbV1DbExportManifestQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await managementV1DbV1DbExportManifest({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: managementV1DbV1DbExportManifestQueryKey(options)
});

/**
 * Prune exports older than before_date. Latest full per (db_type, environment) is always kept.
 */
export const managementV1DbV1DbExportPruneMutation = (options?: Partial<Options<ManagementV1DbV1DbExportPruneData>>): UseMutationOptions<ManagementV1DbV1DbExportPruneResponse, DefaultError, Options<ManagementV1DbV1DbExportPruneData>> => {
    const mutationOptions: UseMutationOptions<ManagementV1DbV1DbExportPruneResponse, DefaultError, Options<ManagementV1DbV1DbExportPruneData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await managementV1DbV1DbExportPrune({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create a new per-plan fee schedule row.
 *
 * Carrier and coverage-zone are derived server-side from the plan's
 * carrier-coverage-zone (CCZ).  Returns 201 + the created FeeSchedule.
 */
export const managementV1FeeScheduleV1CreateFeeScheduleRouteMutation = (options?: Partial<Options<ManagementV1FeeScheduleV1CreateFeeScheduleRouteData>>): UseMutationOptions<ManagementV1FeeScheduleV1CreateFeeScheduleRouteResponse, DefaultError, Options<ManagementV1FeeScheduleV1CreateFeeScheduleRouteData>> => {
    const mutationOptions: UseMutationOptions<ManagementV1FeeScheduleV1CreateFeeScheduleRouteResponse, DefaultError, Options<ManagementV1FeeScheduleV1CreateFeeScheduleRouteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await managementV1FeeScheduleV1CreateFeeScheduleRoute({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const managementV1FeeScheduleV1UpdateFeeScheduleMutation = (options?: Partial<Options<ManagementV1FeeScheduleV1UpdateFeeScheduleData>>): UseMutationOptions<ManagementV1FeeScheduleV1UpdateFeeScheduleResponse, DefaultError, Options<ManagementV1FeeScheduleV1UpdateFeeScheduleData>> => {
    const mutationOptions: UseMutationOptions<ManagementV1FeeScheduleV1UpdateFeeScheduleResponse, DefaultError, Options<ManagementV1FeeScheduleV1UpdateFeeScheduleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await managementV1FeeScheduleV1UpdateFeeSchedule({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const npiV1SearchProvidersQueryKey = (options: Options<NpiV1SearchProvidersData>) => createQueryKey('npiV1SearchProviders', options);

export const npiV1SearchProvidersOptions = (options: Options<NpiV1SearchProvidersData>) => queryOptions<NpiV1SearchProvidersResponse, DefaultError, NpiV1SearchProvidersResponse, ReturnType<typeof npiV1SearchProvidersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await npiV1SearchProviders({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: npiV1SearchProvidersQueryKey(options)
});

export const npiV1SearchProvidersInfiniteQueryKey = (options: Options<NpiV1SearchProvidersData>): QueryKey<Options<NpiV1SearchProvidersData>> => createQueryKey('npiV1SearchProviders', options, true);

export const npiV1SearchProvidersInfiniteOptions = (options: Options<NpiV1SearchProvidersData>) => infiniteQueryOptions<NpiV1SearchProvidersResponse, DefaultError, InfiniteData<NpiV1SearchProvidersResponse>, QueryKey<Options<NpiV1SearchProvidersData>>, number | Pick<QueryKey<Options<NpiV1SearchProvidersData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<NpiV1SearchProvidersData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await npiV1SearchProviders({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: npiV1SearchProvidersInfiniteQueryKey(options)
});

export const npiV1GetProviderQueryKey = (options: Options<NpiV1GetProviderData>) => createQueryKey('npiV1GetProvider', options);

export const npiV1GetProviderOptions = (options: Options<NpiV1GetProviderData>) => queryOptions<NpiV1GetProviderResponse, DefaultError, NpiV1GetProviderResponse, ReturnType<typeof npiV1GetProviderQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await npiV1GetProvider({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: npiV1GetProviderQueryKey(options)
});

/**
 * Verify the OTP, mint a single-use handoff ticket cookie, and return the public_id.
 */
export const orderLookupV1CheckMutation = (options?: Partial<Options<OrderLookupV1CheckData>>): UseMutationOptions<OrderLookupV1CheckResponse, DefaultError, Options<OrderLookupV1CheckData>> => {
    const mutationOptions: UseMutationOptions<OrderLookupV1CheckResponse, DefaultError, Options<OrderLookupV1CheckData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orderLookupV1Check({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Resolve an order from name + DOB and send an OTP to the on-file phone.
 */
export const orderLookupV1StartMutation = (options?: Partial<Options<OrderLookupV1StartData>>): UseMutationOptions<OrderLookupV1StartResponse, DefaultError, Options<OrderLookupV1StartData>> => {
    const mutationOptions: UseMutationOptions<OrderLookupV1StartResponse, DefaultError, Options<OrderLookupV1StartData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orderLookupV1Start({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Enqueue the ePACES auth pipeline for selected fulfillments.
 *
 * Fulfillment ids must belong to the given order or that item fails.
 * Type '6' is queued for ePACES. Unset PA is skipped until mappy stamps auth need.
 * Type '0' after mappy is marked Not Required without enqueueing.
 */
export const ordersV1AuthorizeMutation = (options?: Partial<Options<OrdersV1AuthorizeData>>): UseMutationOptions<OrdersV1AuthorizeResponse, DefaultError, Options<OrdersV1AuthorizeData>> => {
    const mutationOptions: UseMutationOptions<OrdersV1AuthorizeResponse, DefaultError, Options<OrdersV1AuthorizeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersV1Authorize({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * [DEPRECATED]
 */
export const ordersV1BillingMutation = (options?: Partial<Options<OrdersV1BillingData>>): UseMutationOptions<OrdersV1BillingResponse, DefaultError, Options<OrdersV1BillingData>> => {
    const mutationOptions: UseMutationOptions<OrdersV1BillingResponse, DefaultError, Options<OrdersV1BillingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersV1Billing({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const ordersV1GetChangeReasonsQueryKey = (options?: Options<OrdersV1GetChangeReasonsData>) => createQueryKey('ordersV1GetChangeReasons', options);

/**
 * Return the list of valid order change request reasons.
 *
 * Migrated from orders GraphQL query: getChangeReasons
 */
export const ordersV1GetChangeReasonsOptions = (options?: Options<OrdersV1GetChangeReasonsData>) => queryOptions<OrdersV1GetChangeReasonsResponse, DefaultError, OrdersV1GetChangeReasonsResponse, ReturnType<typeof ordersV1GetChangeReasonsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await ordersV1GetChangeReasons({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: ordersV1GetChangeReasonsQueryKey(options)
});

export const ordersV1CreateOrderEndpointMutation = (options?: Partial<Options<OrdersV1CreateOrderEndpointData>>): UseMutationOptions<OrdersV1CreateOrderEndpointResponse, DefaultError, Options<OrdersV1CreateOrderEndpointData>> => {
    const mutationOptions: UseMutationOptions<OrdersV1CreateOrderEndpointResponse, DefaultError, Options<OrdersV1CreateOrderEndpointData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersV1CreateOrderEndpoint({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const ordersV1MoveTempFilesToOrderMutation = (options?: Partial<Options<OrdersV1MoveTempFilesToOrderData>>): UseMutationOptions<OrdersV1MoveTempFilesToOrderResponse, DefaultError, Options<OrdersV1MoveTempFilesToOrderData>> => {
    const mutationOptions: UseMutationOptions<OrdersV1MoveTempFilesToOrderResponse, DefaultError, Options<OrdersV1MoveTempFilesToOrderData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersV1MoveTempFilesToOrder({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const ordersV1UploadOrderTmpFileMutation = (options?: Partial<Options<OrdersV1UploadOrderTmpFileData>>): UseMutationOptions<OrdersV1UploadOrderTmpFileResponse, DefaultError, Options<OrdersV1UploadOrderTmpFileData>> => {
    const mutationOptions: UseMutationOptions<OrdersV1UploadOrderTmpFileResponse, DefaultError, Options<OrdersV1UploadOrderTmpFileData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersV1UploadOrderTmpFile({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update fulfillment authorization status and related fields.
 */
export const ordersV1UpdateFulfillmentMutation = (options?: Partial<Options<OrdersV1UpdateFulfillmentData>>): UseMutationOptions<OrdersV1UpdateFulfillmentResponse, DefaultError, Options<OrdersV1UpdateFulfillmentData>> => {
    const mutationOptions: UseMutationOptions<OrdersV1UpdateFulfillmentResponse, DefaultError, Options<OrdersV1UpdateFulfillmentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersV1UpdateFulfillment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update the auth assignee on a fulfillment.
 */
export const ordersV1UpdateFulfillmentAssigneeMutation = (options?: Partial<Options<OrdersV1UpdateFulfillmentAssigneeData>>): UseMutationOptions<OrdersV1UpdateFulfillmentAssigneeResponse, DefaultError, Options<OrdersV1UpdateFulfillmentAssigneeData>> => {
    const mutationOptions: UseMutationOptions<OrdersV1UpdateFulfillmentAssigneeResponse, DefaultError, Options<OrdersV1UpdateFulfillmentAssigneeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersV1UpdateFulfillmentAssignee({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const ordersV1GetFulfillmentsQueryKey = (options: Options<OrdersV1GetFulfillmentsData>) => createQueryKey('ordersV1GetFulfillments', options);

export const ordersV1GetFulfillmentsOptions = (options: Options<OrdersV1GetFulfillmentsData>) => queryOptions<OrdersV1GetFulfillmentsResponse, DefaultError, OrdersV1GetFulfillmentsResponse, ReturnType<typeof ordersV1GetFulfillmentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await ordersV1GetFulfillments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: ordersV1GetFulfillmentsQueryKey(options)
});

export const ordersV1GetIneligibilityReasonsQueryKey = (options?: Options<OrdersV1GetIneligibilityReasonsData>) => createQueryKey('ordersV1GetIneligibilityReasons', options);

/**
 * Return the list of valid insurance ineligibility reasons.
 *
 * Migrated from orders GraphQL query: getIneligibilityReasons
 */
export const ordersV1GetIneligibilityReasonsOptions = (options?: Options<OrdersV1GetIneligibilityReasonsData>) => queryOptions<OrdersV1GetIneligibilityReasonsResponse, DefaultError, OrdersV1GetIneligibilityReasonsResponse, ReturnType<typeof ordersV1GetIneligibilityReasonsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await ordersV1GetIneligibilityReasons({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: ordersV1GetIneligibilityReasonsQueryKey(options)
});

export const ordersV1GetOnHoldReasonsQueryKey = (options?: Options<OrdersV1GetOnHoldReasonsData>) => createQueryKey('ordersV1GetOnHoldReasons', options);

/**
 * Return the list of valid on-hold reasons for supplier hold actions.
 *
 * Migrated from orders GraphQL query: getOnHoldReasons
 */
export const ordersV1GetOnHoldReasonsOptions = (options?: Options<OrdersV1GetOnHoldReasonsData>) => queryOptions<OrdersV1GetOnHoldReasonsResponse, DefaultError, OrdersV1GetOnHoldReasonsResponse, ReturnType<typeof ordersV1GetOnHoldReasonsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await ordersV1GetOnHoldReasons({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: ordersV1GetOnHoldReasonsQueryKey(options)
});

export const ordersV1GetRejectionReasonsQueryKey = (options?: Options<OrdersV1GetRejectionReasonsData>) => createQueryKey('ordersV1GetRejectionReasons', options);

/**
 * Return the list of valid order rejection reasons, filtered by caller role.
 *
 * Migrated from orders GraphQL query: getRejectionReasons
 */
export const ordersV1GetRejectionReasonsOptions = (options?: Options<OrdersV1GetRejectionReasonsData>) => queryOptions<OrdersV1GetRejectionReasonsResponse, DefaultError, OrdersV1GetRejectionReasonsResponse, ReturnType<typeof ordersV1GetRejectionReasonsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await ordersV1GetRejectionReasons({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: ordersV1GetRejectionReasonsQueryKey(options)
});

/**
 * Backfill prescription_metadata from legacy prescription_expiration field.
 *
 * Targets orders where ``prescription_expiration`` is set AND
 * ``prescription_metadata`` is None. Idempotent — skips orders that already
 * have ``prescription_metadata``.
 *
 * Pass ``{"dry_run": true}`` to preview matching order IDs without writing.
 * Otherwise enqueues a Celery task and returns ``{"task_id": "..."}`` with 202.
 */
export const ordersV1BackfillRxDateMutation = (options?: Partial<Options<OrdersV1BackfillRxDateData>>): UseMutationOptions<OrdersV1BackfillRxDateResponse, DefaultError, Options<OrdersV1BackfillRxDateData>> => {
    const mutationOptions: UseMutationOptions<OrdersV1BackfillRxDateResponse, DefaultError, Options<OrdersV1BackfillRxDateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersV1BackfillRxDate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const ordersV1OrderListQueryKey = (options?: Options<OrdersV1OrderListData>) => createQueryKey('ordersV1OrderList', options);

export const ordersV1OrderListOptions = (options?: Options<OrdersV1OrderListData>) => queryOptions<OrdersV1OrderListResponse, DefaultError, OrdersV1OrderListResponse, ReturnType<typeof ordersV1OrderListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await ordersV1OrderList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: ordersV1OrderListQueryKey(options)
});

export const ordersV1OrderListInfiniteQueryKey = (options?: Options<OrdersV1OrderListData>): QueryKey<Options<OrdersV1OrderListData>> => createQueryKey('ordersV1OrderList', options, true);

export const ordersV1OrderListInfiniteOptions = (options?: Options<OrdersV1OrderListData>) => infiniteQueryOptions<OrdersV1OrderListResponse, DefaultError, InfiniteData<OrdersV1OrderListResponse>, QueryKey<Options<OrdersV1OrderListData>>, number | Pick<QueryKey<Options<OrdersV1OrderListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<OrdersV1OrderListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await ordersV1OrderList({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: ordersV1OrderListInfiniteQueryKey(options)
});

export const ordersV1SearchPatientsWithOrdersQueryKey = (options?: Options<OrdersV1SearchPatientsWithOrdersData>) => createQueryKey('ordersV1SearchPatientsWithOrders', options);

/**
 * Search orders by patient name or order ID, grouped by patient.
 *
 * Query parameter:
 * query (str) — patient first/last name substring, or a numeric order ID.
 *
 * Migrated from orders GraphQL query: searchPatientsWithOrders
 */
export const ordersV1SearchPatientsWithOrdersOptions = (options?: Options<OrdersV1SearchPatientsWithOrdersData>) => queryOptions<OrdersV1SearchPatientsWithOrdersResponse, DefaultError, OrdersV1SearchPatientsWithOrdersResponse, ReturnType<typeof ordersV1SearchPatientsWithOrdersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await ordersV1SearchPatientsWithOrders({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: ordersV1SearchPatientsWithOrdersQueryKey(options)
});

export const ordersV1GetTelehealthErrorReasonsQueryKey = (options?: Options<OrdersV1GetTelehealthErrorReasonsData>) => createQueryKey('ordersV1GetTelehealthErrorReasons', options);

/**
 * Return the list of valid telehealth error reasons for rescheduling actions.
 *
 * Migrated from orders GraphQL query: getTelehealthErrorReasons
 */
export const ordersV1GetTelehealthErrorReasonsOptions = (options?: Options<OrdersV1GetTelehealthErrorReasonsData>) => queryOptions<OrdersV1GetTelehealthErrorReasonsResponse, DefaultError, OrdersV1GetTelehealthErrorReasonsResponse, ReturnType<typeof ordersV1GetTelehealthErrorReasonsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await ordersV1GetTelehealthErrorReasons({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: ordersV1GetTelehealthErrorReasonsQueryKey(options)
});

export const ordersV1OrderDetailsQueryKey = (options: Options<OrdersV1OrderDetailsData>) => createQueryKey('ordersV1OrderDetails', options);

export const ordersV1OrderDetailsOptions = (options: Options<OrdersV1OrderDetailsData>) => queryOptions<OrdersV1OrderDetailsResponse, DefaultError, OrdersV1OrderDetailsResponse, ReturnType<typeof ordersV1OrderDetailsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await ordersV1OrderDetails({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: ordersV1OrderDetailsQueryKey(options)
});

/**
 * Accept a pending order.
 *
 * Migrated from orders GraphQL mutation: acceptOrder
 */
export const ordersV1AcceptOrderMutation = (options?: Partial<Options<OrdersV1AcceptOrderData>>): UseMutationOptions<OrdersV1AcceptOrderResponse, DefaultError, Options<OrdersV1AcceptOrderData>> => {
    const mutationOptions: UseMutationOptions<OrdersV1AcceptOrderResponse, DefaultError, Options<OrdersV1AcceptOrderData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersV1AcceptOrder({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const ordersV1UpdateOrderAssigneeMutation = (options?: Partial<Options<OrdersV1UpdateOrderAssigneeData>>): UseMutationOptions<OrdersV1UpdateOrderAssigneeResponse, DefaultError, Options<OrdersV1UpdateOrderAssigneeData>> => {
    const mutationOptions: UseMutationOptions<OrdersV1UpdateOrderAssigneeResponse, DefaultError, Options<OrdersV1UpdateOrderAssigneeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersV1UpdateOrderAssignee({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const ordersV1AuthRecoveryQueryKey = (options: Options<OrdersV1AuthRecoveryData>) => createQueryKey('ordersV1AuthRecovery', options);

/**
 * Recover epaces authorization info
 *
 * - This will retireve auth info for a given order targeting a specific date authorization was run
 * - This is meant to be used when auth is run manually after updating the order
 * - NOTE: fulfillment authorization_date_embargo and authorization_date_start must  be set, otherwise no fulfillments will be found
 * - The target date will supercede these values
 */
export const ordersV1AuthRecoveryOptions = (options: Options<OrdersV1AuthRecoveryData>) => queryOptions<OrdersV1AuthRecoveryResponse, DefaultError, OrdersV1AuthRecoveryResponse, ReturnType<typeof ordersV1AuthRecoveryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await ordersV1AuthRecovery({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: ordersV1AuthRecoveryQueryKey(options)
});

export const ordersV1ReviewAuthSubmissionQueryKey = (options: Options<OrdersV1ReviewAuthSubmissionData>) => createQueryKey('ordersV1ReviewAuthSubmission', options);

export const ordersV1ReviewAuthSubmissionOptions = (options: Options<OrdersV1ReviewAuthSubmissionData>) => queryOptions<OrdersV1ReviewAuthSubmissionResponse, DefaultError, OrdersV1ReviewAuthSubmissionResponse, ReturnType<typeof ordersV1ReviewAuthSubmissionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await ordersV1ReviewAuthSubmission({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: ordersV1ReviewAuthSubmissionQueryKey(options)
});

export const ordersV1GetCarrierCoverageZoneProductsQueryKey = (options: Options<OrdersV1GetCarrierCoverageZoneProductsData>) => createQueryKey('ordersV1GetCarrierCoverageZoneProducts', options);

/**
 * Get all CarrierCoverageZoneProducts for the order's items
 */
export const ordersV1GetCarrierCoverageZoneProductsOptions = (options: Options<OrdersV1GetCarrierCoverageZoneProductsData>) => queryOptions<OrdersV1GetCarrierCoverageZoneProductsResponse, DefaultError, OrdersV1GetCarrierCoverageZoneProductsResponse, ReturnType<typeof ordersV1GetCarrierCoverageZoneProductsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await ordersV1GetCarrierCoverageZoneProducts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: ordersV1GetCarrierCoverageZoneProductsQueryKey(options)
});

export const ordersV1UpdateOrderClinicalDocsMutation = (options?: Partial<Options<OrdersV1UpdateOrderClinicalDocsData>>): UseMutationOptions<OrdersV1UpdateOrderClinicalDocsResponse, DefaultError, Options<OrdersV1UpdateOrderClinicalDocsData>> => {
    const mutationOptions: UseMutationOptions<OrdersV1UpdateOrderClinicalDocsResponse, DefaultError, Options<OrdersV1UpdateOrderClinicalDocsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersV1UpdateOrderClinicalDocs({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const ordersV1UpdateOrderContactMutation = (options?: Partial<Options<OrdersV1UpdateOrderContactData>>): UseMutationOptions<OrdersV1UpdateOrderContactResponse, DefaultError, Options<OrdersV1UpdateOrderContactData>> => {
    const mutationOptions: UseMutationOptions<OrdersV1UpdateOrderContactResponse, DefaultError, Options<OrdersV1UpdateOrderContactData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersV1UpdateOrderContact({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const ordersV1GetOrderFilesQueryKey = (options: Options<OrdersV1GetOrderFilesData>) => createQueryKey('ordersV1GetOrderFiles', options);

export const ordersV1GetOrderFilesOptions = (options: Options<OrdersV1GetOrderFilesData>) => queryOptions<OrdersV1GetOrderFilesResponse, DefaultError, OrdersV1GetOrderFilesResponse, ReturnType<typeof ordersV1GetOrderFilesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await ordersV1GetOrderFiles({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: ordersV1GetOrderFilesQueryKey(options)
});

export const ordersV1UploadOrderFileMutation = (options?: Partial<Options<OrdersV1UploadOrderFileData>>): UseMutationOptions<OrdersV1UploadOrderFileResponse, DefaultError, Options<OrdersV1UploadOrderFileData>> => {
    const mutationOptions: UseMutationOptions<OrdersV1UploadOrderFileResponse, DefaultError, Options<OrdersV1UploadOrderFileData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersV1UploadOrderFile({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const ordersV1DeleteOrderFileMutation = (options?: Partial<Options<OrdersV1DeleteOrderFileData>>): UseMutationOptions<OrdersV1DeleteOrderFileResponse, DefaultError, Options<OrdersV1DeleteOrderFileData>> => {
    const mutationOptions: UseMutationOptions<OrdersV1DeleteOrderFileResponse, DefaultError, Options<OrdersV1DeleteOrderFileData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersV1DeleteOrderFile({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const ordersV1GetOrderFileQueryKey = (options: Options<OrdersV1GetOrderFileData>) => createQueryKey('ordersV1GetOrderFile', options);

export const ordersV1GetOrderFileOptions = (options: Options<OrdersV1GetOrderFileData>) => queryOptions<OrdersV1GetOrderFileResponse, DefaultError, OrdersV1GetOrderFileResponse, ReturnType<typeof ordersV1GetOrderFileQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await ordersV1GetOrderFile({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: ordersV1GetOrderFileQueryKey(options)
});

export const ordersV1DuplicateOrderEndpointQueryKey = (options: Options<OrdersV1DuplicateOrderEndpointData>) => createQueryKey('ordersV1DuplicateOrderEndpoint', options);

export const ordersV1DuplicateOrderEndpointOptions = (options: Options<OrdersV1DuplicateOrderEndpointData>) => queryOptions<OrdersV1DuplicateOrderEndpointResponse, DefaultError, OrdersV1DuplicateOrderEndpointResponse, ReturnType<typeof ordersV1DuplicateOrderEndpointQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await ordersV1DuplicateOrderEndpoint({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: ordersV1DuplicateOrderEndpointQueryKey(options)
});

export const ordersV1GetOrderFeeSchedulesQueryKey = (options: Options<OrdersV1GetOrderFeeSchedulesData>) => createQueryKey('ordersV1GetOrderFeeSchedules', options);

/**
 * Get fee schedules for an order's primary insurance.
 *
 * Carrier resolved via carrier_type → template slug → UUID (FrontRunner source of
 * truth, mirrors catalog resolution). Falls back to frhc_id + state → CCZ →
 * dme_template_uuid for unverified insurances. Cascades through all insurances in
 * coverage-priority order; returns fee schedules from the first insurance with
 * matching rows. Returns 200 with an empty payload when no insurance resolves to
 * fee schedules (mirrors v2 endpoint behaviour). ENG-1925.
 */
export const ordersV1GetOrderFeeSchedulesOptions = (options: Options<OrdersV1GetOrderFeeSchedulesData>) => queryOptions<OrdersV1GetOrderFeeSchedulesResponse, DefaultError, OrdersV1GetOrderFeeSchedulesResponse, ReturnType<typeof ordersV1GetOrderFeeSchedulesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await ordersV1GetOrderFeeSchedules({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: ordersV1GetOrderFeeSchedulesQueryKey(options)
});

export const ordersV1ToggleFulfillmentActiveQueryKey = (options: Options<OrdersV1ToggleFulfillmentActiveData>) => createQueryKey('ordersV1ToggleFulfillmentActive', options);

export const ordersV1ToggleFulfillmentActiveOptions = (options: Options<OrdersV1ToggleFulfillmentActiveData>) => queryOptions<OrdersV1ToggleFulfillmentActiveResponse, DefaultError, OrdersV1ToggleFulfillmentActiveResponse, ReturnType<typeof ordersV1ToggleFulfillmentActiveQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await ordersV1ToggleFulfillmentActive({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: ordersV1ToggleFulfillmentActiveQueryKey(options)
});

export const ordersV1ToggleFulfillmentInactiveQueryKey = (options: Options<OrdersV1ToggleFulfillmentInactiveData>) => createQueryKey('ordersV1ToggleFulfillmentInactive', options);

export const ordersV1ToggleFulfillmentInactiveOptions = (options: Options<OrdersV1ToggleFulfillmentInactiveData>) => queryOptions<OrdersV1ToggleFulfillmentInactiveResponse, DefaultError, OrdersV1ToggleFulfillmentInactiveResponse, ReturnType<typeof ordersV1ToggleFulfillmentInactiveQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await ordersV1ToggleFulfillmentInactive({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: ordersV1ToggleFulfillmentInactiveQueryKey(options)
});

export const ordersV1GetInsuranceCardDownloadUrlQueryKey = (options: Options<OrdersV1GetInsuranceCardDownloadUrlData>) => createQueryKey('ordersV1GetInsuranceCardDownloadUrl', options);

export const ordersV1GetInsuranceCardDownloadUrlOptions = (options: Options<OrdersV1GetInsuranceCardDownloadUrlData>) => queryOptions<OrdersV1GetInsuranceCardDownloadUrlResponse, DefaultError, OrdersV1GetInsuranceCardDownloadUrlResponse, ReturnType<typeof ordersV1GetInsuranceCardDownloadUrlQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await ordersV1GetInsuranceCardDownloadUrl({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: ordersV1GetInsuranceCardDownloadUrlQueryKey(options)
});

/**
 * Update a single insurance (primary or secondary) on an order.
 *
 * Migrated from orders GraphQL mutation: updateOrderInsurance
 */
export const ordersV1UpdateOrderInsuranceMutation = (options?: Partial<Options<OrdersV1UpdateOrderInsuranceData>>): UseMutationOptions<OrdersV1UpdateOrderInsuranceResponse, DefaultError, Options<OrdersV1UpdateOrderInsuranceData>> => {
    const mutationOptions: UseMutationOptions<OrdersV1UpdateOrderInsuranceResponse, DefaultError, Options<OrdersV1UpdateOrderInsuranceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersV1UpdateOrderInsurance({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Assign Order Insurances
 *
 * Assigns a new slate of insurance information to the order.
 * Expects all insurances to be provided in the request.
 * At least one insurance must be marked as primary.
 * No more than one can be secondary.
 * Any insurances not provided will be deleted from the order.
 */
export const ordersV1AssignOrderInsurancesMutation = (options?: Partial<Options<OrdersV1AssignOrderInsurancesData>>): UseMutationOptions<OrdersV1AssignOrderInsurancesResponse, DefaultError, Options<OrdersV1AssignOrderInsurancesData>> => {
    const mutationOptions: UseMutationOptions<OrdersV1AssignOrderInsurancesResponse, DefaultError, Options<OrdersV1AssignOrderInsurancesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersV1AssignOrderInsurances({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const ordersV1DeleteOrderProductsMutation = (options?: Partial<Options<OrdersV1DeleteOrderProductsData>>): UseMutationOptions<OrdersV1DeleteOrderProductsResponse, DefaultError, Options<OrdersV1DeleteOrderProductsData>> => {
    const mutationOptions: UseMutationOptions<OrdersV1DeleteOrderProductsResponse, DefaultError, Options<OrdersV1DeleteOrderProductsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersV1DeleteOrderProducts({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const ordersV1UpdateOrderProductsMutation = (options?: Partial<Options<OrdersV1UpdateOrderProductsData>>): UseMutationOptions<OrdersV1UpdateOrderProductsResponse, DefaultError, Options<OrdersV1UpdateOrderProductsData>> => {
    const mutationOptions: UseMutationOptions<OrdersV1UpdateOrderProductsResponse, DefaultError, Options<OrdersV1UpdateOrderProductsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersV1UpdateOrderProducts({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const ordersV1UpdateOrderPatientMutation = (options?: Partial<Options<OrdersV1UpdateOrderPatientData>>): UseMutationOptions<OrdersV1UpdateOrderPatientResponse, DefaultError, Options<OrdersV1UpdateOrderPatientData>> => {
    const mutationOptions: UseMutationOptions<OrdersV1UpdateOrderPatientResponse, DefaultError, Options<OrdersV1UpdateOrderPatientData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersV1UpdateOrderPatient({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const ordersV1UpdateOrderPhysicianMutation = (options?: Partial<Options<OrdersV1UpdateOrderPhysicianData>>): UseMutationOptions<OrdersV1UpdateOrderPhysicianResponse, DefaultError, Options<OrdersV1UpdateOrderPhysicianData>> => {
    const mutationOptions: UseMutationOptions<OrdersV1UpdateOrderPhysicianResponse, DefaultError, Options<OrdersV1UpdateOrderPhysicianData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersV1UpdateOrderPhysician({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update the referral (name, phone, email only) on an order.
 *
 * The referral lives on ``order.user`` (the ``OrderUser`` embedded doc surfaced to the
 * frontend as the order's "referral"), NOT ``order.physician`` — the physician is updated
 * separately via ``/physician/update``. We mutate the existing ``OrderUser`` in place so
 * identity fields populated at creation (``user_id``, ``role``, ``organization_*``) are
 * preserved and only the referral's contact fields change.
 *
 * PATCH semantics for the optional contact fields: a field that is present in the request
 * body overwrites (an explicit ``null`` clears it); a field that is omitted is left
 * unchanged. This intentionally diverges from the orders/ GraphQL ``updateOrderReferral``
 * (orders/app/models/order_user.py::OrderUser.update_order_referral), which unconditionally
 * overwrote ``phone``/``email`` and so wiped them when omitted.
 */
export const ordersV1UpdateOrderReferralMutation = (options?: Partial<Options<OrdersV1UpdateOrderReferralData>>): UseMutationOptions<OrdersV1UpdateOrderReferralResponse, DefaultError, Options<OrdersV1UpdateOrderReferralData>> => {
    const mutationOptions: UseMutationOptions<OrdersV1UpdateOrderReferralResponse, DefaultError, Options<OrdersV1UpdateOrderReferralData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersV1UpdateOrderReferral({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reject a pending order.
 *
 * Migrated from orders GraphQL mutation: rejectOrder
 */
export const ordersV1RejectOrderMutation = (options?: Partial<Options<OrdersV1RejectOrderData>>): UseMutationOptions<OrdersV1RejectOrderResponse, DefaultError, Options<OrdersV1RejectOrderData>> => {
    const mutationOptions: UseMutationOptions<OrdersV1RejectOrderResponse, DefaultError, Options<OrdersV1RejectOrderData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersV1RejectOrder({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Request changes on an order.
 *
 * Migrated from orders GraphQL mutation: requestChanges, which appended the
 * requested changes and moved the order to PENDING_CH_FIX (the "CH Fix"
 * status). The append happens before the transition so apply_transition's
 * order.save() persists both; a guard failure (422) records neither.
 */
export const ordersV1RequestOrderChangesMutation = (options?: Partial<Options<OrdersV1RequestOrderChangesData>>): UseMutationOptions<OrdersV1RequestOrderChangesResponse, DefaultError, Options<OrdersV1RequestOrderChangesData>> => {
    const mutationOptions: UseMutationOptions<OrdersV1RequestOrderChangesResponse, DefaultError, Options<OrdersV1RequestOrderChangesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersV1RequestOrderChanges({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Manually set the RX expiration date on an order.
 *
 * Sets default source=Manual otherwise leaves as is.
 * ``reference`` is taken from the request body when
 * provided (e.g. "Fax from Dr. Smith office"); falls back to the requesting
 * user's email when omitted. Does not touch ``signing_date`` — that field is
 * set only by the DocuSign callback.
 */
export const ordersV1UpdateRxDateMutation = (options?: Partial<Options<OrdersV1UpdateRxDateData>>): UseMutationOptions<OrdersV1UpdateRxDateResponse, DefaultError, Options<OrdersV1UpdateRxDateData>> => {
    const mutationOptions: UseMutationOptions<OrdersV1UpdateRxDateResponse, DefaultError, Options<OrdersV1UpdateRxDateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersV1UpdateRxDate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const ordersV1OrderScheduleResupplyQueryKey = (options: Options<OrdersV1OrderScheduleResupplyData>) => createQueryKey('ordersV1OrderScheduleResupply', options);

export const ordersV1OrderScheduleResupplyOptions = (options: Options<OrdersV1OrderScheduleResupplyData>) => queryOptions<OrdersV1OrderScheduleResupplyResponse, DefaultError, OrdersV1OrderScheduleResupplyResponse, ReturnType<typeof ordersV1OrderScheduleResupplyQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await ordersV1OrderScheduleResupply({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: ordersV1OrderScheduleResupplyQueryKey(options)
});

export const ordersV1UpdateOrderShippingAddressMutation = (options?: Partial<Options<OrdersV1UpdateOrderShippingAddressData>>): UseMutationOptions<OrdersV1UpdateOrderShippingAddressResponse, DefaultError, Options<OrdersV1UpdateOrderShippingAddressData>> => {
    const mutationOptions: UseMutationOptions<OrdersV1UpdateOrderShippingAddressResponse, DefaultError, Options<OrdersV1UpdateOrderShippingAddressData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersV1UpdateOrderShippingAddress({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const ordersV1SkipOrderQueryKey = (options: Options<OrdersV1SkipOrderData>) => createQueryKey('ordersV1SkipOrder', options);

export const ordersV1SkipOrderOptions = (options: Options<OrdersV1SkipOrderData>) => queryOptions<OrdersV1SkipOrderResponse, DefaultError, OrdersV1SkipOrderResponse, ReturnType<typeof ordersV1SkipOrderQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await ordersV1SkipOrder({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: ordersV1SkipOrderQueryKey(options)
});

export const ordersV1SkipOrder2QueryKey = (options: Options<OrdersV1SkipOrder2Data>) => createQueryKey('ordersV1SkipOrder2', options);

export const ordersV1SkipOrder2Options = (options: Options<OrdersV1SkipOrder2Data>) => queryOptions<OrdersV1SkipOrder2Response, DefaultError, OrdersV1SkipOrder2Response, ReturnType<typeof ordersV1SkipOrder2QueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await ordersV1SkipOrder2({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: ordersV1SkipOrder2QueryKey(options)
});

export const ordersV1UpdateOrderSupplierMutation = (options?: Partial<Options<OrdersV1UpdateOrderSupplierData>>): UseMutationOptions<OrdersV1UpdateOrderSupplierResponse, DefaultError, Options<OrdersV1UpdateOrderSupplierData>> => {
    const mutationOptions: UseMutationOptions<OrdersV1UpdateOrderSupplierResponse, DefaultError, Options<OrdersV1UpdateOrderSupplierData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersV1UpdateOrderSupplier({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const organizationsV1CreateOrganizationMutation = (options?: Partial<Options<OrganizationsV1CreateOrganizationData>>): UseMutationOptions<OrganizationsV1CreateOrganizationResponse, DefaultError, Options<OrganizationsV1CreateOrganizationData>> => {
    const mutationOptions: UseMutationOptions<OrganizationsV1CreateOrganizationResponse, DefaultError, Options<OrganizationsV1CreateOrganizationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await organizationsV1CreateOrganization({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const organizationsV1SearchOrganizationsQueryKey = (options?: Options<OrganizationsV1SearchOrganizationsData>) => createQueryKey('organizationsV1SearchOrganizations', options);

export const organizationsV1SearchOrganizationsOptions = (options?: Options<OrganizationsV1SearchOrganizationsData>) => queryOptions<OrganizationsV1SearchOrganizationsResponse, DefaultError, OrganizationsV1SearchOrganizationsResponse, ReturnType<typeof organizationsV1SearchOrganizationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await organizationsV1SearchOrganizations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: organizationsV1SearchOrganizationsQueryKey(options)
});

export const organizationsV1SearchOrganizationsInfiniteQueryKey = (options?: Options<OrganizationsV1SearchOrganizationsData>): QueryKey<Options<OrganizationsV1SearchOrganizationsData>> => createQueryKey('organizationsV1SearchOrganizations', options, true);

export const organizationsV1SearchOrganizationsInfiniteOptions = (options?: Options<OrganizationsV1SearchOrganizationsData>) => infiniteQueryOptions<OrganizationsV1SearchOrganizationsResponse, DefaultError, InfiniteData<OrganizationsV1SearchOrganizationsResponse>, QueryKey<Options<OrganizationsV1SearchOrganizationsData>>, number | Pick<QueryKey<Options<OrganizationsV1SearchOrganizationsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<OrganizationsV1SearchOrganizationsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await organizationsV1SearchOrganizations({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: organizationsV1SearchOrganizationsInfiniteQueryKey(options)
});

export const organizationsV1GetOrganizationQueryKey = (options: Options<OrganizationsV1GetOrganizationData>) => createQueryKey('organizationsV1GetOrganization', options);

export const organizationsV1GetOrganizationOptions = (options: Options<OrganizationsV1GetOrganizationData>) => queryOptions<OrganizationsV1GetOrganizationResponse, DefaultError, OrganizationsV1GetOrganizationResponse, ReturnType<typeof organizationsV1GetOrganizationQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await organizationsV1GetOrganization({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: organizationsV1GetOrganizationQueryKey(options)
});

export const organizationsV1UpdateOrganizationMutation = (options?: Partial<Options<OrganizationsV1UpdateOrganizationData>>): UseMutationOptions<OrganizationsV1UpdateOrganizationResponse, DefaultError, Options<OrganizationsV1UpdateOrganizationData>> => {
    const mutationOptions: UseMutationOptions<OrganizationsV1UpdateOrganizationResponse, DefaultError, Options<OrganizationsV1UpdateOrganizationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await organizationsV1UpdateOrganization({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const productsV1CategoriesV1HeartbeatQueryKey = (options?: Options<ProductsV1CategoriesV1HeartbeatData>) => createQueryKey('productsV1CategoriesV1Heartbeat', options);

/**
 * Heartbeat
 *
 * Base validation for the heartbeat endpoint
 */
export const productsV1CategoriesV1HeartbeatOptions = (options?: Options<ProductsV1CategoriesV1HeartbeatData>) => queryOptions<ProductsV1CategoriesV1HeartbeatResponse, DefaultError, ProductsV1CategoriesV1HeartbeatResponse, ReturnType<typeof productsV1CategoriesV1HeartbeatQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await productsV1CategoriesV1Heartbeat({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: productsV1CategoriesV1HeartbeatQueryKey(options)
});

export const productsV1CategoriesV1SearchQueryKey = (options?: Options<ProductsV1CategoriesV1SearchData>) => createQueryKey('productsV1CategoriesV1Search', options);

/**
 * Search
 *
 * Retrieve list of records by query term and/or template type (Medicaid/Medicare)
 */
export const productsV1CategoriesV1SearchOptions = (options?: Options<ProductsV1CategoriesV1SearchData>) => queryOptions<ProductsV1CategoriesV1SearchResponse, DefaultError, ProductsV1CategoriesV1SearchResponse, ReturnType<typeof productsV1CategoriesV1SearchQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await productsV1CategoriesV1Search({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: productsV1CategoriesV1SearchQueryKey(options)
});

export const productsV1CategoriesV1SearchInfiniteQueryKey = (options?: Options<ProductsV1CategoriesV1SearchData>): QueryKey<Options<ProductsV1CategoriesV1SearchData>> => createQueryKey('productsV1CategoriesV1Search', options, true);

/**
 * Search
 *
 * Retrieve list of records by query term and/or template type (Medicaid/Medicare)
 */
export const productsV1CategoriesV1SearchInfiniteOptions = (options?: Options<ProductsV1CategoriesV1SearchData>) => infiniteQueryOptions<ProductsV1CategoriesV1SearchResponse, DefaultError, InfiniteData<ProductsV1CategoriesV1SearchResponse>, QueryKey<Options<ProductsV1CategoriesV1SearchData>>, number | Pick<QueryKey<Options<ProductsV1CategoriesV1SearchData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ProductsV1CategoriesV1SearchData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await productsV1CategoriesV1Search({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: productsV1CategoriesV1SearchInfiniteQueryKey(options)
});

export const productsV1ProductDetailsQueryKey = (options: Options<ProductsV1ProductDetailsData>) => createQueryKey('productsV1ProductDetails', options);

/**
 * Details
 *
 * Retrieve the extended Product record by uuid
 */
export const productsV1ProductDetailsOptions = (options: Options<ProductsV1ProductDetailsData>) => queryOptions<ProductsV1ProductDetailsResponse, DefaultError, ProductsV1ProductDetailsResponse, ReturnType<typeof productsV1ProductDetailsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await productsV1ProductDetails({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: productsV1ProductDetailsQueryKey(options)
});

export const productsV1HeartbeatQueryKey = (options?: Options<ProductsV1HeartbeatData>) => createQueryKey('productsV1Heartbeat', options);

/**
 * Heartbeat
 *
 * Base validation for the heartbeat endpoint
 */
export const productsV1HeartbeatOptions = (options?: Options<ProductsV1HeartbeatData>) => queryOptions<ProductsV1HeartbeatResponse, DefaultError, ProductsV1HeartbeatResponse, ReturnType<typeof productsV1HeartbeatQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await productsV1Heartbeat({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: productsV1HeartbeatQueryKey(options)
});

export const productsV1SearchProductsQueryKey = (options?: Options<ProductsV1SearchProductsData>) => createQueryKey('productsV1SearchProducts', options);

/**
 * Search Products
 *
 * Retrieve list of records by query term and/or template type (Medicaid/Medicare)
 */
export const productsV1SearchProductsOptions = (options?: Options<ProductsV1SearchProductsData>) => queryOptions<ProductsV1SearchProductsResponse, DefaultError, ProductsV1SearchProductsResponse, ReturnType<typeof productsV1SearchProductsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await productsV1SearchProducts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: productsV1SearchProductsQueryKey(options)
});

export const productsV1SearchProductsInfiniteQueryKey = (options?: Options<ProductsV1SearchProductsData>): QueryKey<Options<ProductsV1SearchProductsData>> => createQueryKey('productsV1SearchProducts', options, true);

/**
 * Search Products
 *
 * Retrieve list of records by query term and/or template type (Medicaid/Medicare)
 */
export const productsV1SearchProductsInfiniteOptions = (options?: Options<ProductsV1SearchProductsData>) => infiniteQueryOptions<ProductsV1SearchProductsResponse, DefaultError, InfiniteData<ProductsV1SearchProductsResponse>, QueryKey<Options<ProductsV1SearchProductsData>>, number | Pick<QueryKey<Options<ProductsV1SearchProductsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ProductsV1SearchProductsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await productsV1SearchProducts({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: productsV1SearchProductsInfiniteQueryKey(options)
});

export const servicesV1Auth0V1HeartbeatQueryKey = (options?: Options<ServicesV1Auth0V1HeartbeatData>) => createQueryKey('servicesV1Auth0V1Heartbeat', options);

/**
 * Heartbeat
 *
 * Base validation for the heartbeat endpoint
 */
export const servicesV1Auth0V1HeartbeatOptions = (options?: Options<ServicesV1Auth0V1HeartbeatData>) => queryOptions<ServicesV1Auth0V1HeartbeatResponse, DefaultError, ServicesV1Auth0V1HeartbeatResponse, ReturnType<typeof servicesV1Auth0V1HeartbeatQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await servicesV1Auth0V1Heartbeat({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: servicesV1Auth0V1HeartbeatQueryKey(options)
});

export const servicesV1Auth0V1GetAuth0UserQueryKey = (options: Options<ServicesV1Auth0V1GetAuth0UserData>) => createQueryKey('servicesV1Auth0V1GetAuth0User', options);

/**
 * Auth0 Users
 *
 * Retrieve 1 auth0 registered user based on provided user_id
 */
export const servicesV1Auth0V1GetAuth0UserOptions = (options: Options<ServicesV1Auth0V1GetAuth0UserData>) => queryOptions<ServicesV1Auth0V1GetAuth0UserResponse, DefaultError, ServicesV1Auth0V1GetAuth0UserResponse, ReturnType<typeof servicesV1Auth0V1GetAuth0UserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await servicesV1Auth0V1GetAuth0User({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: servicesV1Auth0V1GetAuth0UserQueryKey(options)
});

export const servicesV1Auth0V1ListAuth0UsersQueryKey = (options?: Options<ServicesV1Auth0V1ListAuth0UsersData>) => createQueryKey('servicesV1Auth0V1ListAuth0Users', options);

/**
 * Auth0 Users
 *
 * Retrieve list of a max of 1000 auth0 registered users for current tenant
 */
export const servicesV1Auth0V1ListAuth0UsersOptions = (options?: Options<ServicesV1Auth0V1ListAuth0UsersData>) => queryOptions<ServicesV1Auth0V1ListAuth0UsersResponse, DefaultError, ServicesV1Auth0V1ListAuth0UsersResponse, ReturnType<typeof servicesV1Auth0V1ListAuth0UsersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await servicesV1Auth0V1ListAuth0Users({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: servicesV1Auth0V1ListAuth0UsersQueryKey(options)
});

export const servicesV1Auth0V1DuplicateAuth0UsersQueryKey = (options?: Options<ServicesV1Auth0V1DuplicateAuth0UsersData>) => createQueryKey('servicesV1Auth0V1DuplicateAuth0Users', options);

/**
 * Auth0 Users
 *
 * Retrieve list of all auth0 registered users for current tenant
 */
export const servicesV1Auth0V1DuplicateAuth0UsersOptions = (options?: Options<ServicesV1Auth0V1DuplicateAuth0UsersData>) => queryOptions<ServicesV1Auth0V1DuplicateAuth0UsersResponse, DefaultError, ServicesV1Auth0V1DuplicateAuth0UsersResponse, ReturnType<typeof servicesV1Auth0V1DuplicateAuth0UsersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await servicesV1Auth0V1DuplicateAuth0Users({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: servicesV1Auth0V1DuplicateAuth0UsersQueryKey(options)
});

export const servicesV1Auth0V1ExportAuth0UsersQueryKey = (options?: Options<ServicesV1Auth0V1ExportAuth0UsersData>) => createQueryKey('servicesV1Auth0V1ExportAuth0Users', options);

/**
 * Auth0 Users
 *
 * Retrieve list of all auth0 registered users for current tenant
 */
export const servicesV1Auth0V1ExportAuth0UsersOptions = (options?: Options<ServicesV1Auth0V1ExportAuth0UsersData>) => queryOptions<ServicesV1Auth0V1ExportAuth0UsersResponse, DefaultError, ServicesV1Auth0V1ExportAuth0UsersResponse, ReturnType<typeof servicesV1Auth0V1ExportAuth0UsersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await servicesV1Auth0V1ExportAuth0Users({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: servicesV1Auth0V1ExportAuth0UsersQueryKey(options)
});

export const servicesV1Auth0V1ListAuth0Users2QueryKey = (options: Options<ServicesV1Auth0V1ListAuth0Users2Data>) => createQueryKey('servicesV1Auth0V1ListAuth0Users2', options);

/**
 * Auth0 Users
 *
 * Retrieve list of a max of 1000 auth0 registered users for current tenant
 */
export const servicesV1Auth0V1ListAuth0Users2Options = (options: Options<ServicesV1Auth0V1ListAuth0Users2Data>) => queryOptions<ServicesV1Auth0V1ListAuth0Users2Response, DefaultError, ServicesV1Auth0V1ListAuth0Users2Response, ReturnType<typeof servicesV1Auth0V1ListAuth0Users2QueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await servicesV1Auth0V1ListAuth0Users2({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: servicesV1Auth0V1ListAuth0Users2QueryKey(options)
});

export const servicesV1CandidV1GenerateEncounterPayloadQueryKey = (options: Options<ServicesV1CandidV1GenerateEncounterPayloadData>) => createQueryKey('servicesV1CandidV1GenerateEncounterPayload', options);

/**
 * Candid Payload
 *
 * Generate the payload that is sent when order is submitted to candid
 */
export const servicesV1CandidV1GenerateEncounterPayloadOptions = (options: Options<ServicesV1CandidV1GenerateEncounterPayloadData>) => queryOptions<ServicesV1CandidV1GenerateEncounterPayloadResponse, DefaultError, ServicesV1CandidV1GenerateEncounterPayloadResponse, ReturnType<typeof servicesV1CandidV1GenerateEncounterPayloadQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await servicesV1CandidV1GenerateEncounterPayload({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: servicesV1CandidV1GenerateEncounterPayloadQueryKey(options)
});

export const servicesV1CandidV1SearchOrderEncounterQueryKey = (options: Options<ServicesV1CandidV1SearchOrderEncounterData>) => createQueryKey('servicesV1CandidV1SearchOrderEncounter', options);

/**
 * Candid Payload
 *
 * Get candid encounter by order
 */
export const servicesV1CandidV1SearchOrderEncounterOptions = (options: Options<ServicesV1CandidV1SearchOrderEncounterData>) => queryOptions<ServicesV1CandidV1SearchOrderEncounterResponse, DefaultError, ServicesV1CandidV1SearchOrderEncounterResponse, ReturnType<typeof servicesV1CandidV1SearchOrderEncounterQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await servicesV1CandidV1SearchOrderEncounter({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: servicesV1CandidV1SearchOrderEncounterQueryKey(options)
});

export const servicesV1CandidV1HeartbeatQueryKey = (options?: Options<ServicesV1CandidV1HeartbeatData>) => createQueryKey('servicesV1CandidV1Heartbeat', options);

/**
 * Heartbeat
 *
 * Base validation for the heartbeat endpoint
 */
export const servicesV1CandidV1HeartbeatOptions = (options?: Options<ServicesV1CandidV1HeartbeatData>) => queryOptions<ServicesV1CandidV1HeartbeatResponse, DefaultError, ServicesV1CandidV1HeartbeatResponse, ReturnType<typeof servicesV1CandidV1HeartbeatQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await servicesV1CandidV1Heartbeat({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: servicesV1CandidV1HeartbeatQueryKey(options)
});

export const servicesV1CandidV1SyncFulfillmentByOrderMutation = (options?: Partial<Options<ServicesV1CandidV1SyncFulfillmentByOrderData>>): UseMutationOptions<ServicesV1CandidV1SyncFulfillmentByOrderResponse, DefaultError, Options<ServicesV1CandidV1SyncFulfillmentByOrderData>> => {
    const mutationOptions: UseMutationOptions<ServicesV1CandidV1SyncFulfillmentByOrderResponse, DefaultError, Options<ServicesV1CandidV1SyncFulfillmentByOrderData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await servicesV1CandidV1SyncFulfillmentByOrder({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const servicesV1CandidV1SyncRentalClaimsMutation = (options?: Partial<Options<ServicesV1CandidV1SyncRentalClaimsData>>): UseMutationOptions<ServicesV1CandidV1SyncRentalClaimsResponse, DefaultError, Options<ServicesV1CandidV1SyncRentalClaimsData>> => {
    const mutationOptions: UseMutationOptions<ServicesV1CandidV1SyncRentalClaimsResponse, DefaultError, Options<ServicesV1CandidV1SyncRentalClaimsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await servicesV1CandidV1SyncRentalClaims({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create an Intercom ticket from a Customer.io webhook action.
 *
 * The Customer.io webhook body must send the raw JSON that this schema
 * describes, since the same raw bytes are what ``X-CIO-Signature`` is
 * computed over.
 *
 * When the request carries ``X-CIO-Idempotency-Key``, the created ticket id
 * is cached under that key so retries (from a lost/slow response or a manual
 * resend) return the original ticket instead of opening a duplicate.
 *
 * When ``order_id`` is present, the order is looked up to enrich structured
 * logs with ``is_resupply`` and ``confirmation_status``.
 */
export const servicesV1CustomerioV1PostCreateTicketMutation = (options?: Partial<Options<ServicesV1CustomerioV1PostCreateTicketData>>): UseMutationOptions<ServicesV1CustomerioV1PostCreateTicketResponse, DefaultError, Options<ServicesV1CustomerioV1PostCreateTicketData>> => {
    const mutationOptions: UseMutationOptions<ServicesV1CustomerioV1PostCreateTicketResponse, DefaultError, Options<ServicesV1CustomerioV1PostCreateTicketData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await servicesV1CustomerioV1PostCreateTicket({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const servicesV1EpacesV1GetEligibilityResponsesQueryKey = (options?: Options<ServicesV1EpacesV1GetEligibilityResponsesData>) => createQueryKey('servicesV1EpacesV1GetEligibilityResponses', options);

export const servicesV1EpacesV1GetEligibilityResponsesOptions = (options?: Options<ServicesV1EpacesV1GetEligibilityResponsesData>) => queryOptions<ServicesV1EpacesV1GetEligibilityResponsesResponse, DefaultError, ServicesV1EpacesV1GetEligibilityResponsesResponse, ReturnType<typeof servicesV1EpacesV1GetEligibilityResponsesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await servicesV1EpacesV1GetEligibilityResponses({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: servicesV1EpacesV1GetEligibilityResponsesQueryKey(options)
});

export const servicesV1EpacesV1HeartbeatQueryKey = (options?: Options<ServicesV1EpacesV1HeartbeatData>) => createQueryKey('servicesV1EpacesV1Heartbeat', options);

/**
 * Heartbeat
 *
 * Base validation for the heartbeat endpoint
 */
export const servicesV1EpacesV1HeartbeatOptions = (options?: Options<ServicesV1EpacesV1HeartbeatData>) => queryOptions<ServicesV1EpacesV1HeartbeatResponse, DefaultError, ServicesV1EpacesV1HeartbeatResponse, ReturnType<typeof servicesV1EpacesV1HeartbeatQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await servicesV1EpacesV1Heartbeat({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: servicesV1EpacesV1HeartbeatQueryKey(options)
});

export const servicesV1EpacesV1GetPriorAuthorizationResponsesQueryKey = (options?: Options<ServicesV1EpacesV1GetPriorAuthorizationResponsesData>) => createQueryKey('servicesV1EpacesV1GetPriorAuthorizationResponses', options);

export const servicesV1EpacesV1GetPriorAuthorizationResponsesOptions = (options?: Options<ServicesV1EpacesV1GetPriorAuthorizationResponsesData>) => queryOptions<ServicesV1EpacesV1GetPriorAuthorizationResponsesResponse, DefaultError, ServicesV1EpacesV1GetPriorAuthorizationResponsesResponse, ReturnType<typeof servicesV1EpacesV1GetPriorAuthorizationResponsesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await servicesV1EpacesV1GetPriorAuthorizationResponses({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: servicesV1EpacesV1GetPriorAuthorizationResponsesQueryKey(options)
});

export const servicesV1EpacesV1GetPriorAuthorizationResponsesForOrderQueryKey = (options: Options<ServicesV1EpacesV1GetPriorAuthorizationResponsesForOrderData>) => createQueryKey('servicesV1EpacesV1GetPriorAuthorizationResponsesForOrder', options);

export const servicesV1EpacesV1GetPriorAuthorizationResponsesForOrderOptions = (options: Options<ServicesV1EpacesV1GetPriorAuthorizationResponsesForOrderData>) => queryOptions<ServicesV1EpacesV1GetPriorAuthorizationResponsesForOrderResponse, DefaultError, ServicesV1EpacesV1GetPriorAuthorizationResponsesForOrderResponse, ReturnType<typeof servicesV1EpacesV1GetPriorAuthorizationResponsesForOrderQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await servicesV1EpacesV1GetPriorAuthorizationResponsesForOrder({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: servicesV1EpacesV1GetPriorAuthorizationResponsesForOrderQueryKey(options)
});

export const servicesV1EpacesV1CancelPriorAuthorizationsForOrderQueryKey = (options: Options<ServicesV1EpacesV1CancelPriorAuthorizationsForOrderData>) => createQueryKey('servicesV1EpacesV1CancelPriorAuthorizationsForOrder', options);

export const servicesV1EpacesV1CancelPriorAuthorizationsForOrderOptions = (options: Options<ServicesV1EpacesV1CancelPriorAuthorizationsForOrderData>) => queryOptions<ServicesV1EpacesV1CancelPriorAuthorizationsForOrderResponse, DefaultError, ServicesV1EpacesV1CancelPriorAuthorizationsForOrderResponse, ReturnType<typeof servicesV1EpacesV1CancelPriorAuthorizationsForOrderQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await servicesV1EpacesV1CancelPriorAuthorizationsForOrder({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: servicesV1EpacesV1CancelPriorAuthorizationsForOrderQueryKey(options)
});

export const servicesV1EpacesV1CancelPriorAuthorizationsForOrder2QueryKey = (options: Options<ServicesV1EpacesV1CancelPriorAuthorizationsForOrder2Data>) => createQueryKey('servicesV1EpacesV1CancelPriorAuthorizationsForOrder2', options);

export const servicesV1EpacesV1CancelPriorAuthorizationsForOrder2Options = (options: Options<ServicesV1EpacesV1CancelPriorAuthorizationsForOrder2Data>) => queryOptions<ServicesV1EpacesV1CancelPriorAuthorizationsForOrder2Response, DefaultError, ServicesV1EpacesV1CancelPriorAuthorizationsForOrder2Response, ReturnType<typeof servicesV1EpacesV1CancelPriorAuthorizationsForOrder2QueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await servicesV1EpacesV1CancelPriorAuthorizationsForOrder2({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: servicesV1EpacesV1CancelPriorAuthorizationsForOrder2QueryKey(options)
});

export const servicesV1EpacesV1SubmitPriorAuthorizationForOrderQueryKey = (options: Options<ServicesV1EpacesV1SubmitPriorAuthorizationForOrderData>) => createQueryKey('servicesV1EpacesV1SubmitPriorAuthorizationForOrder', options);

export const servicesV1EpacesV1SubmitPriorAuthorizationForOrderOptions = (options: Options<ServicesV1EpacesV1SubmitPriorAuthorizationForOrderData>) => queryOptions<ServicesV1EpacesV1SubmitPriorAuthorizationForOrderResponse, DefaultError, ServicesV1EpacesV1SubmitPriorAuthorizationForOrderResponse, ReturnType<typeof servicesV1EpacesV1SubmitPriorAuthorizationForOrderQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await servicesV1EpacesV1SubmitPriorAuthorizationForOrder({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: servicesV1EpacesV1SubmitPriorAuthorizationForOrderQueryKey(options)
});

export const servicesV1EpacesV1SubmitPriorAuthorizationForOrder2QueryKey = (options: Options<ServicesV1EpacesV1SubmitPriorAuthorizationForOrder2Data>) => createQueryKey('servicesV1EpacesV1SubmitPriorAuthorizationForOrder2', options);

export const servicesV1EpacesV1SubmitPriorAuthorizationForOrder2Options = (options: Options<ServicesV1EpacesV1SubmitPriorAuthorizationForOrder2Data>) => queryOptions<ServicesV1EpacesV1SubmitPriorAuthorizationForOrder2Response, DefaultError, ServicesV1EpacesV1SubmitPriorAuthorizationForOrder2Response, ReturnType<typeof servicesV1EpacesV1SubmitPriorAuthorizationForOrder2QueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await servicesV1EpacesV1SubmitPriorAuthorizationForOrder2({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: servicesV1EpacesV1SubmitPriorAuthorizationForOrder2QueryKey(options)
});

export const servicesV1FrontrunnerV1PrioritizedDiscoveryByOrderEndpointQueryKey = (options: Options<ServicesV1FrontrunnerV1PrioritizedDiscoveryByOrderEndpointData>) => createQueryKey('servicesV1FrontrunnerV1PrioritizedDiscoveryByOrderEndpoint', options);

/**
 * Prioritized Order Discovery
 *
 * Run discovery for patient demographics of a given order and return prioritized results
 */
export const servicesV1FrontrunnerV1PrioritizedDiscoveryByOrderEndpointOptions = (options: Options<ServicesV1FrontrunnerV1PrioritizedDiscoveryByOrderEndpointData>) => queryOptions<ServicesV1FrontrunnerV1PrioritizedDiscoveryByOrderEndpointResponse, DefaultError, ServicesV1FrontrunnerV1PrioritizedDiscoveryByOrderEndpointResponse, ReturnType<typeof servicesV1FrontrunnerV1PrioritizedDiscoveryByOrderEndpointQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await servicesV1FrontrunnerV1PrioritizedDiscoveryByOrderEndpoint({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: servicesV1FrontrunnerV1PrioritizedDiscoveryByOrderEndpointQueryKey(options)
});

export const servicesV1FrontrunnerV1DiscoveryByOrderEndpointQueryKey = (options: Options<ServicesV1FrontrunnerV1DiscoveryByOrderEndpointData>) => createQueryKey('servicesV1FrontrunnerV1DiscoveryByOrderEndpoint', options);

/**
 * Order Discovery
 *
 * Run discovery for patient demographics of a given order
 */
export const servicesV1FrontrunnerV1DiscoveryByOrderEndpointOptions = (options: Options<ServicesV1FrontrunnerV1DiscoveryByOrderEndpointData>) => queryOptions<ServicesV1FrontrunnerV1DiscoveryByOrderEndpointResponse, DefaultError, ServicesV1FrontrunnerV1DiscoveryByOrderEndpointResponse, ReturnType<typeof servicesV1FrontrunnerV1DiscoveryByOrderEndpointQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await servicesV1FrontrunnerV1DiscoveryByOrderEndpoint({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: servicesV1FrontrunnerV1DiscoveryByOrderEndpointQueryKey(options)
});

/**
 * Patient Discovery
 *
 * Run discovery for supplied patient demographics
 */
export const servicesV1FrontrunnerV1DiscoveryByPatientEndpointMutation = (options?: Partial<Options<ServicesV1FrontrunnerV1DiscoveryByPatientEndpointData>>): UseMutationOptions<ServicesV1FrontrunnerV1DiscoveryByPatientEndpointResponse, DefaultError, Options<ServicesV1FrontrunnerV1DiscoveryByPatientEndpointData>> => {
    const mutationOptions: UseMutationOptions<ServicesV1FrontrunnerV1DiscoveryByPatientEndpointResponse, DefaultError, Options<ServicesV1FrontrunnerV1DiscoveryByPatientEndpointData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await servicesV1FrontrunnerV1DiscoveryByPatientEndpoint({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Prioritized Patient Discovery
 *
 * Run discovery for supplied patient demographics and return prioritized results
 */
export const servicesV1FrontrunnerV1PrioritizedDiscoveryByPatientEndpointMutation = (options?: Partial<Options<ServicesV1FrontrunnerV1PrioritizedDiscoveryByPatientEndpointData>>): UseMutationOptions<ServicesV1FrontrunnerV1PrioritizedDiscoveryByPatientEndpointResponse, DefaultError, Options<ServicesV1FrontrunnerV1PrioritizedDiscoveryByPatientEndpointData>> => {
    const mutationOptions: UseMutationOptions<ServicesV1FrontrunnerV1PrioritizedDiscoveryByPatientEndpointResponse, DefaultError, Options<ServicesV1FrontrunnerV1PrioritizedDiscoveryByPatientEndpointData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await servicesV1FrontrunnerV1PrioritizedDiscoveryByPatientEndpoint({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getServicesV1FrontrunnerV1MongoDiscoveryEventQueryKey = (options: Options<GetServicesV1FrontrunnerV1MongoDiscoveryEventData>) => createQueryKey('getServicesV1FrontrunnerV1MongoDiscoveryEvent', options);

/**
 * Generate Kafka Message to Write FR data to Mongo
 *
 * Generate the message for kafka based on the same output generated by `mongo-discovery-source`
 */
export const getServicesV1FrontrunnerV1MongoDiscoveryEventOptions = (options: Options<GetServicesV1FrontrunnerV1MongoDiscoveryEventData>) => queryOptions<GetServicesV1FrontrunnerV1MongoDiscoveryEventResponse, DefaultError, GetServicesV1FrontrunnerV1MongoDiscoveryEventResponse, ReturnType<typeof getServicesV1FrontrunnerV1MongoDiscoveryEventQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getServicesV1FrontrunnerV1MongoDiscoveryEvent({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getServicesV1FrontrunnerV1MongoDiscoveryEventQueryKey(options)
});

/**
 * Generate Kafka Message to Write FR data to Mongo
 *
 * Generate the message for kafka based on the same output generated by `mongo-discovery-source`
 */
export const postServicesV1FrontrunnerV1MongoDiscoveryEventMutation = (options?: Partial<Options<PostServicesV1FrontrunnerV1MongoDiscoveryEventData>>): UseMutationOptions<PostServicesV1FrontrunnerV1MongoDiscoveryEventResponse, DefaultError, Options<PostServicesV1FrontrunnerV1MongoDiscoveryEventData>> => {
    const mutationOptions: UseMutationOptions<PostServicesV1FrontrunnerV1MongoDiscoveryEventResponse, DefaultError, Options<PostServicesV1FrontrunnerV1MongoDiscoveryEventData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postServicesV1FrontrunnerV1MongoDiscoveryEvent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const servicesV1FrontrunnerV1MongoDiscoverySourceQueryKey = (options: Options<ServicesV1FrontrunnerV1MongoDiscoverySourceData>) => createQueryKey('servicesV1FrontrunnerV1MongoDiscoverySource', options);

/**
 * Generate Order Discovery Source
 *
 * Run discovery for an order and return the source data used to create the frontrunner_discovery event
 */
export const servicesV1FrontrunnerV1MongoDiscoverySourceOptions = (options: Options<ServicesV1FrontrunnerV1MongoDiscoverySourceData>) => queryOptions<ServicesV1FrontrunnerV1MongoDiscoverySourceResponse, DefaultError, ServicesV1FrontrunnerV1MongoDiscoverySourceResponse, ReturnType<typeof servicesV1FrontrunnerV1MongoDiscoverySourceQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await servicesV1FrontrunnerV1MongoDiscoverySource({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: servicesV1FrontrunnerV1MongoDiscoverySourceQueryKey(options)
});

export const servicesV1FrontrunnerV1PrioritizedEligibilityByOrderEndpointQueryKey = (options: Options<ServicesV1FrontrunnerV1PrioritizedEligibilityByOrderEndpointData>) => createQueryKey('servicesV1FrontrunnerV1PrioritizedEligibilityByOrderEndpoint', options);

/**
 * Prioritized Order Eligibility
 *
 * Check patient eligibility based on an existing order and optional member_id or frhc_id that is already associated with the order and return prioritized results
 */
export const servicesV1FrontrunnerV1PrioritizedEligibilityByOrderEndpointOptions = (options: Options<ServicesV1FrontrunnerV1PrioritizedEligibilityByOrderEndpointData>) => queryOptions<ServicesV1FrontrunnerV1PrioritizedEligibilityByOrderEndpointResponse, DefaultError, ServicesV1FrontrunnerV1PrioritizedEligibilityByOrderEndpointResponse, ReturnType<typeof servicesV1FrontrunnerV1PrioritizedEligibilityByOrderEndpointQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await servicesV1FrontrunnerV1PrioritizedEligibilityByOrderEndpoint({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: servicesV1FrontrunnerV1PrioritizedEligibilityByOrderEndpointQueryKey(options)
});

export const servicesV1FrontrunnerV1PrioritizedEligibilityByOrderEndpoint2QueryKey = (options: Options<ServicesV1FrontrunnerV1PrioritizedEligibilityByOrderEndpoint2Data>) => createQueryKey('servicesV1FrontrunnerV1PrioritizedEligibilityByOrderEndpoint2', options);

/**
 * Prioritized Order Eligibility
 *
 * Check patient eligibility based on an existing order and optional member_id or frhc_id that is already associated with the order and return prioritized results
 */
export const servicesV1FrontrunnerV1PrioritizedEligibilityByOrderEndpoint2Options = (options: Options<ServicesV1FrontrunnerV1PrioritizedEligibilityByOrderEndpoint2Data>) => queryOptions<ServicesV1FrontrunnerV1PrioritizedEligibilityByOrderEndpoint2Response, DefaultError, ServicesV1FrontrunnerV1PrioritizedEligibilityByOrderEndpoint2Response, ReturnType<typeof servicesV1FrontrunnerV1PrioritizedEligibilityByOrderEndpoint2QueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await servicesV1FrontrunnerV1PrioritizedEligibilityByOrderEndpoint2({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: servicesV1FrontrunnerV1PrioritizedEligibilityByOrderEndpoint2QueryKey(options)
});

export const servicesV1FrontrunnerV1EligibilityByOrderEndpointQueryKey = (options: Options<ServicesV1FrontrunnerV1EligibilityByOrderEndpointData>) => createQueryKey('servicesV1FrontrunnerV1EligibilityByOrderEndpoint', options);

/**
 * Order Eligibility
 *
 * Check patient eligibility based on an existing order and optional member_id or frhc_id that is already associated with the order
 */
export const servicesV1FrontrunnerV1EligibilityByOrderEndpointOptions = (options: Options<ServicesV1FrontrunnerV1EligibilityByOrderEndpointData>) => queryOptions<ServicesV1FrontrunnerV1EligibilityByOrderEndpointResponse, DefaultError, ServicesV1FrontrunnerV1EligibilityByOrderEndpointResponse, ReturnType<typeof servicesV1FrontrunnerV1EligibilityByOrderEndpointQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await servicesV1FrontrunnerV1EligibilityByOrderEndpoint({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: servicesV1FrontrunnerV1EligibilityByOrderEndpointQueryKey(options)
});

export const servicesV1FrontrunnerV1EligibilityByOrderEndpoint2QueryKey = (options: Options<ServicesV1FrontrunnerV1EligibilityByOrderEndpoint2Data>) => createQueryKey('servicesV1FrontrunnerV1EligibilityByOrderEndpoint2', options);

/**
 * Order Eligibility
 *
 * Check patient eligibility based on an existing order and optional member_id or frhc_id that is already associated with the order
 */
export const servicesV1FrontrunnerV1EligibilityByOrderEndpoint2Options = (options: Options<ServicesV1FrontrunnerV1EligibilityByOrderEndpoint2Data>) => queryOptions<ServicesV1FrontrunnerV1EligibilityByOrderEndpoint2Response, DefaultError, ServicesV1FrontrunnerV1EligibilityByOrderEndpoint2Response, ReturnType<typeof servicesV1FrontrunnerV1EligibilityByOrderEndpoint2QueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await servicesV1FrontrunnerV1EligibilityByOrderEndpoint2({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: servicesV1FrontrunnerV1EligibilityByOrderEndpoint2QueryKey(options)
});

/**
 * Patient Eligibility
 *
 * Check patient eligibility based on an existing order and optional member_id or frhc_id that is already associated with the order
 */
export const servicesV1FrontrunnerV1EligibilityByPatientEndpointMutation = (options?: Partial<Options<ServicesV1FrontrunnerV1EligibilityByPatientEndpointData>>): UseMutationOptions<ServicesV1FrontrunnerV1EligibilityByPatientEndpointResponse, DefaultError, Options<ServicesV1FrontrunnerV1EligibilityByPatientEndpointData>> => {
    const mutationOptions: UseMutationOptions<ServicesV1FrontrunnerV1EligibilityByPatientEndpointResponse, DefaultError, Options<ServicesV1FrontrunnerV1EligibilityByPatientEndpointData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await servicesV1FrontrunnerV1EligibilityByPatientEndpoint({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Prioritized Patient Eligibility
 *
 * Check patient eligibility based on an existing order and optional member_id or frhc_id that is already associated with the order and return prioritized results
 */
export const servicesV1FrontrunnerV1PrioritizedEligibilityByPatientEndpointMutation = (options?: Partial<Options<ServicesV1FrontrunnerV1PrioritizedEligibilityByPatientEndpointData>>): UseMutationOptions<ServicesV1FrontrunnerV1PrioritizedEligibilityByPatientEndpointResponse, DefaultError, Options<ServicesV1FrontrunnerV1PrioritizedEligibilityByPatientEndpointData>> => {
    const mutationOptions: UseMutationOptions<ServicesV1FrontrunnerV1PrioritizedEligibilityByPatientEndpointResponse, DefaultError, Options<ServicesV1FrontrunnerV1PrioritizedEligibilityByPatientEndpointData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await servicesV1FrontrunnerV1PrioritizedEligibilityByPatientEndpoint({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const servicesV1FrontrunnerV1MongoEligibilityEventQueryKey = (options: Options<ServicesV1FrontrunnerV1MongoEligibilityEventData>) => createQueryKey('servicesV1FrontrunnerV1MongoEligibilityEvent', options);

/**
 * Generate Kafka Message to Write FR data to Mongo
 *
 * Generate the message for kafka based on the same output generated by `/eligibility/mongo/source`
 */
export const servicesV1FrontrunnerV1MongoEligibilityEventOptions = (options: Options<ServicesV1FrontrunnerV1MongoEligibilityEventData>) => queryOptions<ServicesV1FrontrunnerV1MongoEligibilityEventResponse, DefaultError, ServicesV1FrontrunnerV1MongoEligibilityEventResponse, ReturnType<typeof servicesV1FrontrunnerV1MongoEligibilityEventQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await servicesV1FrontrunnerV1MongoEligibilityEvent({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: servicesV1FrontrunnerV1MongoEligibilityEventQueryKey(options)
});

export const servicesV1FrontrunnerV1MongoEligibilityEvent2QueryKey = (options: Options<ServicesV1FrontrunnerV1MongoEligibilityEvent2Data>) => createQueryKey('servicesV1FrontrunnerV1MongoEligibilityEvent2', options);

/**
 * Generate Kafka Message to Write FR data to Mongo
 *
 * Generate the message for kafka based on the same output generated by `/eligibility/mongo/source`
 */
export const servicesV1FrontrunnerV1MongoEligibilityEvent2Options = (options: Options<ServicesV1FrontrunnerV1MongoEligibilityEvent2Data>) => queryOptions<ServicesV1FrontrunnerV1MongoEligibilityEvent2Response, DefaultError, ServicesV1FrontrunnerV1MongoEligibilityEvent2Response, ReturnType<typeof servicesV1FrontrunnerV1MongoEligibilityEvent2QueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await servicesV1FrontrunnerV1MongoEligibilityEvent2({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: servicesV1FrontrunnerV1MongoEligibilityEvent2QueryKey(options)
});

export const servicesV1FrontrunnerV1MongoEligibilitySourceQueryKey = (options: Options<ServicesV1FrontrunnerV1MongoEligibilitySourceData>) => createQueryKey('servicesV1FrontrunnerV1MongoEligibilitySource', options);

/**
 * Generate Order eligibility Source
 *
 * Run eligibility for an order and return the source data used to create the frontrunner_eligibility event
 */
export const servicesV1FrontrunnerV1MongoEligibilitySourceOptions = (options: Options<ServicesV1FrontrunnerV1MongoEligibilitySourceData>) => queryOptions<ServicesV1FrontrunnerV1MongoEligibilitySourceResponse, DefaultError, ServicesV1FrontrunnerV1MongoEligibilitySourceResponse, ReturnType<typeof servicesV1FrontrunnerV1MongoEligibilitySourceQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await servicesV1FrontrunnerV1MongoEligibilitySource({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: servicesV1FrontrunnerV1MongoEligibilitySourceQueryKey(options)
});

export const servicesV1FrontrunnerV1MongoEligibilitySource2QueryKey = (options: Options<ServicesV1FrontrunnerV1MongoEligibilitySource2Data>) => createQueryKey('servicesV1FrontrunnerV1MongoEligibilitySource2', options);

/**
 * Generate Order eligibility Source
 *
 * Run eligibility for an order and return the source data used to create the frontrunner_eligibility event
 */
export const servicesV1FrontrunnerV1MongoEligibilitySource2Options = (options: Options<ServicesV1FrontrunnerV1MongoEligibilitySource2Data>) => queryOptions<ServicesV1FrontrunnerV1MongoEligibilitySource2Response, DefaultError, ServicesV1FrontrunnerV1MongoEligibilitySource2Response, ReturnType<typeof servicesV1FrontrunnerV1MongoEligibilitySource2QueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await servicesV1FrontrunnerV1MongoEligibilitySource2({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: servicesV1FrontrunnerV1MongoEligibilitySource2QueryKey(options)
});

export const servicesV1FrontrunnerV1HeartbeatQueryKey = (options?: Options<ServicesV1FrontrunnerV1HeartbeatData>) => createQueryKey('servicesV1FrontrunnerV1Heartbeat', options);

/**
 * Heartbeat
 *
 * Base validation for the heartbeat endpoint
 */
export const servicesV1FrontrunnerV1HeartbeatOptions = (options?: Options<ServicesV1FrontrunnerV1HeartbeatData>) => queryOptions<ServicesV1FrontrunnerV1HeartbeatResponse, DefaultError, ServicesV1FrontrunnerV1HeartbeatResponse, ReturnType<typeof servicesV1FrontrunnerV1HeartbeatQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await servicesV1FrontrunnerV1Heartbeat({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: servicesV1FrontrunnerV1HeartbeatQueryKey(options)
});

export const servicesV1FrontrunnerV1MockDiscoveryMutation = (options?: Partial<Options<ServicesV1FrontrunnerV1MockDiscoveryData>>): UseMutationOptions<ServicesV1FrontrunnerV1MockDiscoveryResponse, DefaultError, Options<ServicesV1FrontrunnerV1MockDiscoveryData>> => {
    const mutationOptions: UseMutationOptions<ServicesV1FrontrunnerV1MockDiscoveryResponse, DefaultError, Options<ServicesV1FrontrunnerV1MockDiscoveryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await servicesV1FrontrunnerV1MockDiscovery({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const servicesV1HeartbeatQueryKey = (options?: Options<ServicesV1HeartbeatData>) => createQueryKey('servicesV1Heartbeat', options);

/**
 * Heartbeat
 *
 * Base validation for the heartbeat endpoint
 */
export const servicesV1HeartbeatOptions = (options?: Options<ServicesV1HeartbeatData>) => queryOptions<ServicesV1HeartbeatResponse, DefaultError, ServicesV1HeartbeatResponse, ReturnType<typeof servicesV1HeartbeatQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await servicesV1Heartbeat({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: servicesV1HeartbeatQueryKey(options)
});

export const servicesV1HubspotV1ContactsQueryKey = (options?: Options<ServicesV1HubspotV1ContactsData>) => createQueryKey('servicesV1HubspotV1Contacts', options);

/**
 * Retrieve Contact Data
 *
 * Retrieve a list of contacts
 */
export const servicesV1HubspotV1ContactsOptions = (options?: Options<ServicesV1HubspotV1ContactsData>) => queryOptions<ServicesV1HubspotV1ContactsResponse, DefaultError, ServicesV1HubspotV1ContactsResponse, ReturnType<typeof servicesV1HubspotV1ContactsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await servicesV1HubspotV1Contacts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: servicesV1HubspotV1ContactsQueryKey(options)
});

export const servicesV1HubspotV1ContactsInfiniteQueryKey = (options?: Options<ServicesV1HubspotV1ContactsData>): QueryKey<Options<ServicesV1HubspotV1ContactsData>> => createQueryKey('servicesV1HubspotV1Contacts', options, true);

/**
 * Retrieve Contact Data
 *
 * Retrieve a list of contacts
 */
export const servicesV1HubspotV1ContactsInfiniteOptions = (options?: Options<ServicesV1HubspotV1ContactsData>) => infiniteQueryOptions<ServicesV1HubspotV1ContactsResponse, DefaultError, InfiniteData<ServicesV1HubspotV1ContactsResponse>, QueryKey<Options<ServicesV1HubspotV1ContactsData>>, number | Pick<QueryKey<Options<ServicesV1HubspotV1ContactsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ServicesV1HubspotV1ContactsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await servicesV1HubspotV1Contacts({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: servicesV1HubspotV1ContactsInfiniteQueryKey(options)
});

export const servicesV1HubspotV1IngestContactsMutation = (options?: Partial<Options<ServicesV1HubspotV1IngestContactsData>>): UseMutationOptions<ServicesV1HubspotV1IngestContactsResponse, DefaultError, Options<ServicesV1HubspotV1IngestContactsData>> => {
    const mutationOptions: UseMutationOptions<ServicesV1HubspotV1IngestContactsResponse, DefaultError, Options<ServicesV1HubspotV1IngestContactsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await servicesV1HubspotV1IngestContacts({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const servicesV1HubspotV1HeartbeatQueryKey = (options?: Options<ServicesV1HubspotV1HeartbeatData>) => createQueryKey('servicesV1HubspotV1Heartbeat', options);

/**
 * Heartbeat
 *
 * Base validation for the heartbeat endpoint
 */
export const servicesV1HubspotV1HeartbeatOptions = (options?: Options<ServicesV1HubspotV1HeartbeatData>) => queryOptions<ServicesV1HubspotV1HeartbeatResponse, DefaultError, ServicesV1HubspotV1HeartbeatResponse, ReturnType<typeof servicesV1HubspotV1HeartbeatQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await servicesV1HubspotV1Heartbeat({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: servicesV1HubspotV1HeartbeatQueryKey(options)
});

export const servicesV1HubspotV1OrdersQueryKey = (options?: Options<ServicesV1HubspotV1OrdersData>) => createQueryKey('servicesV1HubspotV1Orders', options);

/**
 * Retrieve Order Data
 *
 * Retrieve a list of orders
 */
export const servicesV1HubspotV1OrdersOptions = (options?: Options<ServicesV1HubspotV1OrdersData>) => queryOptions<ServicesV1HubspotV1OrdersResponse, DefaultError, ServicesV1HubspotV1OrdersResponse, ReturnType<typeof servicesV1HubspotV1OrdersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await servicesV1HubspotV1Orders({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: servicesV1HubspotV1OrdersQueryKey(options)
});

export const servicesV1HubspotV1OrdersInfiniteQueryKey = (options?: Options<ServicesV1HubspotV1OrdersData>): QueryKey<Options<ServicesV1HubspotV1OrdersData>> => createQueryKey('servicesV1HubspotV1Orders', options, true);

/**
 * Retrieve Order Data
 *
 * Retrieve a list of orders
 */
export const servicesV1HubspotV1OrdersInfiniteOptions = (options?: Options<ServicesV1HubspotV1OrdersData>) => infiniteQueryOptions<ServicesV1HubspotV1OrdersResponse, DefaultError, InfiniteData<ServicesV1HubspotV1OrdersResponse>, QueryKey<Options<ServicesV1HubspotV1OrdersData>>, number | Pick<QueryKey<Options<ServicesV1HubspotV1OrdersData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ServicesV1HubspotV1OrdersData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await servicesV1HubspotV1Orders({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: servicesV1HubspotV1OrdersInfiniteQueryKey(options)
});

export const servicesV1HubspotV1IngestOrdersMutation = (options?: Partial<Options<ServicesV1HubspotV1IngestOrdersData>>): UseMutationOptions<ServicesV1HubspotV1IngestOrdersResponse, DefaultError, Options<ServicesV1HubspotV1IngestOrdersData>> => {
    const mutationOptions: UseMutationOptions<ServicesV1HubspotV1IngestOrdersResponse, DefaultError, Options<ServicesV1HubspotV1IngestOrdersData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await servicesV1HubspotV1IngestOrders({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const servicesV1HubspotV1ProductsQueryKey = (options?: Options<ServicesV1HubspotV1ProductsData>) => createQueryKey('servicesV1HubspotV1Products', options);

/**
 * Retrieve Product Data
 *
 * Retrieve a list of products
 */
export const servicesV1HubspotV1ProductsOptions = (options?: Options<ServicesV1HubspotV1ProductsData>) => queryOptions<ServicesV1HubspotV1ProductsResponse, DefaultError, ServicesV1HubspotV1ProductsResponse, ReturnType<typeof servicesV1HubspotV1ProductsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await servicesV1HubspotV1Products({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: servicesV1HubspotV1ProductsQueryKey(options)
});

export const servicesV1HubspotV1ProductsInfiniteQueryKey = (options?: Options<ServicesV1HubspotV1ProductsData>): QueryKey<Options<ServicesV1HubspotV1ProductsData>> => createQueryKey('servicesV1HubspotV1Products', options, true);

/**
 * Retrieve Product Data
 *
 * Retrieve a list of products
 */
export const servicesV1HubspotV1ProductsInfiniteOptions = (options?: Options<ServicesV1HubspotV1ProductsData>) => infiniteQueryOptions<ServicesV1HubspotV1ProductsResponse, DefaultError, InfiniteData<ServicesV1HubspotV1ProductsResponse>, QueryKey<Options<ServicesV1HubspotV1ProductsData>>, number | Pick<QueryKey<Options<ServicesV1HubspotV1ProductsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ServicesV1HubspotV1ProductsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await servicesV1HubspotV1Products({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: servicesV1HubspotV1ProductsInfiniteQueryKey(options)
});

/**
 * MCP-authorized route to send a reply to an Intercom conversation.
 */
export const servicesV1IntercomV1IntercomSendReplyMutation = (options?: Partial<Options<ServicesV1IntercomV1IntercomSendReplyData>>): UseMutationOptions<ServicesV1IntercomV1IntercomSendReplyResponse, DefaultError, Options<ServicesV1IntercomV1IntercomSendReplyData>> => {
    const mutationOptions: UseMutationOptions<ServicesV1IntercomV1IntercomSendReplyResponse, DefaultError, Options<ServicesV1IntercomV1IntercomSendReplyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await servicesV1IntercomV1IntercomSendReply({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const servicesV1LuminaV1HeartbeatQueryKey = (options?: Options<ServicesV1LuminaV1HeartbeatData>) => createQueryKey('servicesV1LuminaV1Heartbeat', options);

/**
 * Heartbeat
 *
 * Base validation for the heartbeat endpoint
 */
export const servicesV1LuminaV1HeartbeatOptions = (options?: Options<ServicesV1LuminaV1HeartbeatData>) => queryOptions<ServicesV1LuminaV1HeartbeatResponse, DefaultError, ServicesV1LuminaV1HeartbeatResponse, ReturnType<typeof servicesV1LuminaV1HeartbeatQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await servicesV1LuminaV1Heartbeat({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: servicesV1LuminaV1HeartbeatQueryKey(options)
});

export const servicesV1LuminaV1SubmitOrderQueryKey = (options: Options<ServicesV1LuminaV1SubmitOrderData>) => createQueryKey('servicesV1LuminaV1SubmitOrder', options);

/**
 * Order Submission to Lumina
 *
 * Kickoff Order Submission to Lumina Data
 */
export const servicesV1LuminaV1SubmitOrderOptions = (options: Options<ServicesV1LuminaV1SubmitOrderData>) => queryOptions<ServicesV1LuminaV1SubmitOrderResponse, DefaultError, ServicesV1LuminaV1SubmitOrderResponse, ReturnType<typeof servicesV1LuminaV1SubmitOrderQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await servicesV1LuminaV1SubmitOrder({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: servicesV1LuminaV1SubmitOrderQueryKey(options)
});

/**
 * Accept Medline's daily shipment tracking report and queue it for ingestion.
 *
 * The report is archived to S3 and handed to a Celery task, so the caller gets a
 * ``202`` without waiting on the parse. The file arrives base64-encoded in the JSON
 * body, whose exact raw bytes the signature covers.
 *
 * Ingestion is idempotent, so re-pushing the same report is safe.
 */
export const servicesV1MedlineV1PostShipmentReportMutation = (options?: Partial<Options<ServicesV1MedlineV1PostShipmentReportData>>): UseMutationOptions<ServicesV1MedlineV1PostShipmentReportResponse, DefaultError, Options<ServicesV1MedlineV1PostShipmentReportData>> => {
    const mutationOptions: UseMutationOptions<ServicesV1MedlineV1PostShipmentReportResponse, DefaultError, Options<ServicesV1MedlineV1PostShipmentReportData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await servicesV1MedlineV1PostShipmentReport({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const servicesV1SlackV1SlackPostMutation = (options?: Partial<Options<ServicesV1SlackV1SlackPostData>>): UseMutationOptions<ServicesV1SlackV1SlackPostResponse, DefaultError, Options<ServicesV1SlackV1SlackPostData>> => {
    const mutationOptions: UseMutationOptions<ServicesV1SlackV1SlackPostResponse, DefaultError, Options<ServicesV1SlackV1SlackPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await servicesV1SlackV1SlackPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const suppliersV1GetAllSuppliersQueryKey = (options?: Options<SuppliersV1GetAllSuppliersData>) => createQueryKey('suppliersV1GetAllSuppliers', options);

/**
 * Get all Suppliers
 */
export const suppliersV1GetAllSuppliersOptions = (options?: Options<SuppliersV1GetAllSuppliersData>) => queryOptions<SuppliersV1GetAllSuppliersResponse, DefaultError, SuppliersV1GetAllSuppliersResponse, ReturnType<typeof suppliersV1GetAllSuppliersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await suppliersV1GetAllSuppliers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: suppliersV1GetAllSuppliersQueryKey(options)
});

export const suppliersV1DetailsQueryKey = (options: Options<SuppliersV1DetailsData>) => createQueryKey('suppliersV1Details', options);

/**
 * Details
 *
 * Retrieve the extended Supplier record by uuid
 */
export const suppliersV1DetailsOptions = (options: Options<SuppliersV1DetailsData>) => queryOptions<SuppliersV1DetailsResponse, DefaultError, SuppliersV1DetailsResponse, ReturnType<typeof suppliersV1DetailsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await suppliersV1Details({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: suppliersV1DetailsQueryKey(options)
});

export const suppliersV1HeartbeatQueryKey = (options?: Options<SuppliersV1HeartbeatData>) => createQueryKey('suppliersV1Heartbeat', options);

/**
 * Heartbeat
 *
 * Base validation for the heartbeat endpoint
 */
export const suppliersV1HeartbeatOptions = (options?: Options<SuppliersV1HeartbeatData>) => queryOptions<SuppliersV1HeartbeatResponse, DefaultError, SuppliersV1HeartbeatResponse, ReturnType<typeof suppliersV1HeartbeatQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await suppliersV1Heartbeat({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: suppliersV1HeartbeatQueryKey(options)
});

export const suppliersV1SearchQueryKey = (options?: Options<SuppliersV1SearchData>) => createQueryKey('suppliersV1Search', options);

/**
 * Search
 *
 * Retrieve list of records by query term and/or template type (Medicaid/Medicare)
 */
export const suppliersV1SearchOptions = (options?: Options<SuppliersV1SearchData>) => queryOptions<SuppliersV1SearchResponse, DefaultError, SuppliersV1SearchResponse, ReturnType<typeof suppliersV1SearchQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await suppliersV1Search({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: suppliersV1SearchQueryKey(options)
});

export const suppliersV1SearchInfiniteQueryKey = (options?: Options<SuppliersV1SearchData>): QueryKey<Options<SuppliersV1SearchData>> => createQueryKey('suppliersV1Search', options, true);

/**
 * Search
 *
 * Retrieve list of records by query term and/or template type (Medicaid/Medicare)
 */
export const suppliersV1SearchInfiniteOptions = (options?: Options<SuppliersV1SearchData>) => infiniteQueryOptions<SuppliersV1SearchResponse, DefaultError, InfiniteData<SuppliersV1SearchResponse>, QueryKey<Options<SuppliersV1SearchData>>, number | Pick<QueryKey<Options<SuppliersV1SearchData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<SuppliersV1SearchData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await suppliersV1Search({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: suppliersV1SearchInfiniteQueryKey(options)
});

export const suppliersV1Search2QueryKey = (options: Options<SuppliersV1Search2Data>) => createQueryKey('suppliersV1Search2', options);

/**
 * Search
 *
 * Retrieve list of records by query term and/or template type (Medicaid/Medicare)
 */
export const suppliersV1Search2Options = (options: Options<SuppliersV1Search2Data>) => queryOptions<SuppliersV1Search2Response, DefaultError, SuppliersV1Search2Response, ReturnType<typeof suppliersV1Search2QueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await suppliersV1Search2({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: suppliersV1Search2QueryKey(options)
});

export const suppliersV1Search2InfiniteQueryKey = (options: Options<SuppliersV1Search2Data>): QueryKey<Options<SuppliersV1Search2Data>> => createQueryKey('suppliersV1Search2', options, true);

/**
 * Search
 *
 * Retrieve list of records by query term and/or template type (Medicaid/Medicare)
 */
export const suppliersV1Search2InfiniteOptions = (options: Options<SuppliersV1Search2Data>) => infiniteQueryOptions<SuppliersV1Search2Response, DefaultError, InfiniteData<SuppliersV1Search2Response>, QueryKey<Options<SuppliersV1Search2Data>>, number | Pick<QueryKey<Options<SuppliersV1Search2Data>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<SuppliersV1Search2Data>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await suppliersV1Search2({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: suppliersV1Search2InfiniteQueryKey(options)
});

export const systemV1AggregateLegacyContactsQueryKey = (options?: Options<SystemV1AggregateLegacyContactsData>) => createQueryKey('systemV1AggregateLegacyContacts', options);

/**
 * Sync Aggregate Legacy Contacts
 *
 * Regenerate contents of AggregateLegacyContacts Table
 */
export const systemV1AggregateLegacyContactsOptions = (options?: Options<SystemV1AggregateLegacyContactsData>) => queryOptions<SystemV1AggregateLegacyContactsResponse, DefaultError, SystemV1AggregateLegacyContactsResponse, ReturnType<typeof systemV1AggregateLegacyContactsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await systemV1AggregateLegacyContacts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: systemV1AggregateLegacyContactsQueryKey(options)
});

export const systemV1AnalyzeProgressNoteRouteMutation = (options?: Partial<Options<SystemV1AnalyzeProgressNoteRouteData>>): UseMutationOptions<SystemV1AnalyzeProgressNoteRouteResponse, DefaultError, Options<SystemV1AnalyzeProgressNoteRouteData>> => {
    const mutationOptions: UseMutationOptions<SystemV1AnalyzeProgressNoteRouteResponse, DefaultError, Options<SystemV1AnalyzeProgressNoteRouteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await systemV1AnalyzeProgressNoteRoute({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const systemV1AxiomStatusQueryKey = (options?: Options<SystemV1AxiomStatusData>) => createQueryKey('systemV1AxiomStatus', options);

/**
 * Axiom Bot Status
 *
 * Query the bot's status endpoint
 */
export const systemV1AxiomStatusOptions = (options?: Options<SystemV1AxiomStatusData>) => queryOptions<SystemV1AxiomStatusResponse, DefaultError, SystemV1AxiomStatusResponse, ReturnType<typeof systemV1AxiomStatusQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await systemV1AxiomStatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: systemV1AxiomStatusQueryKey(options)
});

export const systemV1BackfillAftershipShipmentsRouteQueryKey = (options?: Options<SystemV1BackfillAftershipShipmentsRouteData>) => createQueryKey('systemV1BackfillAftershipShipmentsRoute', options);

/**
 * Backfill the ``shipments`` table from a full AfterShip pull.
 *
 * Celery task pages through every AfterShip tracking, correlates each to an
 * order via its purchase-order number, and upserts into ``shipments`` (idempotent
 * on ``source`` + ``source_shipment_id``). Safe to re-run; removable once it has
 * run per env. Not gated by ``AFTERSHIP_SYNC_ENABLED``; requires
 * ``AFTERSHIP_API_KEY``.
 *
 * Query params (optional):
 * single_batch: if truthy (e.g. ?single_batch=1), run only one batch.
 * batch_size: positive integer batch size (default 500).
 */
export const systemV1BackfillAftershipShipmentsRouteOptions = (options?: Options<SystemV1BackfillAftershipShipmentsRouteData>) => queryOptions<SystemV1BackfillAftershipShipmentsRouteResponse, DefaultError, SystemV1BackfillAftershipShipmentsRouteResponse, ReturnType<typeof systemV1BackfillAftershipShipmentsRouteQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await systemV1BackfillAftershipShipmentsRoute({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: systemV1BackfillAftershipShipmentsRouteQueryKey(options)
});

export const systemV1BackfillFulfillmentHcpcsCodesRouteQueryKey = (options?: Options<SystemV1BackfillFulfillmentHcpcsCodesRouteData>) => createQueryKey('systemV1BackfillFulfillmentHcpcsCodesRoute', options);

/**
 * Backfill empty ``fulfillments.hcpcs_code_uuid`` from each fee schedule.
 *
 * Celery task reads fulfillments in batches where ``hcpcs_code_uuid`` is null
 * and a ``fee_schedule_uuid`` is set, then copies the fee schedule's
 * ``code_uuid`` onto the fulfillment.
 *
 * Query params (optional):
 * single_batch: if truthy (e.g. ?single_batch=1), run only one batch.
 * batch_size: positive integer batch size (default 500).
 */
export const systemV1BackfillFulfillmentHcpcsCodesRouteOptions = (options?: Options<SystemV1BackfillFulfillmentHcpcsCodesRouteData>) => queryOptions<SystemV1BackfillFulfillmentHcpcsCodesRouteResponse, DefaultError, SystemV1BackfillFulfillmentHcpcsCodesRouteResponse, ReturnType<typeof systemV1BackfillFulfillmentHcpcsCodesRouteQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await systemV1BackfillFulfillmentHcpcsCodesRoute({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: systemV1BackfillFulfillmentHcpcsCodesRouteQueryKey(options)
});

/**
 * Stamp CareOS ``plan_uuid`` onto Mongo order insurance from CareOS Plan
 *
 * lookup by ``frhc_id`` + state + plan_type + name/alias.
 *
 * Only non-final / pre-billing orders (excludes ``DONE`` / ``CANCELLED`` /
 * ``ERROR`` / ``BILLING``).
 *
 * General run (omit ``frhc_ids`` and ``stedi_ids``): active orders with a
 * FrontRunner id (``frhc_id``, or if that is empty, ``trading_partner_id``) or a
 * Stedi payer id. Stamps mapped carriers and clears stale ``plan_uuid`` stamps.
 *
 * Scoped run (``frhc_ids`` and/or ``stedi_ids`` set): refresh slots for those
 * clearinghouse payer ids after a CareOS Plan mapping change.
 *
 * Pass ``{"dry_run": true}`` to count matches without writing. Pass
 * ``{"single_batch": true, "batch_size": 1000}`` to process one chunk then stop.
 * Always enqueues the Celery task (including dry runs) and returns
 * ``{"task_id": "..."}`` with 202.
 */
export const systemV1BackfillInsurancePlanUuidRouteMutation = (options?: Partial<Options<SystemV1BackfillInsurancePlanUuidRouteData>>): UseMutationOptions<SystemV1BackfillInsurancePlanUuidRouteResponse, DefaultError, Options<SystemV1BackfillInsurancePlanUuidRouteData>> => {
    const mutationOptions: UseMutationOptions<SystemV1BackfillInsurancePlanUuidRouteResponse, DefaultError, Options<SystemV1BackfillInsurancePlanUuidRouteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await systemV1BackfillInsurancePlanUuidRoute({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const systemV1ClearAxiomQueryKey = (options: Options<SystemV1ClearAxiomData>) => createQueryKey('systemV1ClearAxiom', options);

/**
 * Clear Axiom Mutex
 *
 * Clear the Axiom Mutex if it is equal to a specific Order #
 */
export const systemV1ClearAxiomOptions = (options: Options<SystemV1ClearAxiomData>) => queryOptions<SystemV1ClearAxiomResponse, DefaultError, SystemV1ClearAxiomResponse, ReturnType<typeof systemV1ClearAxiomQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await systemV1ClearAxiom({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: systemV1ClearAxiomQueryKey(options)
});

/**
 * Queue conversion events for server-side attribution tracking.
 */
export const systemV1MessageConversionEventsMutation = (options?: Partial<Options<SystemV1MessageConversionEventsData>>): UseMutationOptions<SystemV1MessageConversionEventsResponse, DefaultError, Options<SystemV1MessageConversionEventsData>> => {
    const mutationOptions: UseMutationOptions<SystemV1MessageConversionEventsResponse, DefaultError, Options<SystemV1MessageConversionEventsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await systemV1MessageConversionEvents({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const systemV1CurrentAxiomQueryKey = (options?: Options<SystemV1CurrentAxiomData>) => createQueryKey('systemV1CurrentAxiom', options);

/**
 * Current Axiom Mutex
 *
 * Display the contents of the current axiom mutex
 */
export const systemV1CurrentAxiomOptions = (options?: Options<SystemV1CurrentAxiomData>) => queryOptions<SystemV1CurrentAxiomResponse, DefaultError, SystemV1CurrentAxiomResponse, ReturnType<typeof systemV1CurrentAxiomQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await systemV1CurrentAxiom({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: systemV1CurrentAxiomQueryKey(options)
});

export const systemV1DisableCurrentAxiomOrderQueryKey = (options: Options<SystemV1DisableCurrentAxiomOrderData>) => createQueryKey('systemV1DisableCurrentAxiomOrder', options);

/**
 * Disable Current Axiom Order
 *
 * Disable the current axiom order and clear the mutex
 */
export const systemV1DisableCurrentAxiomOrderOptions = (options: Options<SystemV1DisableCurrentAxiomOrderData>) => queryOptions<SystemV1DisableCurrentAxiomOrderResponse, DefaultError, SystemV1DisableCurrentAxiomOrderResponse, ReturnType<typeof systemV1DisableCurrentAxiomOrderQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await systemV1DisableCurrentAxiomOrder({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: systemV1DisableCurrentAxiomOrderQueryKey(options)
});

export const systemV1EpacesQueryKey = (options?: Options<SystemV1EpacesData>) => createQueryKey('systemV1Epaces', options);

/**
 * EPaces
 *
 * Display the contents of an epaces form
 */
export const systemV1EpacesOptions = (options?: Options<SystemV1EpacesData>) => queryOptions<SystemV1EpacesResponse, DefaultError, SystemV1EpacesResponse, ReturnType<typeof systemV1EpacesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await systemV1Epaces({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: systemV1EpacesQueryKey(options)
});

export const systemV1FailedFulfillmentResupplyQueryKey = (options: Options<SystemV1FailedFulfillmentResupplyData>) => createQueryKey('systemV1FailedFulfillmentResupply', options);

/**
 * Failed Fulfillment / Resupply Diagnostic
 *
 * Lists orders from order_confirmation_gate-enabled suppliers that are in a
 * qualifying status, have no resupply order, and failed to resupply due to
 * fulfillment misconfiguration.
 *
 * Query params:
 * created_after (required, YYYY-MM-DD): Lower bound for order creation date.
 * created_before (required, YYYY-MM-DD): Upper bound for order creation date.
 *
 * Failure classes per order:
 * missing_hcpc: item(s) with empty hcpc_code.
 * unknown_hcpc: item HCPC label not found in the PG codes table.
 * no_fee_schedule: HCPC known but no fee schedule attached.
 * missing_icd: item(s) with empty icds.
 * unknown_failure: no PG fulfillments and items appear configured.
 * missing_shipping_address: shipping address missing required fields for Candid submission.
 */
export const systemV1FailedFulfillmentResupplyOptions = (options: Options<SystemV1FailedFulfillmentResupplyData>) => queryOptions<SystemV1FailedFulfillmentResupplyResponse, DefaultError, SystemV1FailedFulfillmentResupplyResponse, ReturnType<typeof systemV1FailedFulfillmentResupplyQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await systemV1FailedFulfillmentResupply({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: systemV1FailedFulfillmentResupplyQueryKey(options)
});

export const systemV1GenerateLomnRouteMutation = (options?: Partial<Options<SystemV1GenerateLomnRouteData>>): UseMutationOptions<SystemV1GenerateLomnRouteResponse, DefaultError, Options<SystemV1GenerateLomnRouteData>> => {
    const mutationOptions: UseMutationOptions<SystemV1GenerateLomnRouteResponse, DefaultError, Options<SystemV1GenerateLomnRouteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await systemV1GenerateLomnRoute({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const systemV1HeartbeatQueryKey = (options?: Options<SystemV1HeartbeatData>) => createQueryKey('systemV1Heartbeat', options);

/**
 * Heartbeat
 *
 * Base validation for the heartbeat endpoint
 */
export const systemV1HeartbeatOptions = (options?: Options<SystemV1HeartbeatData>) => queryOptions<SystemV1HeartbeatResponse, DefaultError, SystemV1HeartbeatResponse, ReturnType<typeof systemV1HeartbeatQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await systemV1Heartbeat({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: systemV1HeartbeatQueryKey(options)
});

/**
 * Generate Kafka Message
 *
 * Generate an arbitrary message to the indicated topic
 */
export const systemV1ProduceMessageMutation = (options?: Partial<Options<SystemV1ProduceMessageData>>): UseMutationOptions<SystemV1ProduceMessageResponse, DefaultError, Options<SystemV1ProduceMessageData>> => {
    const mutationOptions: UseMutationOptions<SystemV1ProduceMessageResponse, DefaultError, Options<SystemV1ProduceMessageData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await systemV1ProduceMessage({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const systemV1LomnHistoryQueryKey = (options: Options<SystemV1LomnHistoryData>) => createQueryKey('systemV1LomnHistory', options);

export const systemV1LomnHistoryOptions = (options: Options<SystemV1LomnHistoryData>) => queryOptions<SystemV1LomnHistoryResponse, DefaultError, SystemV1LomnHistoryResponse, ReturnType<typeof systemV1LomnHistoryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await systemV1LomnHistory({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: systemV1LomnHistoryQueryKey(options)
});

export const systemV1LomnPdfMutation = (options?: Partial<Options<SystemV1LomnPdfData>>): UseMutationOptions<SystemV1LomnPdfResponse, DefaultError, Options<SystemV1LomnPdfData>> => {
    const mutationOptions: UseMutationOptions<SystemV1LomnPdfResponse, DefaultError, Options<SystemV1LomnPdfData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await systemV1LomnPdf({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Repopulate all LOMN requirement tables from the PRODUCT_REQUIREMENTS dict.
 *
 * Blocked when LOMN_REQUIREMENTS_FROM_DB=True to prevent overwriting
 * live DB-managed data after flag cutover.
 */
export const systemV1LomnRequirementsPopulateMutation = (options?: Partial<Options<SystemV1LomnRequirementsPopulateData>>): UseMutationOptions<SystemV1LomnRequirementsPopulateResponse, DefaultError, Options<SystemV1LomnRequirementsPopulateData>> => {
    const mutationOptions: UseMutationOptions<SystemV1LomnRequirementsPopulateResponse, DefaultError, Options<SystemV1LomnRequirementsPopulateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await systemV1LomnRequirementsPopulate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const systemV1LomnRequirementsQueryKey = (options: Options<SystemV1LomnRequirementsData>) => createQueryKey('systemV1LomnRequirements', options);

export const systemV1LomnRequirementsOptions = (options: Options<SystemV1LomnRequirementsData>) => queryOptions<SystemV1LomnRequirementsResponse, DefaultError, SystemV1LomnRequirementsResponse, ReturnType<typeof systemV1LomnRequirementsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await systemV1LomnRequirements({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: systemV1LomnRequirementsQueryKey(options)
});

/**
 * Migrate one legacy MySQL patient and related data into Postgres.
 */
export const systemV1MigrateLegacyPatientRouteMutation = (options?: Partial<Options<SystemV1MigrateLegacyPatientRouteData>>): UseMutationOptions<SystemV1MigrateLegacyPatientRouteResponse, DefaultError, Options<SystemV1MigrateLegacyPatientRouteData>> => {
    const mutationOptions: UseMutationOptions<SystemV1MigrateLegacyPatientRouteResponse, DefaultError, Options<SystemV1MigrateLegacyPatientRouteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await systemV1MigrateLegacyPatientRoute({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Migrate one Mongo order's missing ancestry, then remigrate the child.
 *
 * This explicit repair endpoint keeps ancestry traversal out of the normal
 * batch and ad hoc migration paths.
 */
export const systemV1MigrateMongoOrderAncestryMutation = (options?: Partial<Options<SystemV1MigrateMongoOrderAncestryData>>): UseMutationOptions<SystemV1MigrateMongoOrderAncestryResponse, DefaultError, Options<SystemV1MigrateMongoOrderAncestryData>> => {
    const mutationOptions: UseMutationOptions<SystemV1MigrateMongoOrderAncestryResponse, DefaultError, Options<SystemV1MigrateMongoOrderAncestryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await systemV1MigrateMongoOrderAncestry({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const systemV1MigrateMongoOrdersRouteQueryKey = (options?: Options<SystemV1MigrateMongoOrdersRouteData>) => createQueryKey('systemV1MigrateMongoOrdersRoute', options);

/**
 * Migrate Mongo orders into Postgres orders bind tables.
 *
 * Celery task reads legacy Mongo orders in batches, inserts into ``orders`` (and
 * related physician / address rows). Skips rows already present (unique
 * ``orders.legacy_id``).
 *
 * Query params (optional):
 * single_batch: if truthy (e.g. ?single_batch=1), run only one batch of 500.
 * starting_mongo_order_id: integer; first batch loads Mongo orders with
 * ``order_id >=`` this value, then continues in batches of 500 by ascending id.
 */
export const systemV1MigrateMongoOrdersRouteOptions = (options?: Options<SystemV1MigrateMongoOrdersRouteData>) => queryOptions<SystemV1MigrateMongoOrdersRouteResponse, DefaultError, SystemV1MigrateMongoOrdersRouteResponse, ReturnType<typeof systemV1MigrateMongoOrdersRouteQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await systemV1MigrateMongoOrdersRoute({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: systemV1MigrateMongoOrdersRouteQueryKey(options)
});

export const systemV1MongoHealthQueryKey = (options?: Options<SystemV1MongoHealthData>) => createQueryKey('systemV1MongoHealth', options);

export const systemV1MongoHealthOptions = (options?: Options<SystemV1MongoHealthData>) => queryOptions<SystemV1MongoHealthResponse, DefaultError, SystemV1MongoHealthResponse, ReturnType<typeof systemV1MongoHealthQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await systemV1MongoHealth({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: systemV1MongoHealthQueryKey(options)
});

export const systemV1OrdersMissingOtQueryKey = (options: Options<SystemV1OrdersMissingOtData>) => createQueryKey('systemV1OrdersMissingOt', options);

/**
 * Missing Order Transition Diagnostic
 *
 * Lists orders from order_confirmation_gate-enabled suppliers that are in a
 * qualifying resupply status, have no resupply_order, and are missing a
 * PostgreSQL OrderTransition record. These represent data-integrity gaps
 * where Mongo shows a shipped/billed order but the PG fulfillment pipeline
 * lost or never created the OT. The resupply task returns UNCONFIRMED ORDER
 * for these until the OT is backfilled.
 *
 * Query params:
 * created_after (required, YYYY-MM-DD): Lower bound for order creation date.
 * created_before (required, YYYY-MM-DD): Upper bound for order creation date.
 */
export const systemV1OrdersMissingOtOptions = (options: Options<SystemV1OrdersMissingOtData>) => queryOptions<SystemV1OrdersMissingOtResponse, DefaultError, SystemV1OrdersMissingOtResponse, ReturnType<typeof systemV1OrdersMissingOtQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await systemV1OrdersMissingOt({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: systemV1OrdersMissingOtQueryKey(options)
});

export const systemV1PdfReaderMutation = (options?: Partial<Options<SystemV1PdfReaderData>>): UseMutationOptions<SystemV1PdfReaderResponse, DefaultError, Options<SystemV1PdfReaderData>> => {
    const mutationOptions: UseMutationOptions<SystemV1PdfReaderResponse, DefaultError, Options<SystemV1PdfReaderData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await systemV1PdfReader({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Move CONTACTING_PATIENT orders to CONFIRM_ORDER if they pass the auth gate.
 *
 * For each order ID the Celery task will:
 * 1. Load the order and verify status is CONTACTING_PATIENT.
 * 2. Check the auth gate (same logic as validate_resupply):
 * - Must have a valid e-signature / prescription.
 * - Embargo date must be before prescription expiration.
 * 3. Transition CONTACTING_PATIENT → PROCESSING → CONFIRM_ORDER.
 *
 * Orders are chunked into batches of 100 and dispatched as async Celery
 * tasks. Each task result is a dict::
 *
 * {"succeeded": [...], "failed": {...}, "ignored": {...}}
 *
 * JSON body:
 * order_ids: list of integer order IDs (min 1, no upper cap).
 */
export const systemV1PromoteToConfirmOrderMutation = (options?: Partial<Options<SystemV1PromoteToConfirmOrderData>>): UseMutationOptions<SystemV1PromoteToConfirmOrderResponse, DefaultError, Options<SystemV1PromoteToConfirmOrderData>> => {
    const mutationOptions: UseMutationOptions<SystemV1PromoteToConfirmOrderResponse, DefaultError, Options<SystemV1PromoteToConfirmOrderData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await systemV1PromoteToConfirmOrder({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Force-re-run insurance discovery for the given orders.
 *
 * Each order is enqueued as its own Celery task that runs the same
 * ``process_order_discovery`` (force=True) the ``/insurance/v3/orders/<id>/discover``
 * endpoint uses, but from a worker — so ChangeLog writes are attributed to
 * ``"system"`` and manually-verified slots are preserved. At most 100 ids per
 * request; chunk larger backfills across calls.
 *
 * JSON body:
 * order_ids: required list of Mongo order ids, e.g. ``{"order_ids": [1, 2, 3]}``.
 */
export const systemV1RerunInsuranceDiscoveryMutation = (options?: Partial<Options<SystemV1RerunInsuranceDiscoveryData>>): UseMutationOptions<SystemV1RerunInsuranceDiscoveryResponse, DefaultError, Options<SystemV1RerunInsuranceDiscoveryData>> => {
    const mutationOptions: UseMutationOptions<SystemV1RerunInsuranceDiscoveryResponse, DefaultError, Options<SystemV1RerunInsuranceDiscoveryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await systemV1RerunInsuranceDiscovery({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Enqueue Customer.io order syncs for the given Postgres order ids.
 *
 * Each order is enqueued as its own Celery task on the ``customerio`` queue.
 * At most 100 ids per request.
 *
 * JSON body:
 * order_ids: required list of Postgres order ids, e.g. ``{"order_ids": [1, 2, 3]}``.
 */
export const systemV1SyncCioOrdersByIdMutation = (options?: Partial<Options<SystemV1SyncCioOrdersByIdData>>): UseMutationOptions<SystemV1SyncCioOrdersByIdResponse, DefaultError, Options<SystemV1SyncCioOrdersByIdData>> => {
    const mutationOptions: UseMutationOptions<SystemV1SyncCioOrdersByIdResponse, DefaultError, Options<SystemV1SyncCioOrdersByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await systemV1SyncCioOrdersById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Manually sync Intercom conversations that never triggered the inbound webhook
 *
 * (e.g. a sender was briefly misflagged as spam by Intercom).
 *
 * Each conversation is fetched from Intercom and dispatched into the same
 * email-agent pipeline the live webhook uses, as its own Celery task on the
 * ``email-agent`` queue. At most 25 ids per request.
 *
 * Conversations that already have an ``IntercomThread`` row (already processed
 * at least once) are skipped by default to avoid re-triggering the agent on an
 * old message. Pass ``"force": true`` to sync them anyway.
 *
 * JSON body:
 * conversation_ids: required list of Intercom conversation ids,
 * e.g. ``{"conversation_ids": ["123", "456"]}``.
 * force: optional bool, default false.
 */
export const systemV1SyncIntercomConvoByIdMutation = (options?: Partial<Options<SystemV1SyncIntercomConvoByIdData>>): UseMutationOptions<SystemV1SyncIntercomConvoByIdResponse, DefaultError, Options<SystemV1SyncIntercomConvoByIdData>> => {
    const mutationOptions: UseMutationOptions<SystemV1SyncIntercomConvoByIdResponse, DefaultError, Options<SystemV1SyncIntercomConvoByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await systemV1SyncIntercomConvoById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Re-sync Mongo orders into Postgres by integer ``order_id``.
 *
 * Celery task loads current Mongo documents and upserts ``orders`` and related
 * rows (same as the batch migrator). Use when documents changed after the
 * initial migration. At most 100 ids per request.
 *
 * JSON body:
 * mongo_order_ids: required list of Mongo order ids, e.g. ``{"mongo_order_ids": [1, 2, 3]}``.
 */
export const systemV1SyncMongoOrdersByIdMutation = (options?: Partial<Options<SystemV1SyncMongoOrdersByIdData>>): UseMutationOptions<SystemV1SyncMongoOrdersByIdResponse, DefaultError, Options<SystemV1SyncMongoOrdersByIdData>> => {
    const mutationOptions: UseMutationOptions<SystemV1SyncMongoOrdersByIdResponse, DefaultError, Options<SystemV1SyncMongoOrdersByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await systemV1SyncMongoOrdersById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const systemV1TriggerResupplyReportQueryKey = (options?: Options<SystemV1TriggerResupplyReportData>) => createQueryKey('systemV1TriggerResupplyReport', options);

export const systemV1TriggerResupplyReportOptions = (options?: Options<SystemV1TriggerResupplyReportData>) => queryOptions<SystemV1TriggerResupplyReportResponse, DefaultError, SystemV1TriggerResupplyReportResponse, ReturnType<typeof systemV1TriggerResupplyReportQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await systemV1TriggerResupplyReport({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: systemV1TriggerResupplyReportQueryKey(options)
});

export const usersV1CreateUserMutation = (options?: Partial<Options<UsersV1CreateUserData>>): UseMutationOptions<UsersV1CreateUserResponse, DefaultError, Options<UsersV1CreateUserData>> => {
    const mutationOptions: UseMutationOptions<UsersV1CreateUserResponse, DefaultError, Options<UsersV1CreateUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await usersV1CreateUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const usersV1ActivateUserMutation = (options?: Partial<Options<UsersV1ActivateUserData>>): UseMutationOptions<UsersV1ActivateUserResponse, DefaultError, Options<UsersV1ActivateUserData>> => {
    const mutationOptions: UseMutationOptions<UsersV1ActivateUserResponse, DefaultError, Options<UsersV1ActivateUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await usersV1ActivateUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const usersV1ListCommunicationPreferencesQueryKey = (options?: Options<UsersV1ListCommunicationPreferencesData>) => createQueryKey('usersV1ListCommunicationPreferences', options);

export const usersV1ListCommunicationPreferencesOptions = (options?: Options<UsersV1ListCommunicationPreferencesData>) => queryOptions<UsersV1ListCommunicationPreferencesResponse, DefaultError, UsersV1ListCommunicationPreferencesResponse, ReturnType<typeof usersV1ListCommunicationPreferencesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await usersV1ListCommunicationPreferences({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: usersV1ListCommunicationPreferencesQueryKey(options)
});

export const usersV1UpdateCommunicationPreferencesMutation = (options?: Partial<Options<UsersV1UpdateCommunicationPreferencesData>>): UseMutationOptions<UsersV1UpdateCommunicationPreferencesResponse, DefaultError, Options<UsersV1UpdateCommunicationPreferencesData>> => {
    const mutationOptions: UseMutationOptions<UsersV1UpdateCommunicationPreferencesResponse, DefaultError, Options<UsersV1UpdateCommunicationPreferencesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await usersV1UpdateCommunicationPreferences({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const usersV1SearchUsersQueryKey = (options?: Options<UsersV1SearchUsersData>) => createQueryKey('usersV1SearchUsers', options);

export const usersV1SearchUsersOptions = (options?: Options<UsersV1SearchUsersData>) => queryOptions<UsersV1SearchUsersResponse, DefaultError, UsersV1SearchUsersResponse, ReturnType<typeof usersV1SearchUsersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await usersV1SearchUsers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: usersV1SearchUsersQueryKey(options)
});

export const usersV1SearchUsersInfiniteQueryKey = (options?: Options<UsersV1SearchUsersData>): QueryKey<Options<UsersV1SearchUsersData>> => createQueryKey('usersV1SearchUsers', options, true);

export const usersV1SearchUsersInfiniteOptions = (options?: Options<UsersV1SearchUsersData>) => infiniteQueryOptions<UsersV1SearchUsersResponse, DefaultError, InfiniteData<UsersV1SearchUsersResponse>, QueryKey<Options<UsersV1SearchUsersData>>, number | Pick<QueryKey<Options<UsersV1SearchUsersData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<UsersV1SearchUsersData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await usersV1SearchUsers({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: usersV1SearchUsersInfiniteQueryKey(options)
});

export const usersV1DeleteUserMutation = (options?: Partial<Options<UsersV1DeleteUserData>>): UseMutationOptions<UsersV1DeleteUserResponse, DefaultError, Options<UsersV1DeleteUserData>> => {
    const mutationOptions: UseMutationOptions<UsersV1DeleteUserResponse, DefaultError, Options<UsersV1DeleteUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await usersV1DeleteUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const usersV1GetUserQueryKey = (options: Options<UsersV1GetUserData>) => createQueryKey('usersV1GetUser', options);

export const usersV1GetUserOptions = (options: Options<UsersV1GetUserData>) => queryOptions<UsersV1GetUserResponse, DefaultError, UsersV1GetUserResponse, ReturnType<typeof usersV1GetUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await usersV1GetUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: usersV1GetUserQueryKey(options)
});

export const usersV1UpdateUserMutation = (options?: Partial<Options<UsersV1UpdateUserData>>): UseMutationOptions<UsersV1UpdateUserResponse, DefaultError, Options<UsersV1UpdateUserData>> => {
    const mutationOptions: UseMutationOptions<UsersV1UpdateUserResponse, DefaultError, Options<UsersV1UpdateUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await usersV1UpdateUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const insuranceV2GetCarriersByStateQueryKey = (options: Options<InsuranceV2GetCarriersByStateData>) => createQueryKey('insuranceV2GetCarriersByState', options);

/**
 * Get list of carriers for a given state
 */
export const insuranceV2GetCarriersByStateOptions = (options: Options<InsuranceV2GetCarriersByStateData>) => queryOptions<InsuranceV2GetCarriersByStateResponse, DefaultError, InsuranceV2GetCarriersByStateResponse, ReturnType<typeof insuranceV2GetCarriersByStateQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await insuranceV2GetCarriersByState({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: insuranceV2GetCarriersByStateQueryKey(options)
});

export const insuranceV2GetCoverageZonesQueryKey = (options?: Options<InsuranceV2GetCoverageZonesData>) => createQueryKey('insuranceV2GetCoverageZones', options);

/**
 * Get all CoverageZones
 */
export const insuranceV2GetCoverageZonesOptions = (options?: Options<InsuranceV2GetCoverageZonesData>) => queryOptions<InsuranceV2GetCoverageZonesResponse, DefaultError, InsuranceV2GetCoverageZonesResponse, ReturnType<typeof insuranceV2GetCoverageZonesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await insuranceV2GetCoverageZones({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: insuranceV2GetCoverageZonesQueryKey(options)
});

export const insuranceV2GetPlanFeeSchedulesQueryKey = (options: Options<InsuranceV2GetPlanFeeSchedulesData>) => createQueryKey('insuranceV2GetPlanFeeSchedules', options);

/**
 * Get active per-plan fee schedules for a given plan UUID.
 *
 * Supports server-side filtering (``q``), sorting (``sort_by``,
 * ``sort_direction``), and pagination (``page``, ``limit``).
 * Returns an empty ``payload`` list when the plan has no per-plan rows —
 * never 404 on an empty result.
 */
export const insuranceV2GetPlanFeeSchedulesOptions = (options: Options<InsuranceV2GetPlanFeeSchedulesData>) => queryOptions<InsuranceV2GetPlanFeeSchedulesResponse, DefaultError, InsuranceV2GetPlanFeeSchedulesResponse, ReturnType<typeof insuranceV2GetPlanFeeSchedulesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await insuranceV2GetPlanFeeSchedules({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: insuranceV2GetPlanFeeSchedulesQueryKey(options)
});

export const insuranceV2GetPlanFeeSchedulesInfiniteQueryKey = (options: Options<InsuranceV2GetPlanFeeSchedulesData>): QueryKey<Options<InsuranceV2GetPlanFeeSchedulesData>> => createQueryKey('insuranceV2GetPlanFeeSchedules', options, true);

/**
 * Get active per-plan fee schedules for a given plan UUID.
 *
 * Supports server-side filtering (``q``), sorting (``sort_by``,
 * ``sort_direction``), and pagination (``page``, ``limit``).
 * Returns an empty ``payload`` list when the plan has no per-plan rows —
 * never 404 on an empty result.
 */
export const insuranceV2GetPlanFeeSchedulesInfiniteOptions = (options: Options<InsuranceV2GetPlanFeeSchedulesData>) => infiniteQueryOptions<InsuranceV2GetPlanFeeSchedulesResponse, DefaultError, InfiniteData<InsuranceV2GetPlanFeeSchedulesResponse>, QueryKey<Options<InsuranceV2GetPlanFeeSchedulesData>>, number | Pick<QueryKey<Options<InsuranceV2GetPlanFeeSchedulesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<InsuranceV2GetPlanFeeSchedulesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await insuranceV2GetPlanFeeSchedules({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: insuranceV2GetPlanFeeSchedulesInfiniteQueryKey(options)
});

/**
 * Bulk-create/update per-plan fee schedule rows from a CSV upload.
 *
 * Accepts ``multipart/form-data`` with a ``file`` field — CSV in the format:
 * ``code,fee,rental_fee,max_units,pa,max_refills`` (also accepts ``hcpc_code``).
 *
 * Creates a ``PlanFeeScheduleSubmission`` record and runs validate+ingest
 * atomically.  Returns 200 with the ingest result regardless of partial
 * row-level failures; callers inspect ``errors`` to determine individual
 * row outcomes.
 */
export const insuranceV2BulkUploadPlanFeeSchedulesMutation = (options?: Partial<Options<InsuranceV2BulkUploadPlanFeeSchedulesData>>): UseMutationOptions<InsuranceV2BulkUploadPlanFeeSchedulesResponse, DefaultError, Options<InsuranceV2BulkUploadPlanFeeSchedulesData>> => {
    const mutationOptions: UseMutationOptions<InsuranceV2BulkUploadPlanFeeSchedulesResponse, DefaultError, Options<InsuranceV2BulkUploadPlanFeeSchedulesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await insuranceV2BulkUploadPlanFeeSchedules({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Seed per-plan fee schedules from a template carrier+zone or another plan.
 *
 * JSON body — exactly one source required:
 *
 * * ``source_plan_uuid``: duplicate from another plan's per-plan rows.
 * * ``source_carrier_uuid`` + ``source_coverage_zone_uuid``: copy from
 * template rows (``plan_uuid IS NULL``) for that carrier+zone pair.
 *
 * Optional:
 *
 * * ``modifier_pct`` (float, default 100): scale ``fee`` and ``rental_fee``
 * by this percentage before ingesting (100 = no change).
 *
 * Fetches source rows server-side, builds a CSV, creates a
 * ``PlanFeeScheduleSubmission``, runs validate+ingest atomically, and returns
 * the same ``{submission_uuid, created, updated, errors}`` envelope as
 * ``bulk_upload``.
 */
export const insuranceV2SeedPlanFeeSchedulesMutation = (options?: Partial<Options<InsuranceV2SeedPlanFeeSchedulesData>>): UseMutationOptions<InsuranceV2SeedPlanFeeSchedulesResponse, DefaultError, Options<InsuranceV2SeedPlanFeeSchedulesData>> => {
    const mutationOptions: UseMutationOptions<InsuranceV2SeedPlanFeeSchedulesResponse, DefaultError, Options<InsuranceV2SeedPlanFeeSchedulesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await insuranceV2SeedPlanFeeSchedules({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const insuranceV2GetPlanFeeScheduleTemplateSourcesQueryKey = (options: Options<InsuranceV2GetPlanFeeScheduleTemplateSourcesData>) => createQueryKey('insuranceV2GetPlanFeeScheduleTemplateSources', options);

/**
 * Return distinct (carrier, coverage_zone) pairs that have active template fee
 *
 * schedules (plan_uuid IS NULL) in the same state as the given plan.
 *
 * Used by the UI bulk-add form to populate the "Generate from template" picker.
 * Returns 200 with an empty payload if the plan is not found or has no matching
 * template sources.
 */
export const insuranceV2GetPlanFeeScheduleTemplateSourcesOptions = (options: Options<InsuranceV2GetPlanFeeScheduleTemplateSourcesData>) => queryOptions<InsuranceV2GetPlanFeeScheduleTemplateSourcesResponse, DefaultError, InsuranceV2GetPlanFeeScheduleTemplateSourcesResponse, ReturnType<typeof insuranceV2GetPlanFeeScheduleTemplateSourcesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await insuranceV2GetPlanFeeScheduleTemplateSources({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: insuranceV2GetPlanFeeScheduleTemplateSourcesQueryKey(options)
});

export const insuranceV2RefillsQueryKey = (options: Options<InsuranceV2RefillsData>) => createQueryKey('insuranceV2Refills', options);

/**
 * Refills
 *
 * Retrieve the max refills Insurance record by product code(s) and insurance carrier
 */
export const insuranceV2RefillsOptions = (options: Options<InsuranceV2RefillsData>) => queryOptions<InsuranceV2RefillsResponse, DefaultError, InsuranceV2RefillsResponse, ReturnType<typeof insuranceV2RefillsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await insuranceV2Refills({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: insuranceV2RefillsQueryKey(options)
});

export const insuranceV2HeartbeatQueryKey = (options?: Options<InsuranceV2HeartbeatData>) => createQueryKey('insuranceV2Heartbeat', options);

/**
 * Heartbeat
 *
 * Base validation for the heartbeat endpoint
 */
export const insuranceV2HeartbeatOptions = (options?: Options<InsuranceV2HeartbeatData>) => queryOptions<InsuranceV2HeartbeatResponse, DefaultError, InsuranceV2HeartbeatResponse, ReturnType<typeof insuranceV2HeartbeatQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await insuranceV2Heartbeat({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: insuranceV2HeartbeatQueryKey(options)
});

export const insuranceV2SearchIcdsQueryKey = (options: Options<InsuranceV2SearchIcdsData>) => createQueryKey('insuranceV2SearchIcds', options);

export const insuranceV2SearchIcdsOptions = (options: Options<InsuranceV2SearchIcdsData>) => queryOptions<InsuranceV2SearchIcdsResponse, DefaultError, InsuranceV2SearchIcdsResponse, ReturnType<typeof insuranceV2SearchIcdsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await insuranceV2SearchIcds({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: insuranceV2SearchIcdsQueryKey(options)
});

export const insuranceV2SearchIcdsInfiniteQueryKey = (options: Options<InsuranceV2SearchIcdsData>): QueryKey<Options<InsuranceV2SearchIcdsData>> => createQueryKey('insuranceV2SearchIcds', options, true);

export const insuranceV2SearchIcdsInfiniteOptions = (options: Options<InsuranceV2SearchIcdsData>) => infiniteQueryOptions<InsuranceV2SearchIcdsResponse, DefaultError, InfiniteData<InsuranceV2SearchIcdsResponse>, QueryKey<Options<InsuranceV2SearchIcdsData>>, number | Pick<QueryKey<Options<InsuranceV2SearchIcdsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<InsuranceV2SearchIcdsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await insuranceV2SearchIcds({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: insuranceV2SearchIcdsInfiniteQueryKey(options)
});

export const insuranceV2GetPrimaryIcdsQueryKey = (options: Options<InsuranceV2GetPrimaryIcdsData>) => createQueryKey('insuranceV2GetPrimaryIcds', options);

export const insuranceV2GetPrimaryIcdsOptions = (options: Options<InsuranceV2GetPrimaryIcdsData>) => queryOptions<InsuranceV2GetPrimaryIcdsResponse, DefaultError, InsuranceV2GetPrimaryIcdsResponse, ReturnType<typeof insuranceV2GetPrimaryIcdsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await insuranceV2GetPrimaryIcds({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: insuranceV2GetPrimaryIcdsQueryKey(options)
});

export const insuranceV2GetCarrierProductLegacyQueryKey = (options: Options<InsuranceV2GetCarrierProductLegacyData>) => createQueryKey('insuranceV2GetCarrierProductLegacy', options);

/**
 * Get product details for a given carrier & state using a legacy id
 */
export const insuranceV2GetCarrierProductLegacyOptions = (options: Options<InsuranceV2GetCarrierProductLegacyData>) => queryOptions<InsuranceV2GetCarrierProductLegacyResponse, DefaultError, InsuranceV2GetCarrierProductLegacyResponse, ReturnType<typeof insuranceV2GetCarrierProductLegacyQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await insuranceV2GetCarrierProductLegacy({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: insuranceV2GetCarrierProductLegacyQueryKey(options)
});

export const insuranceV2GetCarrierProductQueryKey = (options: Options<InsuranceV2GetCarrierProductData>) => createQueryKey('insuranceV2GetCarrierProduct', options);

/**
 * Get via Carrier/State
 *
 * Retrieve list of records by query term and/or template type (Medicaid/Medicare)
 */
export const insuranceV2GetCarrierProductOptions = (options: Options<InsuranceV2GetCarrierProductData>) => queryOptions<InsuranceV2GetCarrierProductResponse, DefaultError, InsuranceV2GetCarrierProductResponse, ReturnType<typeof insuranceV2GetCarrierProductQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await insuranceV2GetCarrierProduct({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: insuranceV2GetCarrierProductQueryKey(options)
});

export const insuranceV2GetCarrierProductsQueryKey = (options: Options<InsuranceV2GetCarrierProductsData>) => createQueryKey('insuranceV2GetCarrierProducts', options);

/**
 * Get via Carrier/State
 *
 * Retrieve list of records by query term and/or template type (Medicaid/Medicare)
 */
export const insuranceV2GetCarrierProductsOptions = (options: Options<InsuranceV2GetCarrierProductsData>) => queryOptions<InsuranceV2GetCarrierProductsResponse, DefaultError, InsuranceV2GetCarrierProductsResponse, ReturnType<typeof insuranceV2GetCarrierProductsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await insuranceV2GetCarrierProducts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: insuranceV2GetCarrierProductsQueryKey(options)
});

export const insuranceV2GetCarrierProductsInfiniteQueryKey = (options: Options<InsuranceV2GetCarrierProductsData>): QueryKey<Options<InsuranceV2GetCarrierProductsData>> => createQueryKey('insuranceV2GetCarrierProducts', options, true);

/**
 * Get via Carrier/State
 *
 * Retrieve list of records by query term and/or template type (Medicaid/Medicare)
 */
export const insuranceV2GetCarrierProductsInfiniteOptions = (options: Options<InsuranceV2GetCarrierProductsData>) => infiniteQueryOptions<InsuranceV2GetCarrierProductsResponse, DefaultError, InfiniteData<InsuranceV2GetCarrierProductsResponse>, QueryKey<Options<InsuranceV2GetCarrierProductsData>>, number | Pick<QueryKey<Options<InsuranceV2GetCarrierProductsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<InsuranceV2GetCarrierProductsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await insuranceV2GetCarrierProducts({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: insuranceV2GetCarrierProductsInfiniteQueryKey(options)
});

export const npiV2SearchProvidersQueryKey = (options?: Options<NpiV2SearchProvidersData>) => createQueryKey('npiV2SearchProviders', options);

export const npiV2SearchProvidersOptions = (options?: Options<NpiV2SearchProvidersData>) => queryOptions<NpiV2SearchProvidersResponse, DefaultError, NpiV2SearchProvidersResponse, ReturnType<typeof npiV2SearchProvidersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await npiV2SearchProviders({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: npiV2SearchProvidersQueryKey(options)
});

export const npiV2SearchProvidersInfiniteQueryKey = (options?: Options<NpiV2SearchProvidersData>): QueryKey<Options<NpiV2SearchProvidersData>> => createQueryKey('npiV2SearchProviders', options, true);

export const npiV2SearchProvidersInfiniteOptions = (options?: Options<NpiV2SearchProvidersData>) => infiniteQueryOptions<NpiV2SearchProvidersResponse, DefaultError, InfiniteData<NpiV2SearchProvidersResponse>, QueryKey<Options<NpiV2SearchProvidersData>>, number | Pick<QueryKey<Options<NpiV2SearchProvidersData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<NpiV2SearchProvidersData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await npiV2SearchProviders({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: npiV2SearchProvidersInfiniteQueryKey(options)
});

export const npiV2GetProviderQueryKey = (options: Options<NpiV2GetProviderData>) => createQueryKey('npiV2GetProvider', options);

export const npiV2GetProviderOptions = (options: Options<NpiV2GetProviderData>) => queryOptions<NpiV2GetProviderResponse, DefaultError, NpiV2GetProviderResponse, ReturnType<typeof npiV2GetProviderQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await npiV2GetProvider({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: npiV2GetProviderQueryKey(options)
});

export const npiV2UpdateProviderMutation = (options?: Partial<Options<NpiV2UpdateProviderData>>): UseMutationOptions<NpiV2UpdateProviderResponse, DefaultError, Options<NpiV2UpdateProviderData>> => {
    const mutationOptions: UseMutationOptions<NpiV2UpdateProviderResponse, DefaultError, Options<NpiV2UpdateProviderData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await npiV2UpdateProvider({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const npiV2AddProviderAddressMutation = (options?: Partial<Options<NpiV2AddProviderAddressData>>): UseMutationOptions<NpiV2AddProviderAddressResponse, DefaultError, Options<NpiV2AddProviderAddressData>> => {
    const mutationOptions: UseMutationOptions<NpiV2AddProviderAddressResponse, DefaultError, Options<NpiV2AddProviderAddressData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await npiV2AddProviderAddress({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const npiV2UpdateProviderAddressMutation = (options?: Partial<Options<NpiV2UpdateProviderAddressData>>): UseMutationOptions<NpiV2UpdateProviderAddressResponse, DefaultError, Options<NpiV2UpdateProviderAddressData>> => {
    const mutationOptions: UseMutationOptions<NpiV2UpdateProviderAddressResponse, DefaultError, Options<NpiV2UpdateProviderAddressData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await npiV2UpdateProviderAddress({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const npiV2ToggleProviderAddressMutation = (options?: Partial<Options<NpiV2ToggleProviderAddressData>>): UseMutationOptions<NpiV2ToggleProviderAddressResponse, DefaultError, Options<NpiV2ToggleProviderAddressData>> => {
    const mutationOptions: UseMutationOptions<NpiV2ToggleProviderAddressResponse, DefaultError, Options<NpiV2ToggleProviderAddressData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await npiV2ToggleProviderAddress({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const ordersV2GetOrderStatusesV2QueryKey = (options?: Options<OrdersV2GetOrderStatusesV2Data>) => createQueryKey('ordersV2GetOrderStatusesV2', options);

/**
 * Return the order statuses visible to the caller's role, grouped by display label.
 *
 * Migrated from orders GraphQL query: getOrderStatusesV2
 */
export const ordersV2GetOrderStatusesV2Options = (options?: Options<OrdersV2GetOrderStatusesV2Data>) => queryOptions<OrdersV2GetOrderStatusesV2Response, DefaultError, OrdersV2GetOrderStatusesV2Response, ReturnType<typeof ordersV2GetOrderStatusesV2QueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await ordersV2GetOrderStatusesV2({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: ordersV2GetOrderStatusesV2QueryKey(options)
});

/**
 * Move order to BILLING state.
 *
 * Migrated from orders GraphQL mutation: moveOrderToBilling
 */
export const ordersV2MoveOrderToBillingMutation = (options?: Partial<Options<OrdersV2MoveOrderToBillingData>>): UseMutationOptions<OrdersV2MoveOrderToBillingResponse, DefaultError, Options<OrdersV2MoveOrderToBillingData>> => {
    const mutationOptions: UseMutationOptions<OrdersV2MoveOrderToBillingResponse, DefaultError, Options<OrdersV2MoveOrderToBillingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersV2MoveOrderToBilling({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Move order to CANT_REACH_PATIENT state.
 *
 * Migrated from orders GraphQL mutation: moveOrderToCantReachPatient
 */
export const ordersV2MoveOrderToCantReachPatientMutation = (options?: Partial<Options<OrdersV2MoveOrderToCantReachPatientData>>): UseMutationOptions<OrdersV2MoveOrderToCantReachPatientResponse, DefaultError, Options<OrdersV2MoveOrderToCantReachPatientData>> => {
    const mutationOptions: UseMutationOptions<OrdersV2MoveOrderToCantReachPatientResponse, DefaultError, Options<OrdersV2MoveOrderToCantReachPatientData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersV2MoveOrderToCantReachPatient({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Move order to DONE state.
 *
 * Migrated from orders GraphQL mutation: moveOrderToDone
 */
export const ordersV2MoveOrderToDoneMutation = (options?: Partial<Options<OrdersV2MoveOrderToDoneData>>): UseMutationOptions<OrdersV2MoveOrderToDoneResponse, DefaultError, Options<OrdersV2MoveOrderToDoneData>> => {
    const mutationOptions: UseMutationOptions<OrdersV2MoveOrderToDoneResponse, DefaultError, Options<OrdersV2MoveOrderToDoneData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersV2MoveOrderToDone({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Duplicate an order (e.g. for resupply). Returns the new order's id and status.
 *
 * The duplicate_order utility internally emits ORDERS_REPLICATE_HISTORY_V1 and
 * ORDERS_ORDER_COPY_FILES_V1 so downstream services copy history and files onto
 * the new order.
 *
 * Migrated from orders GraphQL mutation: duplicateOrder (V2)
 */
export const ordersV2DuplicateOrderV2Mutation = (options?: Partial<Options<OrdersV2DuplicateOrderV2Data>>): UseMutationOptions<OrdersV2DuplicateOrderV2Response, DefaultError, Options<OrdersV2DuplicateOrderV2Data>> => {
    const mutationOptions: UseMutationOptions<OrdersV2DuplicateOrderV2Response, DefaultError, Options<OrdersV2DuplicateOrderV2Data>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersV2DuplicateOrderV2({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Move order to IN_PROGRESS_WITH_SUPPLIER state.
 *
 * Migrated from orders GraphQL mutation: moveOrderToInProgressWithSupplier
 */
export const ordersV2MoveOrderToInProgressWithSupplierMutation = (options?: Partial<Options<OrdersV2MoveOrderToInProgressWithSupplierData>>): UseMutationOptions<OrdersV2MoveOrderToInProgressWithSupplierResponse, DefaultError, Options<OrdersV2MoveOrderToInProgressWithSupplierData>> => {
    const mutationOptions: UseMutationOptions<OrdersV2MoveOrderToInProgressWithSupplierResponse, DefaultError, Options<OrdersV2MoveOrderToInProgressWithSupplierData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersV2MoveOrderToInProgressWithSupplier({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Move order to ON_HOLD_WITH_SUPPLIER state with a required reason.
 *
 * Migrated from orders GraphQL mutation: moveOrderToOnHoldWithSupplier
 */
export const ordersV2MoveOrderToOnHoldWithSupplierMutation = (options?: Partial<Options<OrdersV2MoveOrderToOnHoldWithSupplierData>>): UseMutationOptions<OrdersV2MoveOrderToOnHoldWithSupplierResponse, DefaultError, Options<OrdersV2MoveOrderToOnHoldWithSupplierData>> => {
    const mutationOptions: UseMutationOptions<OrdersV2MoveOrderToOnHoldWithSupplierResponse, DefaultError, Options<OrdersV2MoveOrderToOnHoldWithSupplierData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersV2MoveOrderToOnHoldWithSupplier({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Move order to PENDING_AUTHORIZATION state.
 *
 * Migrated from orders GraphQL mutation: moveOrderToPendingAuthorization
 */
export const ordersV2MoveOrderToPendingAuthorizationMutation = (options?: Partial<Options<OrdersV2MoveOrderToPendingAuthorizationData>>): UseMutationOptions<OrdersV2MoveOrderToPendingAuthorizationResponse, DefaultError, Options<OrdersV2MoveOrderToPendingAuthorizationData>> => {
    const mutationOptions: UseMutationOptions<OrdersV2MoveOrderToPendingAuthorizationResponse, DefaultError, Options<OrdersV2MoveOrderToPendingAuthorizationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersV2MoveOrderToPendingAuthorization({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Move order to PENDING_REROUTE state.
 *
 * Migrated from orders GraphQL mutation: moveOrderToPendingReroute
 */
export const ordersV2MoveOrderToPendingRerouteMutation = (options?: Partial<Options<OrdersV2MoveOrderToPendingRerouteData>>): UseMutationOptions<OrdersV2MoveOrderToPendingRerouteResponse, DefaultError, Options<OrdersV2MoveOrderToPendingRerouteData>> => {
    const mutationOptions: UseMutationOptions<OrdersV2MoveOrderToPendingRerouteResponse, DefaultError, Options<OrdersV2MoveOrderToPendingRerouteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersV2MoveOrderToPendingReroute({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Move order to PENDING_ACCEPTANCE state.
 *
 * Migrated from orders GraphQL mutation: moveOrderToPendingSupplierAcceptance
 *
 * RX Date gate: when the order's supplier has ``require_rx_date_gate=True``
 * and the order has ``prescription_metadata`` present (not grandfathered),
 * the metadata must include a non-None ``expiration_date`` before the
 * transition is allowed.
 */
export const ordersV2MoveOrderToPendingSupplierAcceptanceMutation = (options?: Partial<Options<OrdersV2MoveOrderToPendingSupplierAcceptanceData>>): UseMutationOptions<OrdersV2MoveOrderToPendingSupplierAcceptanceResponse, DefaultError, Options<OrdersV2MoveOrderToPendingSupplierAcceptanceData>> => {
    const mutationOptions: UseMutationOptions<OrdersV2MoveOrderToPendingSupplierAcceptanceResponse, DefaultError, Options<OrdersV2MoveOrderToPendingSupplierAcceptanceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersV2MoveOrderToPendingSupplierAcceptance({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Move order to PREPARING_SHIPMENT state.
 *
 * Migrated from orders GraphQL mutation: moveOrderToPreparingShipment
 */
export const ordersV2MoveOrderToPreparingShipmentMutation = (options?: Partial<Options<OrdersV2MoveOrderToPreparingShipmentData>>): UseMutationOptions<OrdersV2MoveOrderToPreparingShipmentResponse, DefaultError, Options<OrdersV2MoveOrderToPreparingShipmentData>> => {
    const mutationOptions: UseMutationOptions<OrdersV2MoveOrderToPreparingShipmentResponse, DefaultError, Options<OrdersV2MoveOrderToPreparingShipmentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersV2MoveOrderToPreparingShipment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Request a refresh of the e-signature for an order.
 *
 * Validates that:
 * - The order has an e-signature
 * - The e-signature is not already signed
 * - The e-signature link has expired (created more than 24 hours ago)
 *
 * Migrated from orders GraphQL mutation: refreshEsignature
 */
export const ordersV2RefreshEsignatureMutation = (options?: Partial<Options<OrdersV2RefreshEsignatureData>>): UseMutationOptions<OrdersV2RefreshEsignatureResponse, DefaultError, Options<OrdersV2RefreshEsignatureData>> => {
    const mutationOptions: UseMutationOptions<OrdersV2RefreshEsignatureResponse, DefaultError, Options<OrdersV2RefreshEsignatureData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersV2RefreshEsignature({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Request an e-signature for an order by uploading a document.
 *
 * Proxies the file upload to the esignature service.  MongoDB write is a
 * placeholder pending full migration.
 *
 * Migrated from orders service: POST /orders/api/esignature/request
 */
export const ordersV2RequestEsignatureMutation = (options?: Partial<Options<OrdersV2RequestEsignatureData>>): UseMutationOptions<OrdersV2RequestEsignatureResponse, DefaultError, Options<OrdersV2RequestEsignatureData>> => {
    const mutationOptions: UseMutationOptions<OrdersV2RequestEsignatureResponse, DefaultError, Options<OrdersV2RequestEsignatureData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersV2RequestEsignature({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Move order to SUPPLIER_COMPLETED state.
 *
 * Migrated from orders GraphQL mutation: moveOrderToSupplierCompleted
 */
export const ordersV2MoveOrderToSupplierCompletedMutation = (options?: Partial<Options<OrdersV2MoveOrderToSupplierCompletedData>>): UseMutationOptions<OrdersV2MoveOrderToSupplierCompletedResponse, DefaultError, Options<OrdersV2MoveOrderToSupplierCompletedData>> => {
    const mutationOptions: UseMutationOptions<OrdersV2MoveOrderToSupplierCompletedResponse, DefaultError, Options<OrdersV2MoveOrderToSupplierCompletedData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersV2MoveOrderToSupplierCompleted({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Move order to SUPPLIER_SHIPPED state.
 *
 * Migrated from orders GraphQL mutation: moveOrderToSupplierShipped
 */
export const ordersV2MoveOrderToSupplierShippedMutation = (options?: Partial<Options<OrdersV2MoveOrderToSupplierShippedData>>): UseMutationOptions<OrdersV2MoveOrderToSupplierShippedResponse, DefaultError, Options<OrdersV2MoveOrderToSupplierShippedData>> => {
    const mutationOptions: UseMutationOptions<OrdersV2MoveOrderToSupplierShippedResponse, DefaultError, Options<OrdersV2MoveOrderToSupplierShippedData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersV2MoveOrderToSupplierShipped({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Move order to CHASING_CLINICALS state.
 *
 * Migrated from orders GraphQL mutation: moveOrderToTelehealthChasingClinicals
 */
export const ordersV2MoveOrderToTelehealthChasingClinicalsMutation = (options?: Partial<Options<OrdersV2MoveOrderToTelehealthChasingClinicalsData>>): UseMutationOptions<OrdersV2MoveOrderToTelehealthChasingClinicalsResponse, DefaultError, Options<OrdersV2MoveOrderToTelehealthChasingClinicalsData>> => {
    const mutationOptions: UseMutationOptions<OrdersV2MoveOrderToTelehealthChasingClinicalsResponse, DefaultError, Options<OrdersV2MoveOrderToTelehealthChasingClinicalsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersV2MoveOrderToTelehealthChasingClinicals({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Move order to TELEHEALTH_COMPLETED state.
 *
 * Migrated from orders GraphQL mutation: moveOrderToTelehealthCompleted (V2)
 */
export const ordersV2MoveOrderToTelehealthCompletedMutation = (options?: Partial<Options<OrdersV2MoveOrderToTelehealthCompletedData>>): UseMutationOptions<OrdersV2MoveOrderToTelehealthCompletedResponse, DefaultError, Options<OrdersV2MoveOrderToTelehealthCompletedData>> => {
    const mutationOptions: UseMutationOptions<OrdersV2MoveOrderToTelehealthCompletedResponse, DefaultError, Options<OrdersV2MoveOrderToTelehealthCompletedData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersV2MoveOrderToTelehealthCompleted({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Move order to CONTACTING_PATIENT state.
 *
 * Migrated from orders GraphQL mutation: moveOrderToTelehealthContactingPatient
 */
export const ordersV2MoveOrderToTelehealthContactingPatientMutation = (options?: Partial<Options<OrdersV2MoveOrderToTelehealthContactingPatientData>>): UseMutationOptions<OrdersV2MoveOrderToTelehealthContactingPatientResponse, DefaultError, Options<OrdersV2MoveOrderToTelehealthContactingPatientData>> => {
    const mutationOptions: UseMutationOptions<OrdersV2MoveOrderToTelehealthContactingPatientResponse, DefaultError, Options<OrdersV2MoveOrderToTelehealthContactingPatientData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersV2MoveOrderToTelehealthContactingPatient({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Move order to TELEHEALTH_NEEDS_RESCHED state.
 *
 * Migrated from orders GraphQL mutation: moveOrderToTelehealthNeedsResched
 */
export const ordersV2MoveOrderToTelehealthNeedsReschedulingMutation = (options?: Partial<Options<OrdersV2MoveOrderToTelehealthNeedsReschedulingData>>): UseMutationOptions<OrdersV2MoveOrderToTelehealthNeedsReschedulingResponse, DefaultError, Options<OrdersV2MoveOrderToTelehealthNeedsReschedulingData>> => {
    const mutationOptions: UseMutationOptions<OrdersV2MoveOrderToTelehealthNeedsReschedulingResponse, DefaultError, Options<OrdersV2MoveOrderToTelehealthNeedsReschedulingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersV2MoveOrderToTelehealthNeedsRescheduling({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Move order to TELEHEALTH_ON_HOLD state.
 *
 * Migrated from orders GraphQL mutation: moveOrderToTelehealthOnHold
 */
export const ordersV2MoveOrderToTelehealthOnHoldMutation = (options?: Partial<Options<OrdersV2MoveOrderToTelehealthOnHoldData>>): UseMutationOptions<OrdersV2MoveOrderToTelehealthOnHoldResponse, DefaultError, Options<OrdersV2MoveOrderToTelehealthOnHoldData>> => {
    const mutationOptions: UseMutationOptions<OrdersV2MoveOrderToTelehealthOnHoldResponse, DefaultError, Options<OrdersV2MoveOrderToTelehealthOnHoldData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersV2MoveOrderToTelehealthOnHold({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Move order to POST_VISIT_ACTIONS_COMPLETED state.
 *
 * Migrated from orders GraphQL mutation: moveOrderToTelehealthPostVisitActionsCompleted
 */
export const ordersV2MoveOrderToTelehealthPostVisitCompletedMutation = (options?: Partial<Options<OrdersV2MoveOrderToTelehealthPostVisitCompletedData>>): UseMutationOptions<OrdersV2MoveOrderToTelehealthPostVisitCompletedResponse, DefaultError, Options<OrdersV2MoveOrderToTelehealthPostVisitCompletedData>> => {
    const mutationOptions: UseMutationOptions<OrdersV2MoveOrderToTelehealthPostVisitCompletedResponse, DefaultError, Options<OrdersV2MoveOrderToTelehealthPostVisitCompletedData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersV2MoveOrderToTelehealthPostVisitCompleted({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Move order to TELEHEALTH_UPCOMING state with a scheduled appointment time.
 *
 * Migrated from orders GraphQL mutation: moveOrderToTelehealthUpcoming
 */
export const ordersV2MoveOrderToTelehealthUpcomingMutation = (options?: Partial<Options<OrdersV2MoveOrderToTelehealthUpcomingData>>): UseMutationOptions<OrdersV2MoveOrderToTelehealthUpcomingResponse, DefaultError, Options<OrdersV2MoveOrderToTelehealthUpcomingData>> => {
    const mutationOptions: UseMutationOptions<OrdersV2MoveOrderToTelehealthUpcomingResponse, DefaultError, Options<OrdersV2MoveOrderToTelehealthUpcomingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersV2MoveOrderToTelehealthUpcoming({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const patientsV2GetContactFieldOptionsQueryKey = (options?: Options<PatientsV2GetContactFieldOptionsData>) => createQueryKey('patientsV2GetContactFieldOptions', options);

/**
 * Contact Field Options
 *
 * Return the static lookup options for the contact-details dropdowns
 * (relationship, phone type, preferred language). The option sets are small
 * and static, so there is no pagination and no DB access. Authorized to the
 * same roles that could read these via the patients-service GraphQL query.
 */
export const patientsV2GetContactFieldOptionsOptions = (options?: Options<PatientsV2GetContactFieldOptionsData>) => queryOptions<PatientsV2GetContactFieldOptionsResponse, DefaultError, PatientsV2GetContactFieldOptionsResponse, ReturnType<typeof patientsV2GetContactFieldOptionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await patientsV2GetContactFieldOptions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: patientsV2GetContactFieldOptionsQueryKey(options)
});

export const patientsV2HeartbeatQueryKey = (options?: Options<PatientsV2HeartbeatData>) => createQueryKey('patientsV2Heartbeat', options);

/**
 * Heartbeat
 *
 * Base validation for the heartbeat endpoint
 */
export const patientsV2HeartbeatOptions = (options?: Options<PatientsV2HeartbeatData>) => queryOptions<PatientsV2HeartbeatResponse, DefaultError, PatientsV2HeartbeatResponse, ReturnType<typeof patientsV2HeartbeatQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await patientsV2Heartbeat({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: patientsV2HeartbeatQueryKey(options)
});

export const patientsV2SearchPatientsQueryKey = (options?: Options<PatientsV2SearchPatientsData>) => createQueryKey('patientsV2SearchPatients', options);

/**
 * Patient Search
 *
 * Get list of patients by case-insensitive partial match against
 * - First Name
 * - Last Name
 * - Email
 * - Auth0 ID
 */
export const patientsV2SearchPatientsOptions = (options?: Options<PatientsV2SearchPatientsData>) => queryOptions<PatientsV2SearchPatientsResponse, DefaultError, PatientsV2SearchPatientsResponse, ReturnType<typeof patientsV2SearchPatientsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await patientsV2SearchPatients({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: patientsV2SearchPatientsQueryKey(options)
});

export const patientsV2SearchPatientsInfiniteQueryKey = (options?: Options<PatientsV2SearchPatientsData>): QueryKey<Options<PatientsV2SearchPatientsData>> => createQueryKey('patientsV2SearchPatients', options, true);

/**
 * Patient Search
 *
 * Get list of patients by case-insensitive partial match against
 * - First Name
 * - Last Name
 * - Email
 * - Auth0 ID
 */
export const patientsV2SearchPatientsInfiniteOptions = (options?: Options<PatientsV2SearchPatientsData>) => infiniteQueryOptions<PatientsV2SearchPatientsResponse, DefaultError, InfiniteData<PatientsV2SearchPatientsResponse>, QueryKey<Options<PatientsV2SearchPatientsData>>, number | Pick<QueryKey<Options<PatientsV2SearchPatientsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<PatientsV2SearchPatientsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await patientsV2SearchPatients({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: patientsV2SearchPatientsInfiniteQueryKey(options)
});

export const patientsV2PatientDetailsQueryKey = (options: Options<PatientsV2PatientDetailsData>) => createQueryKey('patientsV2PatientDetails', options);

/**
 * Patient Detail
 *
 * Get patient details by numeric id
 */
export const patientsV2PatientDetailsOptions = (options: Options<PatientsV2PatientDetailsData>) => queryOptions<PatientsV2PatientDetailsResponse, DefaultError, PatientsV2PatientDetailsResponse, ReturnType<typeof patientsV2PatientDetailsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await patientsV2PatientDetails({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: patientsV2PatientDetailsQueryKey(options)
});

export const patientsV2PatientAddressesQueryKey = (options: Options<PatientsV2PatientAddressesData>) => createQueryKey('patientsV2PatientAddresses', options);

/**
 * Patient Detail
 *
 * Get patient address details by numeric id
 */
export const patientsV2PatientAddressesOptions = (options: Options<PatientsV2PatientAddressesData>) => queryOptions<PatientsV2PatientAddressesResponse, DefaultError, PatientsV2PatientAddressesResponse, ReturnType<typeof patientsV2PatientAddressesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await patientsV2PatientAddresses({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: patientsV2PatientAddressesQueryKey(options)
});

export const patientsV2PatientContactsQueryKey = (options: Options<PatientsV2PatientContactsData>) => createQueryKey('patientsV2PatientContacts', options);

/**
 * Patient Detail
 *
 * Get patient contacts details by numeric id
 */
export const patientsV2PatientContactsOptions = (options: Options<PatientsV2PatientContactsData>) => queryOptions<PatientsV2PatientContactsResponse, DefaultError, PatientsV2PatientContactsResponse, ReturnType<typeof patientsV2PatientContactsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await patientsV2PatientContacts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: patientsV2PatientContactsQueryKey(options)
});

export const patientsV2PatientCustomerioProfileQueryKey = (options: Options<PatientsV2PatientCustomerioProfileData>) => createQueryKey('patientsV2PatientCustomerioProfile', options);

/**
 * Patient Customer.io Profile
 *
 * Look up the patient's Customer.io profile so internal tooling can link to it.
 * Payload is null when the patient has no patient UUID, or when the Customer.io
 * workspace has no profile for that UUID.
 */
export const patientsV2PatientCustomerioProfileOptions = (options: Options<PatientsV2PatientCustomerioProfileData>) => queryOptions<PatientsV2PatientCustomerioProfileResponse, DefaultError, PatientsV2PatientCustomerioProfileResponse, ReturnType<typeof patientsV2PatientCustomerioProfileQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await patientsV2PatientCustomerioProfile({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: patientsV2PatientCustomerioProfileQueryKey(options)
});

export const patientsV2PatientInsurancesQueryKey = (options: Options<PatientsV2PatientInsurancesData>) => createQueryKey('patientsV2PatientInsurances', options);

/**
 * Patient Detail
 *
 * Get patient insurance details by numeric id
 */
export const patientsV2PatientInsurancesOptions = (options: Options<PatientsV2PatientInsurancesData>) => queryOptions<PatientsV2PatientInsurancesResponse, DefaultError, PatientsV2PatientInsurancesResponse, ReturnType<typeof patientsV2PatientInsurancesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await patientsV2PatientInsurances({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: patientsV2PatientInsurancesQueryKey(options)
});

export const patientsV2PatientOrdersQueryKey = (options: Options<PatientsV2PatientOrdersData>) => createQueryKey('patientsV2PatientOrders', options);

/**
 * Patient Detail
 *
 * Get patient details by numeric id
 */
export const patientsV2PatientOrdersOptions = (options: Options<PatientsV2PatientOrdersData>) => queryOptions<PatientsV2PatientOrdersResponse, DefaultError, PatientsV2PatientOrdersResponse, ReturnType<typeof patientsV2PatientOrdersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await patientsV2PatientOrders({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: patientsV2PatientOrdersQueryKey(options)
});

export const patientsV2PatientOrdersInfiniteQueryKey = (options: Options<PatientsV2PatientOrdersData>): QueryKey<Options<PatientsV2PatientOrdersData>> => createQueryKey('patientsV2PatientOrders', options, true);

/**
 * Patient Detail
 *
 * Get patient details by numeric id
 */
export const patientsV2PatientOrdersInfiniteOptions = (options: Options<PatientsV2PatientOrdersData>) => infiniteQueryOptions<PatientsV2PatientOrdersResponse, DefaultError, InfiniteData<PatientsV2PatientOrdersResponse>, QueryKey<Options<PatientsV2PatientOrdersData>>, number | Pick<QueryKey<Options<PatientsV2PatientOrdersData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<PatientsV2PatientOrdersData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await patientsV2PatientOrders({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: patientsV2PatientOrdersInfiniteQueryKey(options)
});

export const patientsV2ReassignPatientMutation = (options?: Partial<Options<PatientsV2ReassignPatientData>>): UseMutationOptions<PatientsV2ReassignPatientResponse, DefaultError, Options<PatientsV2ReassignPatientData>> => {
    const mutationOptions: UseMutationOptions<PatientsV2ReassignPatientResponse, DefaultError, Options<PatientsV2ReassignPatientData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patientsV2ReassignPatient({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create a Carrier Coverage Zone Product
 */
export const productsV2CarrierCoverageZoneProductsV2CreateCarrierCoverageZoneProductMutation = (options?: Partial<Options<ProductsV2CarrierCoverageZoneProductsV2CreateCarrierCoverageZoneProductData>>): UseMutationOptions<ProductsV2CarrierCoverageZoneProductsV2CreateCarrierCoverageZoneProductResponse, DefaultError, Options<ProductsV2CarrierCoverageZoneProductsV2CreateCarrierCoverageZoneProductData>> => {
    const mutationOptions: UseMutationOptions<ProductsV2CarrierCoverageZoneProductsV2CreateCarrierCoverageZoneProductResponse, DefaultError, Options<ProductsV2CarrierCoverageZoneProductsV2CreateCarrierCoverageZoneProductData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await productsV2CarrierCoverageZoneProductsV2CreateCarrierCoverageZoneProduct({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const productsV2CarrierCoverageZoneProductsV2HeartbeatQueryKey = (options?: Options<ProductsV2CarrierCoverageZoneProductsV2HeartbeatData>) => createQueryKey('productsV2CarrierCoverageZoneProductsV2Heartbeat', options);

export const productsV2CarrierCoverageZoneProductsV2HeartbeatOptions = (options?: Options<ProductsV2CarrierCoverageZoneProductsV2HeartbeatData>) => queryOptions<ProductsV2CarrierCoverageZoneProductsV2HeartbeatResponse, DefaultError, ProductsV2CarrierCoverageZoneProductsV2HeartbeatResponse, ReturnType<typeof productsV2CarrierCoverageZoneProductsV2HeartbeatQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await productsV2CarrierCoverageZoneProductsV2Heartbeat({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: productsV2CarrierCoverageZoneProductsV2HeartbeatQueryKey(options)
});

export const productsV2CarrierCoverageZoneProductsV2GetCarrierCoverageZoneProductDetailsQueryKey = (options: Options<ProductsV2CarrierCoverageZoneProductsV2GetCarrierCoverageZoneProductDetailsData>) => createQueryKey('productsV2CarrierCoverageZoneProductsV2GetCarrierCoverageZoneProductDetails', options);

/**
 * Get Carrier Coverage Zone Product by uuid
 */
export const productsV2CarrierCoverageZoneProductsV2GetCarrierCoverageZoneProductDetailsOptions = (options: Options<ProductsV2CarrierCoverageZoneProductsV2GetCarrierCoverageZoneProductDetailsData>) => queryOptions<ProductsV2CarrierCoverageZoneProductsV2GetCarrierCoverageZoneProductDetailsResponse, DefaultError, ProductsV2CarrierCoverageZoneProductsV2GetCarrierCoverageZoneProductDetailsResponse, ReturnType<typeof productsV2CarrierCoverageZoneProductsV2GetCarrierCoverageZoneProductDetailsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await productsV2CarrierCoverageZoneProductsV2GetCarrierCoverageZoneProductDetails({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: productsV2CarrierCoverageZoneProductsV2GetCarrierCoverageZoneProductDetailsQueryKey(options)
});

/**
 * Delete a Carrier Coverage Zone Product
 */
export const productsV2CarrierCoverageZoneProductsV2DeleteCarrierCoverageZoneProductMutation = (options?: Partial<Options<ProductsV2CarrierCoverageZoneProductsV2DeleteCarrierCoverageZoneProductData>>): UseMutationOptions<ProductsV2CarrierCoverageZoneProductsV2DeleteCarrierCoverageZoneProductResponse, DefaultError, Options<ProductsV2CarrierCoverageZoneProductsV2DeleteCarrierCoverageZoneProductData>> => {
    const mutationOptions: UseMutationOptions<ProductsV2CarrierCoverageZoneProductsV2DeleteCarrierCoverageZoneProductResponse, DefaultError, Options<ProductsV2CarrierCoverageZoneProductsV2DeleteCarrierCoverageZoneProductData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await productsV2CarrierCoverageZoneProductsV2DeleteCarrierCoverageZoneProduct({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Edit a Carrier Coverage Zone Product
 */
export const productsV2CarrierCoverageZoneProductsV2EditCarrierCoverageZoneProductMutation = (options?: Partial<Options<ProductsV2CarrierCoverageZoneProductsV2EditCarrierCoverageZoneProductData>>): UseMutationOptions<ProductsV2CarrierCoverageZoneProductsV2EditCarrierCoverageZoneProductResponse, DefaultError, Options<ProductsV2CarrierCoverageZoneProductsV2EditCarrierCoverageZoneProductData>> => {
    const mutationOptions: UseMutationOptions<ProductsV2CarrierCoverageZoneProductsV2EditCarrierCoverageZoneProductResponse, DefaultError, Options<ProductsV2CarrierCoverageZoneProductsV2EditCarrierCoverageZoneProductData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await productsV2CarrierCoverageZoneProductsV2EditCarrierCoverageZoneProduct({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const productsV2CartV2DeleteCartMutation = (options?: Partial<Options<ProductsV2CartV2DeleteCartData>>): UseMutationOptions<ProductsV2CartV2DeleteCartResponse, DefaultError, Options<ProductsV2CartV2DeleteCartData>> => {
    const mutationOptions: UseMutationOptions<ProductsV2CartV2DeleteCartResponse, DefaultError, Options<ProductsV2CartV2DeleteCartData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await productsV2CartV2DeleteCart({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const productsV2CartV2GetCartQueryKey = (options?: Options<ProductsV2CartV2GetCartData>) => createQueryKey('productsV2CartV2GetCart', options);

export const productsV2CartV2GetCartOptions = (options?: Options<ProductsV2CartV2GetCartData>) => queryOptions<ProductsV2CartV2GetCartResponse, DefaultError, ProductsV2CartV2GetCartResponse, ReturnType<typeof productsV2CartV2GetCartQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await productsV2CartV2GetCart({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: productsV2CartV2GetCartQueryKey(options)
});

export const postProductsV2CartV2CreateUpdateCartMutation = (options?: Partial<Options<PostProductsV2CartV2CreateUpdateCartData>>): UseMutationOptions<PostProductsV2CartV2CreateUpdateCartResponse, DefaultError, Options<PostProductsV2CartV2CreateUpdateCartData>> => {
    const mutationOptions: UseMutationOptions<PostProductsV2CartV2CreateUpdateCartResponse, DefaultError, Options<PostProductsV2CartV2CreateUpdateCartData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postProductsV2CartV2CreateUpdateCart({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const putProductsV2CartV2CreateUpdateCartMutation = (options?: Partial<Options<PutProductsV2CartV2CreateUpdateCartData>>): UseMutationOptions<PutProductsV2CartV2CreateUpdateCartResponse, DefaultError, Options<PutProductsV2CartV2CreateUpdateCartData>> => {
    const mutationOptions: UseMutationOptions<PutProductsV2CartV2CreateUpdateCartResponse, DefaultError, Options<PutProductsV2CartV2CreateUpdateCartData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putProductsV2CartV2CreateUpdateCart({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const productsV2CategoriesV2GetAllCategoriesQueryKey = (options?: Options<ProductsV2CategoriesV2GetAllCategoriesData>) => createQueryKey('productsV2CategoriesV2GetAllCategories', options);

/**
 * Get all Product Categories
 */
export const productsV2CategoriesV2GetAllCategoriesOptions = (options?: Options<ProductsV2CategoriesV2GetAllCategoriesData>) => queryOptions<ProductsV2CategoriesV2GetAllCategoriesResponse, DefaultError, ProductsV2CategoriesV2GetAllCategoriesResponse, ReturnType<typeof productsV2CategoriesV2GetAllCategoriesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await productsV2CategoriesV2GetAllCategories({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: productsV2CategoriesV2GetAllCategoriesQueryKey(options)
});

export const productsV2CategoriesV2HeartbeatQueryKey = (options?: Options<ProductsV2CategoriesV2HeartbeatData>) => createQueryKey('productsV2CategoriesV2Heartbeat', options);

/**
 * Heartbeat
 *
 * Base validation for the heartbeat endpoint
 */
export const productsV2CategoriesV2HeartbeatOptions = (options?: Options<ProductsV2CategoriesV2HeartbeatData>) => queryOptions<ProductsV2CategoriesV2HeartbeatResponse, DefaultError, ProductsV2CategoriesV2HeartbeatResponse, ReturnType<typeof productsV2CategoriesV2HeartbeatQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await productsV2CategoriesV2Heartbeat({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: productsV2CategoriesV2HeartbeatQueryKey(options)
});

export const productsV2CategoriesV2SearchCategoriesQueryKey = (options?: Options<ProductsV2CategoriesV2SearchCategoriesData>) => createQueryKey('productsV2CategoriesV2SearchCategories', options);

/**
 * Search
 *
 * Retrieve list of records by query term and/or template type (Medicaid/Medicare)
 */
export const productsV2CategoriesV2SearchCategoriesOptions = (options?: Options<ProductsV2CategoriesV2SearchCategoriesData>) => queryOptions<ProductsV2CategoriesV2SearchCategoriesResponse, DefaultError, ProductsV2CategoriesV2SearchCategoriesResponse, ReturnType<typeof productsV2CategoriesV2SearchCategoriesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await productsV2CategoriesV2SearchCategories({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: productsV2CategoriesV2SearchCategoriesQueryKey(options)
});

export const productsV2HeartbeatQueryKey = (options?: Options<ProductsV2HeartbeatData>) => createQueryKey('productsV2Heartbeat', options);

/**
 * Heartbeat
 *
 * Base validation for the heartbeat endpoint
 */
export const productsV2HeartbeatOptions = (options?: Options<ProductsV2HeartbeatData>) => queryOptions<ProductsV2HeartbeatResponse, DefaultError, ProductsV2HeartbeatResponse, ReturnType<typeof productsV2HeartbeatQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await productsV2Heartbeat({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: productsV2HeartbeatQueryKey(options)
});

export const productsV2SearchProductsQueryKey = (options?: Options<ProductsV2SearchProductsData>) => createQueryKey('productsV2SearchProducts', options);

/**
 * Search through Products with filters for CoverageZone, Supplier, Category, and a search term.
 *
 * Filters for CoverageZone and Supplier apply to the product's CarrierCoverageZoneProduct. If any
 * of a products CarrierCoverageZoneProducts match those filters, the parent Product is included in the results.
 */
export const productsV2SearchProductsOptions = (options?: Options<ProductsV2SearchProductsData>) => queryOptions<ProductsV2SearchProductsResponse, DefaultError, ProductsV2SearchProductsResponse, ReturnType<typeof productsV2SearchProductsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await productsV2SearchProducts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: productsV2SearchProductsQueryKey(options)
});

export const productsV2SearchProductsInfiniteQueryKey = (options?: Options<ProductsV2SearchProductsData>): QueryKey<Options<ProductsV2SearchProductsData>> => createQueryKey('productsV2SearchProducts', options, true);

/**
 * Search through Products with filters for CoverageZone, Supplier, Category, and a search term.
 *
 * Filters for CoverageZone and Supplier apply to the product's CarrierCoverageZoneProduct. If any
 * of a products CarrierCoverageZoneProducts match those filters, the parent Product is included in the results.
 */
export const productsV2SearchProductsInfiniteOptions = (options?: Options<ProductsV2SearchProductsData>) => infiniteQueryOptions<ProductsV2SearchProductsResponse, DefaultError, InfiniteData<ProductsV2SearchProductsResponse>, QueryKey<Options<ProductsV2SearchProductsData>>, number | Pick<QueryKey<Options<ProductsV2SearchProductsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ProductsV2SearchProductsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await productsV2SearchProducts({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: productsV2SearchProductsInfiniteQueryKey(options)
});

export const productsV2FoldProductsQueryKey = (options: Options<ProductsV2FoldProductsData>) => createQueryKey('productsV2FoldProducts', options);

export const productsV2FoldProductsOptions = (options: Options<ProductsV2FoldProductsData>) => queryOptions<ProductsV2FoldProductsResponse, DefaultError, ProductsV2FoldProductsResponse, ReturnType<typeof productsV2FoldProductsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await productsV2FoldProducts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: productsV2FoldProductsQueryKey(options)
});

export const productsV2FoldProducts2QueryKey = (options: Options<ProductsV2FoldProducts2Data>) => createQueryKey('productsV2FoldProducts2', options);

export const productsV2FoldProducts2Options = (options: Options<ProductsV2FoldProducts2Data>) => queryOptions<ProductsV2FoldProducts2Response, DefaultError, ProductsV2FoldProducts2Response, ReturnType<typeof productsV2FoldProducts2QueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await productsV2FoldProducts2({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: productsV2FoldProducts2QueryKey(options)
});

export const productsV2FoldProducts3QueryKey = (options: Options<ProductsV2FoldProducts3Data>) => createQueryKey('productsV2FoldProducts3', options);

export const productsV2FoldProducts3Options = (options: Options<ProductsV2FoldProducts3Data>) => queryOptions<ProductsV2FoldProducts3Response, DefaultError, ProductsV2FoldProducts3Response, ReturnType<typeof productsV2FoldProducts3QueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await productsV2FoldProducts3({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: productsV2FoldProducts3QueryKey(options)
});

export const productsV2FoldProducts4QueryKey = (options: Options<ProductsV2FoldProducts4Data>) => createQueryKey('productsV2FoldProducts4', options);

export const productsV2FoldProducts4Options = (options: Options<ProductsV2FoldProducts4Data>) => queryOptions<ProductsV2FoldProducts4Response, DefaultError, ProductsV2FoldProducts4Response, ReturnType<typeof productsV2FoldProducts4QueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await productsV2FoldProducts4({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: productsV2FoldProducts4QueryKey(options)
});

export const productsV2GetProductDetailsQueryKey = (options: Options<ProductsV2GetProductDetailsData>) => createQueryKey('productsV2GetProductDetails', options);

/**
 * Details
 *
 * Get the Product and its associated CarrierCoverageZoneProducts
 */
export const productsV2GetProductDetailsOptions = (options: Options<ProductsV2GetProductDetailsData>) => queryOptions<ProductsV2GetProductDetailsResponse, DefaultError, ProductsV2GetProductDetailsResponse, ReturnType<typeof productsV2GetProductDetailsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await productsV2GetProductDetails({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: productsV2GetProductDetailsQueryKey(options)
});

/**
 * Edit a Product's top-level fields
 */
export const productsV2EditProductMutation = (options?: Partial<Options<ProductsV2EditProductData>>): UseMutationOptions<ProductsV2EditProductResponse, DefaultError, Options<ProductsV2EditProductData>> => {
    const mutationOptions: UseMutationOptions<ProductsV2EditProductResponse, DefaultError, Options<ProductsV2EditProductData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await productsV2EditProduct({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const servicesV2FrontrunnerV2PlanDetailsQueryKey = (options: Options<ServicesV2FrontrunnerV2PlanDetailsData>) => createQueryKey('servicesV2FrontrunnerV2PlanDetails', options);

/**
 * Plan Details — plan-identity values read back from an order's stored eligibility responses.
 *
 * Covers the fields the billed insurance record does not keep: the payer's own name before
 * carrier resolution, the plan name and description the payer reported, and the plan
 * contract identifier. Reads stored responses only; runs no eligibility call.
 *
 * Each entry's memberId and payorId hold the member id and plan code recorded on the
 * insurance it describes, so callers can match on both. Returns payload: [] when the order
 * has no lines whose stored response is in this shape (not 404).
 */
export const servicesV2FrontrunnerV2PlanDetailsOptions = (options: Options<ServicesV2FrontrunnerV2PlanDetailsData>) => queryOptions<ServicesV2FrontrunnerV2PlanDetailsResponse, DefaultError, ServicesV2FrontrunnerV2PlanDetailsResponse, ReturnType<typeof servicesV2FrontrunnerV2PlanDetailsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await servicesV2FrontrunnerV2PlanDetails({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: servicesV2FrontrunnerV2PlanDetailsQueryKey(options)
});

export const servicesV2FrontrunnerV2HeartbeatQueryKey = (options?: Options<ServicesV2FrontrunnerV2HeartbeatData>) => createQueryKey('servicesV2FrontrunnerV2Heartbeat', options);

/**
 * Heartbeat — v2 FrontRunner services blueprint.
 */
export const servicesV2FrontrunnerV2HeartbeatOptions = (options?: Options<ServicesV2FrontrunnerV2HeartbeatData>) => queryOptions<ServicesV2FrontrunnerV2HeartbeatResponse, DefaultError, ServicesV2FrontrunnerV2HeartbeatResponse, ReturnType<typeof servicesV2FrontrunnerV2HeartbeatQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await servicesV2FrontrunnerV2Heartbeat({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: servicesV2FrontrunnerV2HeartbeatQueryKey(options)
});

export const servicesV2FrontrunnerV2PipelineReplayQueryKey = (options: Options<ServicesV2FrontrunnerV2PipelineReplayData>) => createQueryKey('servicesV2FrontrunnerV2PipelineReplay', options);

/**
 * Pipeline Replay — run read-only Elgin discovery + payer ordering for an order.
 *
 * Query params:
 * no_cache (bool, default false): bypass the 24 h FrontRunner response cache.
 * raw (bool, default false): include the raw 271 JSON from the audit trail record.
 *
 * Returns 404 when the order does not exist in MongoDB.
 */
export const servicesV2FrontrunnerV2PipelineReplayOptions = (options: Options<ServicesV2FrontrunnerV2PipelineReplayData>) => queryOptions<ServicesV2FrontrunnerV2PipelineReplayResponse, DefaultError, ServicesV2FrontrunnerV2PipelineReplayResponse, ReturnType<typeof servicesV2FrontrunnerV2PipelineReplayQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await servicesV2FrontrunnerV2PipelineReplay({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: servicesV2FrontrunnerV2PipelineReplayQueryKey(options)
});

export const servicesV2HeartbeatQueryKey = (options?: Options<ServicesV2HeartbeatData>) => createQueryKey('servicesV2Heartbeat', options);

/**
 * Heartbeat — v2 services blueprint.
 */
export const servicesV2HeartbeatOptions = (options?: Options<ServicesV2HeartbeatData>) => queryOptions<ServicesV2HeartbeatResponse, DefaultError, ServicesV2HeartbeatResponse, ReturnType<typeof servicesV2HeartbeatQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await servicesV2Heartbeat({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: servicesV2HeartbeatQueryKey(options)
});

export const suppliersV2GetAllSuppliersQueryKey = (options?: Options<SuppliersV2GetAllSuppliersData>) => createQueryKey('suppliersV2GetAllSuppliers', options);

/**
 * Retrieve all active suppliers.
 */
export const suppliersV2GetAllSuppliersOptions = (options?: Options<SuppliersV2GetAllSuppliersData>) => queryOptions<SuppliersV2GetAllSuppliersResponse, DefaultError, SuppliersV2GetAllSuppliersResponse, ReturnType<typeof suppliersV2GetAllSuppliersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await suppliersV2GetAllSuppliers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: suppliersV2GetAllSuppliersQueryKey(options)
});

export const suppliersV2DetailsQueryKey = (options: Options<SuppliersV2DetailsData>) => createQueryKey('suppliersV2Details', options);

/**
 * Retrieve a supplier by UUID.
 */
export const suppliersV2DetailsOptions = (options: Options<SuppliersV2DetailsData>) => queryOptions<SuppliersV2DetailsResponse, DefaultError, SuppliersV2DetailsResponse, ReturnType<typeof suppliersV2DetailsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await suppliersV2Details({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: suppliersV2DetailsQueryKey(options)
});

export const suppliersV2HeartbeatQueryKey = (options?: Options<SuppliersV2HeartbeatData>) => createQueryKey('suppliersV2Heartbeat', options);

/**
 * Health check endpoint.
 */
export const suppliersV2HeartbeatOptions = (options?: Options<SuppliersV2HeartbeatData>) => queryOptions<SuppliersV2HeartbeatResponse, DefaultError, SuppliersV2HeartbeatResponse, ReturnType<typeof suppliersV2HeartbeatQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await suppliersV2Heartbeat({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: suppliersV2HeartbeatQueryKey(options)
});

export const suppliersV2SearchQueryKey = (options?: Options<SuppliersV2SearchData>) => createQueryKey('suppliersV2Search', options);

/**
 * Search suppliers by query term and/or category.
 */
export const suppliersV2SearchOptions = (options?: Options<SuppliersV2SearchData>) => queryOptions<SuppliersV2SearchResponse, DefaultError, SuppliersV2SearchResponse, ReturnType<typeof suppliersV2SearchQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await suppliersV2Search({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: suppliersV2SearchQueryKey(options)
});

export const suppliersV2SearchInfiniteQueryKey = (options?: Options<SuppliersV2SearchData>): QueryKey<Options<SuppliersV2SearchData>> => createQueryKey('suppliersV2Search', options, true);

/**
 * Search suppliers by query term and/or category.
 */
export const suppliersV2SearchInfiniteOptions = (options?: Options<SuppliersV2SearchData>) => infiniteQueryOptions<SuppliersV2SearchResponse, DefaultError, InfiniteData<SuppliersV2SearchResponse>, QueryKey<Options<SuppliersV2SearchData>>, number | Pick<QueryKey<Options<SuppliersV2SearchData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<SuppliersV2SearchData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await suppliersV2Search({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: suppliersV2SearchInfiniteQueryKey(options)
});

export const suppliersV2Search2QueryKey = (options: Options<SuppliersV2Search2Data>) => createQueryKey('suppliersV2Search2', options);

/**
 * Search suppliers by query term and/or category.
 */
export const suppliersV2Search2Options = (options: Options<SuppliersV2Search2Data>) => queryOptions<SuppliersV2Search2Response, DefaultError, SuppliersV2Search2Response, ReturnType<typeof suppliersV2Search2QueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await suppliersV2Search2({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: suppliersV2Search2QueryKey(options)
});

export const suppliersV2Search2InfiniteQueryKey = (options: Options<SuppliersV2Search2Data>): QueryKey<Options<SuppliersV2Search2Data>> => createQueryKey('suppliersV2Search2', options, true);

/**
 * Search suppliers by query term and/or category.
 */
export const suppliersV2Search2InfiniteOptions = (options: Options<SuppliersV2Search2Data>) => infiniteQueryOptions<SuppliersV2Search2Response, DefaultError, InfiniteData<SuppliersV2Search2Response>, QueryKey<Options<SuppliersV2Search2Data>>, number | Pick<QueryKey<Options<SuppliersV2Search2Data>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<SuppliersV2Search2Data>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await suppliersV2Search2({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: suppliersV2Search2InfiniteQueryKey(options)
});

/**
 * Insurance Card Presigned Upload URL
 *
 * Issues a short-lived presigned S3 PUT URL the FE uses to upload one card
 * image directly to S3. After the upload succeeds the FE registers the
 * resulting s3_object_key on the cache entry via
 * PUT /v3/insurance/cards/<verification_key>.
 *
 * Returns 404 when the verification_key has no cache entry.
 */
export const insuranceV3CardUploadUrlMutation = (options?: Partial<Options<InsuranceV3CardUploadUrlData>>): UseMutationOptions<InsuranceV3CardUploadUrlResponse, DefaultError, Options<InsuranceV3CardUploadUrlData>> => {
    const mutationOptions: UseMutationOptions<InsuranceV3CardUploadUrlResponse, DefaultError, Options<InsuranceV3CardUploadUrlData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await insuranceV3CardUploadUrl({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Insurance Card Upload
 *
 * Stores front and back card paths on the cached verification record.
 * Returns 404 if the verification_key has no cache entry.
 */
export const insuranceV3PutCardsMutation = (options?: Partial<Options<InsuranceV3PutCardsData>>): UseMutationOptions<InsuranceV3PutCardsResponse, DefaultError, Options<InsuranceV3PutCardsData>> => {
    const mutationOptions: UseMutationOptions<InsuranceV3PutCardsResponse, DefaultError, Options<InsuranceV3PutCardsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await insuranceV3PutCards({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const insuranceV3CarrierStatusesV3ListCarrierStatusesQueryKey = (options?: Options<InsuranceV3CarrierStatusesV3ListCarrierStatusesData>) => createQueryKey('insuranceV3CarrierStatusesV3ListCarrierStatuses', options);

/**
 * List all carrier statuses, sorted by display order.
 *
 * Backs the carrier-admin status dropdown; the small, mostly-static row count
 * makes pagination unnecessary.
 */
export const insuranceV3CarrierStatusesV3ListCarrierStatusesOptions = (options?: Options<InsuranceV3CarrierStatusesV3ListCarrierStatusesData>) => queryOptions<InsuranceV3CarrierStatusesV3ListCarrierStatusesResponse, DefaultError, InsuranceV3CarrierStatusesV3ListCarrierStatusesResponse, ReturnType<typeof insuranceV3CarrierStatusesV3ListCarrierStatusesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await insuranceV3CarrierStatusesV3ListCarrierStatuses({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: insuranceV3CarrierStatusesV3ListCarrierStatusesQueryKey(options)
});

export const insuranceV3CarriersV3CreateCarrierMutation = (options?: Partial<Options<InsuranceV3CarriersV3CreateCarrierData>>): UseMutationOptions<InsuranceV3CarriersV3CreateCarrierResponse, DefaultError, Options<InsuranceV3CarriersV3CreateCarrierData>> => {
    const mutationOptions: UseMutationOptions<InsuranceV3CarriersV3CreateCarrierResponse, DefaultError, Options<InsuranceV3CarriersV3CreateCarrierData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await insuranceV3CarriersV3CreateCarrier({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const insuranceV3CarriersV3SearchCarriersQueryKey = (options?: Options<InsuranceV3CarriersV3SearchCarriersData>) => createQueryKey('insuranceV3CarriersV3SearchCarriers', options);

export const insuranceV3CarriersV3SearchCarriersOptions = (options?: Options<InsuranceV3CarriersV3SearchCarriersData>) => queryOptions<InsuranceV3CarriersV3SearchCarriersResponse, DefaultError, InsuranceV3CarriersV3SearchCarriersResponse, ReturnType<typeof insuranceV3CarriersV3SearchCarriersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await insuranceV3CarriersV3SearchCarriers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: insuranceV3CarriersV3SearchCarriersQueryKey(options)
});

export const insuranceV3CarriersV3SearchCarriersInfiniteQueryKey = (options?: Options<InsuranceV3CarriersV3SearchCarriersData>): QueryKey<Options<InsuranceV3CarriersV3SearchCarriersData>> => createQueryKey('insuranceV3CarriersV3SearchCarriers', options, true);

export const insuranceV3CarriersV3SearchCarriersInfiniteOptions = (options?: Options<InsuranceV3CarriersV3SearchCarriersData>) => infiniteQueryOptions<InsuranceV3CarriersV3SearchCarriersResponse, DefaultError, InfiniteData<InsuranceV3CarriersV3SearchCarriersResponse>, QueryKey<Options<InsuranceV3CarriersV3SearchCarriersData>>, number | Pick<QueryKey<Options<InsuranceV3CarriersV3SearchCarriersData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<InsuranceV3CarriersV3SearchCarriersData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await insuranceV3CarriersV3SearchCarriers({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: insuranceV3CarriersV3SearchCarriersInfiniteQueryKey(options)
});

export const insuranceV3CarriersV3UpdateCarrierMutation = (options?: Partial<Options<InsuranceV3CarriersV3UpdateCarrierData>>): UseMutationOptions<InsuranceV3CarriersV3UpdateCarrierResponse, DefaultError, Options<InsuranceV3CarriersV3UpdateCarrierData>> => {
    const mutationOptions: UseMutationOptions<InsuranceV3CarriersV3UpdateCarrierResponse, DefaultError, Options<InsuranceV3CarriersV3UpdateCarrierData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await insuranceV3CarriersV3UpdateCarrier({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const insuranceV3GetCarriersByStateQueryKey = (options: Options<InsuranceV3GetCarriersByStateData>) => createQueryKey('insuranceV3GetCarriersByState', options);

export const insuranceV3GetCarriersByStateOptions = (options: Options<InsuranceV3GetCarriersByStateData>) => queryOptions<InsuranceV3GetCarriersByStateResponse, DefaultError, InsuranceV3GetCarriersByStateResponse, ReturnType<typeof insuranceV3GetCarriersByStateQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await insuranceV3GetCarriersByState({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: insuranceV3GetCarriersByStateQueryKey(options)
});

export const insuranceV3CodeEligibilityOverridesV3ListCodeEligibilityOverridesQueryKey = (options?: Options<InsuranceV3CodeEligibilityOverridesV3ListCodeEligibilityOverridesData>) => createQueryKey('insuranceV3CodeEligibilityOverridesV3ListCodeEligibilityOverrides', options);

export const insuranceV3CodeEligibilityOverridesV3ListCodeEligibilityOverridesOptions = (options?: Options<InsuranceV3CodeEligibilityOverridesV3ListCodeEligibilityOverridesData>) => queryOptions<InsuranceV3CodeEligibilityOverridesV3ListCodeEligibilityOverridesResponse, DefaultError, InsuranceV3CodeEligibilityOverridesV3ListCodeEligibilityOverridesResponse, ReturnType<typeof insuranceV3CodeEligibilityOverridesV3ListCodeEligibilityOverridesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await insuranceV3CodeEligibilityOverridesV3ListCodeEligibilityOverrides({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: insuranceV3CodeEligibilityOverridesV3ListCodeEligibilityOverridesQueryKey(options)
});

export const insuranceV3CodeEligibilityOverridesV3ListCodeEligibilityOverridesInfiniteQueryKey = (options?: Options<InsuranceV3CodeEligibilityOverridesV3ListCodeEligibilityOverridesData>): QueryKey<Options<InsuranceV3CodeEligibilityOverridesV3ListCodeEligibilityOverridesData>> => createQueryKey('insuranceV3CodeEligibilityOverridesV3ListCodeEligibilityOverrides', options, true);

export const insuranceV3CodeEligibilityOverridesV3ListCodeEligibilityOverridesInfiniteOptions = (options?: Options<InsuranceV3CodeEligibilityOverridesV3ListCodeEligibilityOverridesData>) => infiniteQueryOptions<InsuranceV3CodeEligibilityOverridesV3ListCodeEligibilityOverridesResponse, DefaultError, InfiniteData<InsuranceV3CodeEligibilityOverridesV3ListCodeEligibilityOverridesResponse>, QueryKey<Options<InsuranceV3CodeEligibilityOverridesV3ListCodeEligibilityOverridesData>>, number | Pick<QueryKey<Options<InsuranceV3CodeEligibilityOverridesV3ListCodeEligibilityOverridesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<InsuranceV3CodeEligibilityOverridesV3ListCodeEligibilityOverridesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await insuranceV3CodeEligibilityOverridesV3ListCodeEligibilityOverrides({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: insuranceV3CodeEligibilityOverridesV3ListCodeEligibilityOverridesInfiniteQueryKey(options)
});

export const insuranceV3CodeEligibilityOverridesV3CreateCodeEligibilityOverrideMutation = (options?: Partial<Options<InsuranceV3CodeEligibilityOverridesV3CreateCodeEligibilityOverrideData>>): UseMutationOptions<InsuranceV3CodeEligibilityOverridesV3CreateCodeEligibilityOverrideResponse, DefaultError, Options<InsuranceV3CodeEligibilityOverridesV3CreateCodeEligibilityOverrideData>> => {
    const mutationOptions: UseMutationOptions<InsuranceV3CodeEligibilityOverridesV3CreateCodeEligibilityOverrideResponse, DefaultError, Options<InsuranceV3CodeEligibilityOverridesV3CreateCodeEligibilityOverrideData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await insuranceV3CodeEligibilityOverridesV3CreateCodeEligibilityOverride({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const insuranceV3CodeEligibilityOverridesV3DeleteCodeEligibilityOverrideMutation = (options?: Partial<Options<InsuranceV3CodeEligibilityOverridesV3DeleteCodeEligibilityOverrideData>>): UseMutationOptions<InsuranceV3CodeEligibilityOverridesV3DeleteCodeEligibilityOverrideResponse, DefaultError, Options<InsuranceV3CodeEligibilityOverridesV3DeleteCodeEligibilityOverrideData>> => {
    const mutationOptions: UseMutationOptions<InsuranceV3CodeEligibilityOverridesV3DeleteCodeEligibilityOverrideResponse, DefaultError, Options<InsuranceV3CodeEligibilityOverridesV3DeleteCodeEligibilityOverrideData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await insuranceV3CodeEligibilityOverridesV3DeleteCodeEligibilityOverride({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const insuranceV3CodeEligibilityOverridesV3UpdateCodeEligibilityOverrideMutation = (options?: Partial<Options<InsuranceV3CodeEligibilityOverridesV3UpdateCodeEligibilityOverrideData>>): UseMutationOptions<InsuranceV3CodeEligibilityOverridesV3UpdateCodeEligibilityOverrideResponse, DefaultError, Options<InsuranceV3CodeEligibilityOverridesV3UpdateCodeEligibilityOverrideData>> => {
    const mutationOptions: UseMutationOptions<InsuranceV3CodeEligibilityOverridesV3UpdateCodeEligibilityOverrideResponse, DefaultError, Options<InsuranceV3CodeEligibilityOverridesV3UpdateCodeEligibilityOverrideData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await insuranceV3CodeEligibilityOverridesV3UpdateCodeEligibilityOverride({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const insuranceV3CodesV3SearchCodesQueryKey = (options?: Options<InsuranceV3CodesV3SearchCodesData>) => createQueryKey('insuranceV3CodesV3SearchCodes', options);

export const insuranceV3CodesV3SearchCodesOptions = (options?: Options<InsuranceV3CodesV3SearchCodesData>) => queryOptions<InsuranceV3CodesV3SearchCodesResponse, DefaultError, InsuranceV3CodesV3SearchCodesResponse, ReturnType<typeof insuranceV3CodesV3SearchCodesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await insuranceV3CodesV3SearchCodes({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: insuranceV3CodesV3SearchCodesQueryKey(options)
});

export const insuranceV3CodesV3SearchCodesInfiniteQueryKey = (options?: Options<InsuranceV3CodesV3SearchCodesData>): QueryKey<Options<InsuranceV3CodesV3SearchCodesData>> => createQueryKey('insuranceV3CodesV3SearchCodes', options, true);

export const insuranceV3CodesV3SearchCodesInfiniteOptions = (options?: Options<InsuranceV3CodesV3SearchCodesData>) => infiniteQueryOptions<InsuranceV3CodesV3SearchCodesResponse, DefaultError, InfiniteData<InsuranceV3CodesV3SearchCodesResponse>, QueryKey<Options<InsuranceV3CodesV3SearchCodesData>>, number | Pick<QueryKey<Options<InsuranceV3CodesV3SearchCodesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<InsuranceV3CodesV3SearchCodesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await insuranceV3CodesV3SearchCodes({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: insuranceV3CodesV3SearchCodesInfiniteQueryKey(options)
});

export const insuranceV3CoverageZonesV3ListCoverageZonesQueryKey = (options?: Options<InsuranceV3CoverageZonesV3ListCoverageZonesData>) => createQueryKey('insuranceV3CoverageZonesV3ListCoverageZones', options);

/**
 * List all coverage zones (states), sorted by abbreviation.
 *
 * Backs the carrier-admin state multi-select; the small, mostly-static row count
 * makes pagination unnecessary.
 */
export const insuranceV3CoverageZonesV3ListCoverageZonesOptions = (options?: Options<InsuranceV3CoverageZonesV3ListCoverageZonesData>) => queryOptions<InsuranceV3CoverageZonesV3ListCoverageZonesResponse, DefaultError, InsuranceV3CoverageZonesV3ListCoverageZonesResponse, ReturnType<typeof insuranceV3CoverageZonesV3ListCoverageZonesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await insuranceV3CoverageZonesV3ListCoverageZones({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: insuranceV3CoverageZonesV3ListCoverageZonesQueryKey(options)
});

export const insuranceV3HeartbeatQueryKey = (options?: Options<InsuranceV3HeartbeatData>) => createQueryKey('insuranceV3Heartbeat', options);

/**
 * Heartbeat
 *
 * Base validation for the heartbeat endpoint
 */
export const insuranceV3HeartbeatOptions = (options?: Options<InsuranceV3HeartbeatData>) => queryOptions<InsuranceV3HeartbeatResponse, DefaultError, InsuranceV3HeartbeatResponse, ReturnType<typeof insuranceV3HeartbeatQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await insuranceV3Heartbeat({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: insuranceV3HeartbeatQueryKey(options)
});

/**
 * Run Mappy For Orders
 *
 * Run the ``initiate_mappy_for_order`` task for one or more orders. By default
 * the work is enqueued as a Celery task per order and the response returns the
 * task ids. Pass ``synchronous=true`` with exactly one order to run the task
 * inline and return its result directly.
 */
export const insuranceV3MappyMutation = (options?: Partial<Options<InsuranceV3MappyData>>): UseMutationOptions<InsuranceV3MappyResponse, DefaultError, Options<InsuranceV3MappyData>> => {
    const mutationOptions: UseMutationOptions<InsuranceV3MappyResponse, DefaultError, Options<InsuranceV3MappyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await insuranceV3Mappy({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const insuranceV3NetworkStatusDesignationsV3ListNetworkStatusDesignationsQueryKey = (options?: Options<InsuranceV3NetworkStatusDesignationsV3ListNetworkStatusDesignationsData>) => createQueryKey('insuranceV3NetworkStatusDesignationsV3ListNetworkStatusDesignations', options);

export const insuranceV3NetworkStatusDesignationsV3ListNetworkStatusDesignationsOptions = (options?: Options<InsuranceV3NetworkStatusDesignationsV3ListNetworkStatusDesignationsData>) => queryOptions<InsuranceV3NetworkStatusDesignationsV3ListNetworkStatusDesignationsResponse, DefaultError, InsuranceV3NetworkStatusDesignationsV3ListNetworkStatusDesignationsResponse, ReturnType<typeof insuranceV3NetworkStatusDesignationsV3ListNetworkStatusDesignationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await insuranceV3NetworkStatusDesignationsV3ListNetworkStatusDesignations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: insuranceV3NetworkStatusDesignationsV3ListNetworkStatusDesignationsQueryKey(options)
});

export const insuranceV3NetworkStatusDesignationsV3ListNetworkStatusDesignationsInfiniteQueryKey = (options?: Options<InsuranceV3NetworkStatusDesignationsV3ListNetworkStatusDesignationsData>): QueryKey<Options<InsuranceV3NetworkStatusDesignationsV3ListNetworkStatusDesignationsData>> => createQueryKey('insuranceV3NetworkStatusDesignationsV3ListNetworkStatusDesignations', options, true);

export const insuranceV3NetworkStatusDesignationsV3ListNetworkStatusDesignationsInfiniteOptions = (options?: Options<InsuranceV3NetworkStatusDesignationsV3ListNetworkStatusDesignationsData>) => infiniteQueryOptions<InsuranceV3NetworkStatusDesignationsV3ListNetworkStatusDesignationsResponse, DefaultError, InfiniteData<InsuranceV3NetworkStatusDesignationsV3ListNetworkStatusDesignationsResponse>, QueryKey<Options<InsuranceV3NetworkStatusDesignationsV3ListNetworkStatusDesignationsData>>, number | Pick<QueryKey<Options<InsuranceV3NetworkStatusDesignationsV3ListNetworkStatusDesignationsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<InsuranceV3NetworkStatusDesignationsV3ListNetworkStatusDesignationsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await insuranceV3NetworkStatusDesignationsV3ListNetworkStatusDesignations({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: insuranceV3NetworkStatusDesignationsV3ListNetworkStatusDesignationsInfiniteQueryKey(options)
});

export const insuranceV3NetworkStatusDesignationsV3CreateNetworkStatusDesignationMutation = (options?: Partial<Options<InsuranceV3NetworkStatusDesignationsV3CreateNetworkStatusDesignationData>>): UseMutationOptions<InsuranceV3NetworkStatusDesignationsV3CreateNetworkStatusDesignationResponse, DefaultError, Options<InsuranceV3NetworkStatusDesignationsV3CreateNetworkStatusDesignationData>> => {
    const mutationOptions: UseMutationOptions<InsuranceV3NetworkStatusDesignationsV3CreateNetworkStatusDesignationResponse, DefaultError, Options<InsuranceV3NetworkStatusDesignationsV3CreateNetworkStatusDesignationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await insuranceV3NetworkStatusDesignationsV3CreateNetworkStatusDesignation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const insuranceV3NetworkStatusDesignationsV3DeleteNetworkStatusDesignationMutation = (options?: Partial<Options<InsuranceV3NetworkStatusDesignationsV3DeleteNetworkStatusDesignationData>>): UseMutationOptions<InsuranceV3NetworkStatusDesignationsV3DeleteNetworkStatusDesignationResponse, DefaultError, Options<InsuranceV3NetworkStatusDesignationsV3DeleteNetworkStatusDesignationData>> => {
    const mutationOptions: UseMutationOptions<InsuranceV3NetworkStatusDesignationsV3DeleteNetworkStatusDesignationResponse, DefaultError, Options<InsuranceV3NetworkStatusDesignationsV3DeleteNetworkStatusDesignationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await insuranceV3NetworkStatusDesignationsV3DeleteNetworkStatusDesignation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const insuranceV3NetworkStatusDesignationsV3UpdateNetworkStatusDesignationMutation = (options?: Partial<Options<InsuranceV3NetworkStatusDesignationsV3UpdateNetworkStatusDesignationData>>): UseMutationOptions<InsuranceV3NetworkStatusDesignationsV3UpdateNetworkStatusDesignationResponse, DefaultError, Options<InsuranceV3NetworkStatusDesignationsV3UpdateNetworkStatusDesignationData>> => {
    const mutationOptions: UseMutationOptions<InsuranceV3NetworkStatusDesignationsV3UpdateNetworkStatusDesignationResponse, DefaultError, Options<InsuranceV3NetworkStatusDesignationsV3UpdateNetworkStatusDesignationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await insuranceV3NetworkStatusDesignationsV3UpdateNetworkStatusDesignation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Order Insurance Discovery
 *
 * Run insurance discovery for an order, write results to the order document, and return an acknowledgment.
 */
export const insuranceV3OrderDiscoveryMutation = (options?: Partial<Options<InsuranceV3OrderDiscoveryData>>): UseMutationOptions<unknown, DefaultError, Options<InsuranceV3OrderDiscoveryData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<InsuranceV3OrderDiscoveryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await insuranceV3OrderDiscovery({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Order Eligibility Verification
 *
 * Run eligibility check for an order's insurance, write results to the order document, and return an acknowledgment.
 */
export const insuranceV3OrderEligibilityMutation = (options?: Partial<Options<InsuranceV3OrderEligibilityData>>): UseMutationOptions<unknown, DefaultError, Options<InsuranceV3OrderEligibilityData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<InsuranceV3OrderEligibilityData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await insuranceV3OrderEligibility({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const insuranceV3PlanCodesV3CreatePlanCodeMutation = (options?: Partial<Options<InsuranceV3PlanCodesV3CreatePlanCodeData>>): UseMutationOptions<InsuranceV3PlanCodesV3CreatePlanCodeResponse, DefaultError, Options<InsuranceV3PlanCodesV3CreatePlanCodeData>> => {
    const mutationOptions: UseMutationOptions<InsuranceV3PlanCodesV3CreatePlanCodeResponse, DefaultError, Options<InsuranceV3PlanCodesV3CreatePlanCodeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await insuranceV3PlanCodesV3CreatePlanCode({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const insuranceV3PlanCodesV3SearchPlanCodesQueryKey = (options?: Options<InsuranceV3PlanCodesV3SearchPlanCodesData>) => createQueryKey('insuranceV3PlanCodesV3SearchPlanCodes', options);

export const insuranceV3PlanCodesV3SearchPlanCodesOptions = (options?: Options<InsuranceV3PlanCodesV3SearchPlanCodesData>) => queryOptions<InsuranceV3PlanCodesV3SearchPlanCodesResponse, DefaultError, InsuranceV3PlanCodesV3SearchPlanCodesResponse, ReturnType<typeof insuranceV3PlanCodesV3SearchPlanCodesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await insuranceV3PlanCodesV3SearchPlanCodes({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: insuranceV3PlanCodesV3SearchPlanCodesQueryKey(options)
});

export const insuranceV3PlanCodesV3SearchPlanCodesInfiniteQueryKey = (options?: Options<InsuranceV3PlanCodesV3SearchPlanCodesData>): QueryKey<Options<InsuranceV3PlanCodesV3SearchPlanCodesData>> => createQueryKey('insuranceV3PlanCodesV3SearchPlanCodes', options, true);

export const insuranceV3PlanCodesV3SearchPlanCodesInfiniteOptions = (options?: Options<InsuranceV3PlanCodesV3SearchPlanCodesData>) => infiniteQueryOptions<InsuranceV3PlanCodesV3SearchPlanCodesResponse, DefaultError, InfiniteData<InsuranceV3PlanCodesV3SearchPlanCodesResponse>, QueryKey<Options<InsuranceV3PlanCodesV3SearchPlanCodesData>>, number | Pick<QueryKey<Options<InsuranceV3PlanCodesV3SearchPlanCodesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<InsuranceV3PlanCodesV3SearchPlanCodesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await insuranceV3PlanCodesV3SearchPlanCodes({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: insuranceV3PlanCodesV3SearchPlanCodesInfiniteQueryKey(options)
});

export const insuranceV3PlanCodesV3GetPlanCodeQueryKey = (options: Options<InsuranceV3PlanCodesV3GetPlanCodeData>) => createQueryKey('insuranceV3PlanCodesV3GetPlanCode', options);

export const insuranceV3PlanCodesV3GetPlanCodeOptions = (options: Options<InsuranceV3PlanCodesV3GetPlanCodeData>) => queryOptions<InsuranceV3PlanCodesV3GetPlanCodeResponse, DefaultError, InsuranceV3PlanCodesV3GetPlanCodeResponse, ReturnType<typeof insuranceV3PlanCodesV3GetPlanCodeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await insuranceV3PlanCodesV3GetPlanCode({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: insuranceV3PlanCodesV3GetPlanCodeQueryKey(options)
});

export const insuranceV3PlanCodesV3UpdatePlanCodeMutation = (options?: Partial<Options<InsuranceV3PlanCodesV3UpdatePlanCodeData>>): UseMutationOptions<InsuranceV3PlanCodesV3UpdatePlanCodeResponse, DefaultError, Options<InsuranceV3PlanCodesV3UpdatePlanCodeData>> => {
    const mutationOptions: UseMutationOptions<InsuranceV3PlanCodesV3UpdatePlanCodeResponse, DefaultError, Options<InsuranceV3PlanCodesV3UpdatePlanCodeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await insuranceV3PlanCodesV3UpdatePlanCode({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const insuranceV3PlansV3CreatePlanMutation = (options?: Partial<Options<InsuranceV3PlansV3CreatePlanData>>): UseMutationOptions<InsuranceV3PlansV3CreatePlanResponse, DefaultError, Options<InsuranceV3PlansV3CreatePlanData>> => {
    const mutationOptions: UseMutationOptions<InsuranceV3PlansV3CreatePlanResponse, DefaultError, Options<InsuranceV3PlansV3CreatePlanData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await insuranceV3PlansV3CreatePlan({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const insuranceV3PlansV3SearchCandidPayersQueryKey = (options: Options<InsuranceV3PlansV3SearchCandidPayersData>) => createQueryKey('insuranceV3PlansV3SearchCandidPayers', options);

export const insuranceV3PlansV3SearchCandidPayersOptions = (options: Options<InsuranceV3PlansV3SearchCandidPayersData>) => queryOptions<InsuranceV3PlansV3SearchCandidPayersResponse, DefaultError, InsuranceV3PlansV3SearchCandidPayersResponse, ReturnType<typeof insuranceV3PlansV3SearchCandidPayersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await insuranceV3PlansV3SearchCandidPayers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: insuranceV3PlansV3SearchCandidPayersQueryKey(options)
});

export const insuranceV3PlansV3SearchEhrPlansQueryKey = (options?: Options<InsuranceV3PlansV3SearchEhrPlansData>) => createQueryKey('insuranceV3PlansV3SearchEhrPlans', options);

export const insuranceV3PlansV3SearchEhrPlansOptions = (options?: Options<InsuranceV3PlansV3SearchEhrPlansData>) => queryOptions<InsuranceV3PlansV3SearchEhrPlansResponse, DefaultError, InsuranceV3PlansV3SearchEhrPlansResponse, ReturnType<typeof insuranceV3PlansV3SearchEhrPlansQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await insuranceV3PlansV3SearchEhrPlans({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: insuranceV3PlansV3SearchEhrPlansQueryKey(options)
});

export const insuranceV3PlansV3SearchEhrPlansInfiniteQueryKey = (options?: Options<InsuranceV3PlansV3SearchEhrPlansData>): QueryKey<Options<InsuranceV3PlansV3SearchEhrPlansData>> => createQueryKey('insuranceV3PlansV3SearchEhrPlans', options, true);

export const insuranceV3PlansV3SearchEhrPlansInfiniteOptions = (options?: Options<InsuranceV3PlansV3SearchEhrPlansData>) => infiniteQueryOptions<InsuranceV3PlansV3SearchEhrPlansResponse, DefaultError, InfiniteData<InsuranceV3PlansV3SearchEhrPlansResponse>, QueryKey<Options<InsuranceV3PlansV3SearchEhrPlansData>>, string | null | Pick<QueryKey<Options<InsuranceV3PlansV3SearchEhrPlansData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<InsuranceV3PlansV3SearchEhrPlansData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                after: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await insuranceV3PlansV3SearchEhrPlans({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: insuranceV3PlansV3SearchEhrPlansInfiniteQueryKey(options)
});

export const insuranceV3PlansV3SearchPlansQueryKey = (options?: Options<InsuranceV3PlansV3SearchPlansData>) => createQueryKey('insuranceV3PlansV3SearchPlans', options);

export const insuranceV3PlansV3SearchPlansOptions = (options?: Options<InsuranceV3PlansV3SearchPlansData>) => queryOptions<InsuranceV3PlansV3SearchPlansResponse, DefaultError, InsuranceV3PlansV3SearchPlansResponse, ReturnType<typeof insuranceV3PlansV3SearchPlansQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await insuranceV3PlansV3SearchPlans({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: insuranceV3PlansV3SearchPlansQueryKey(options)
});

export const insuranceV3PlansV3SearchPlansInfiniteQueryKey = (options?: Options<InsuranceV3PlansV3SearchPlansData>): QueryKey<Options<InsuranceV3PlansV3SearchPlansData>> => createQueryKey('insuranceV3PlansV3SearchPlans', options, true);

export const insuranceV3PlansV3SearchPlansInfiniteOptions = (options?: Options<InsuranceV3PlansV3SearchPlansData>) => infiniteQueryOptions<InsuranceV3PlansV3SearchPlansResponse, DefaultError, InfiniteData<InsuranceV3PlansV3SearchPlansResponse>, QueryKey<Options<InsuranceV3PlansV3SearchPlansData>>, number | Pick<QueryKey<Options<InsuranceV3PlansV3SearchPlansData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<InsuranceV3PlansV3SearchPlansData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await insuranceV3PlansV3SearchPlans({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: insuranceV3PlansV3SearchPlansInfiniteQueryKey(options)
});

export const insuranceV3PlansV3GetPlanQueryKey = (options: Options<InsuranceV3PlansV3GetPlanData>) => createQueryKey('insuranceV3PlansV3GetPlan', options);

export const insuranceV3PlansV3GetPlanOptions = (options: Options<InsuranceV3PlansV3GetPlanData>) => queryOptions<InsuranceV3PlansV3GetPlanResponse, DefaultError, InsuranceV3PlansV3GetPlanResponse, ReturnType<typeof insuranceV3PlansV3GetPlanQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await insuranceV3PlansV3GetPlan({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: insuranceV3PlansV3GetPlanQueryKey(options)
});

export const insuranceV3PlansV3UpdatePlanMutation = (options?: Partial<Options<InsuranceV3PlansV3UpdatePlanData>>): UseMutationOptions<InsuranceV3PlansV3UpdatePlanResponse, DefaultError, Options<InsuranceV3PlansV3UpdatePlanData>> => {
    const mutationOptions: UseMutationOptions<InsuranceV3PlansV3UpdatePlanResponse, DefaultError, Options<InsuranceV3PlansV3UpdatePlanData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await insuranceV3PlansV3UpdatePlan({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Insurance Discovery: delegate to discovery service, then shape HTTP response and metrics.
 */
export const insuranceV3DiscoveryMutation = (options?: Partial<Options<InsuranceV3DiscoveryData>>): UseMutationOptions<InsuranceV3DiscoveryResponse, DefaultError, Options<InsuranceV3DiscoveryData>> => {
    const mutationOptions: UseMutationOptions<InsuranceV3DiscoveryResponse, DefaultError, Options<InsuranceV3DiscoveryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await insuranceV3Discovery({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const insuranceV3SupplierBillingAssignmentsV3ListSupplierBillingAssignmentsQueryKey = (options?: Options<InsuranceV3SupplierBillingAssignmentsV3ListSupplierBillingAssignmentsData>) => createQueryKey('insuranceV3SupplierBillingAssignmentsV3ListSupplierBillingAssignments', options);

export const insuranceV3SupplierBillingAssignmentsV3ListSupplierBillingAssignmentsOptions = (options?: Options<InsuranceV3SupplierBillingAssignmentsV3ListSupplierBillingAssignmentsData>) => queryOptions<InsuranceV3SupplierBillingAssignmentsV3ListSupplierBillingAssignmentsResponse, DefaultError, InsuranceV3SupplierBillingAssignmentsV3ListSupplierBillingAssignmentsResponse, ReturnType<typeof insuranceV3SupplierBillingAssignmentsV3ListSupplierBillingAssignmentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await insuranceV3SupplierBillingAssignmentsV3ListSupplierBillingAssignments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: insuranceV3SupplierBillingAssignmentsV3ListSupplierBillingAssignmentsQueryKey(options)
});

export const insuranceV3SupplierBillingAssignmentsV3ListSupplierBillingAssignmentsInfiniteQueryKey = (options?: Options<InsuranceV3SupplierBillingAssignmentsV3ListSupplierBillingAssignmentsData>): QueryKey<Options<InsuranceV3SupplierBillingAssignmentsV3ListSupplierBillingAssignmentsData>> => createQueryKey('insuranceV3SupplierBillingAssignmentsV3ListSupplierBillingAssignments', options, true);

export const insuranceV3SupplierBillingAssignmentsV3ListSupplierBillingAssignmentsInfiniteOptions = (options?: Options<InsuranceV3SupplierBillingAssignmentsV3ListSupplierBillingAssignmentsData>) => infiniteQueryOptions<InsuranceV3SupplierBillingAssignmentsV3ListSupplierBillingAssignmentsResponse, DefaultError, InfiniteData<InsuranceV3SupplierBillingAssignmentsV3ListSupplierBillingAssignmentsResponse>, QueryKey<Options<InsuranceV3SupplierBillingAssignmentsV3ListSupplierBillingAssignmentsData>>, number | Pick<QueryKey<Options<InsuranceV3SupplierBillingAssignmentsV3ListSupplierBillingAssignmentsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<InsuranceV3SupplierBillingAssignmentsV3ListSupplierBillingAssignmentsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await insuranceV3SupplierBillingAssignmentsV3ListSupplierBillingAssignments({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: insuranceV3SupplierBillingAssignmentsV3ListSupplierBillingAssignmentsInfiniteQueryKey(options)
});

export const insuranceV3SupplierBillingAssignmentsV3CreateSupplierBillingAssignmentMutation = (options?: Partial<Options<InsuranceV3SupplierBillingAssignmentsV3CreateSupplierBillingAssignmentData>>): UseMutationOptions<InsuranceV3SupplierBillingAssignmentsV3CreateSupplierBillingAssignmentResponse, DefaultError, Options<InsuranceV3SupplierBillingAssignmentsV3CreateSupplierBillingAssignmentData>> => {
    const mutationOptions: UseMutationOptions<InsuranceV3SupplierBillingAssignmentsV3CreateSupplierBillingAssignmentResponse, DefaultError, Options<InsuranceV3SupplierBillingAssignmentsV3CreateSupplierBillingAssignmentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await insuranceV3SupplierBillingAssignmentsV3CreateSupplierBillingAssignment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const insuranceV3SupplierBillingAssignmentsV3DeleteSupplierBillingAssignmentMutation = (options?: Partial<Options<InsuranceV3SupplierBillingAssignmentsV3DeleteSupplierBillingAssignmentData>>): UseMutationOptions<InsuranceV3SupplierBillingAssignmentsV3DeleteSupplierBillingAssignmentResponse, DefaultError, Options<InsuranceV3SupplierBillingAssignmentsV3DeleteSupplierBillingAssignmentData>> => {
    const mutationOptions: UseMutationOptions<InsuranceV3SupplierBillingAssignmentsV3DeleteSupplierBillingAssignmentResponse, DefaultError, Options<InsuranceV3SupplierBillingAssignmentsV3DeleteSupplierBillingAssignmentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await insuranceV3SupplierBillingAssignmentsV3DeleteSupplierBillingAssignment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const insuranceV3SupplierBillingAssignmentsV3UpdateSupplierBillingAssignmentMutation = (options?: Partial<Options<InsuranceV3SupplierBillingAssignmentsV3UpdateSupplierBillingAssignmentData>>): UseMutationOptions<InsuranceV3SupplierBillingAssignmentsV3UpdateSupplierBillingAssignmentResponse, DefaultError, Options<InsuranceV3SupplierBillingAssignmentsV3UpdateSupplierBillingAssignmentData>> => {
    const mutationOptions: UseMutationOptions<InsuranceV3SupplierBillingAssignmentsV3UpdateSupplierBillingAssignmentResponse, DefaultError, Options<InsuranceV3SupplierBillingAssignmentsV3UpdateSupplierBillingAssignmentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await insuranceV3SupplierBillingAssignmentsV3UpdateSupplierBillingAssignment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const insuranceV3TestVerificationKeyQueryKey = (options: Options<InsuranceV3TestVerificationKeyData>) => createQueryKey('insuranceV3TestVerificationKey', options);

export const insuranceV3TestVerificationKeyOptions = (options: Options<InsuranceV3TestVerificationKeyData>) => queryOptions<InsuranceV3TestVerificationKeyResponse, DefaultError, InsuranceV3TestVerificationKeyResponse, ReturnType<typeof insuranceV3TestVerificationKeyQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await insuranceV3TestVerificationKey({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: insuranceV3TestVerificationKeyQueryKey(options)
});

/**
 * Patient Eligibility: delegate to verification service, then shape HTTP response and metrics.
 */
export const insuranceV3VerificationMutation = (options?: Partial<Options<InsuranceV3VerificationData>>): UseMutationOptions<InsuranceV3VerificationResponse, DefaultError, Options<InsuranceV3VerificationData>> => {
    const mutationOptions: UseMutationOptions<InsuranceV3VerificationResponse, DefaultError, Options<InsuranceV3VerificationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await insuranceV3Verification({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const productsV3GetProductsQueryKey = (options: Options<ProductsV3GetProductsData>) => createQueryKey('productsV3GetProducts', options);

export const productsV3GetProductsOptions = (options: Options<ProductsV3GetProductsData>) => queryOptions<ProductsV3GetProductsResponse, DefaultError, ProductsV3GetProductsResponse, ReturnType<typeof productsV3GetProductsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await productsV3GetProducts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: productsV3GetProductsQueryKey(options)
});

export const productsV3GetProductsInfiniteQueryKey = (options: Options<ProductsV3GetProductsData>): QueryKey<Options<ProductsV3GetProductsData>> => createQueryKey('productsV3GetProducts', options, true);

export const productsV3GetProductsInfiniteOptions = (options: Options<ProductsV3GetProductsData>) => infiniteQueryOptions<ProductsV3GetProductsResponse, DefaultError, InfiniteData<ProductsV3GetProductsResponse>, QueryKey<Options<ProductsV3GetProductsData>>, number | Pick<QueryKey<Options<ProductsV3GetProductsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ProductsV3GetProductsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await productsV3GetProducts({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: productsV3GetProductsInfiniteQueryKey(options)
});

export const productsV3GetCategoriesQueryKey = (options: Options<ProductsV3GetCategoriesData>) => createQueryKey('productsV3GetCategories', options);

/**
 * Get Categories
 *
 * Returns a flat list of all active and visible product categories
 * (both parent and subcategories) filtered by the specified catalog.
 *
 * This endpoint does not require authentication.
 * Categories are filtered to include all categories (parents and subcategories)
 * that are both active and visible, belong to the specified catalog (Marketplace or D2C),
 * and are sorted alphabetically by name. Subcategories include their parent_uuid in the response.
 *
 * Query Parameters:
 * catalog (required): Must be either "Marketplace" or "D2C" (case-insensitive)
 *
 * Returns:
 * Response with metadata (timestamp, catalog) and payload (array of category objects).
 * Each category object contains uuid (UUID), label (string), parent_uuid (UUID or null),
 * description (string or null), and image_url (string or null).
 */
export const productsV3GetCategoriesOptions = (options: Options<ProductsV3GetCategoriesData>) => queryOptions<ProductsV3GetCategoriesResponse, DefaultError, ProductsV3GetCategoriesResponse, ReturnType<typeof productsV3GetCategoriesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await productsV3GetCategories({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: productsV3GetCategoriesQueryKey(options)
});

export const productsV3GetCoverageZonesQueryKey = (options?: Options<ProductsV3GetCoverageZonesData>) => createQueryKey('productsV3GetCoverageZones', options);

/**
 * Get Coverage Zones
 *
 * Returns active coverage zones that have at least one active, visible product.
 * Optionally filtered to zones whose products belong to the specified catalog.
 *
 * Query Parameters:
 * catalog (optional): "Marketplace" or "D2C" (case-insensitive). Omit for all zones.
 *
 * Returns:
 * Response with metadata (timestamp, catalog) and payload (array of zone objects).
 * Each zone contains uuid, label (state name), and abbreviation (2-letter code).
 */
export const productsV3GetCoverageZonesOptions = (options?: Options<ProductsV3GetCoverageZonesData>) => queryOptions<ProductsV3GetCoverageZonesResponse, DefaultError, ProductsV3GetCoverageZonesResponse, ReturnType<typeof productsV3GetCoverageZonesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await productsV3GetCoverageZones({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: productsV3GetCoverageZonesQueryKey(options)
});

export const productsV3ExportCatalogQueryKey = (options?: Options<ProductsV3ExportCatalogData>) => createQueryKey('productsV3ExportCatalog', options);

/**
 * Export Flat Catalog
 *
 * Returns a flat list of every billable product × HCPC configuration.
 * Each row contains catalog, category, bundle name, product name, description, and HCPC code.
 *
 * Optionally filtered to a single catalog by name (case-sensitive, must match DB label).
 *
 * Path Parameters:
 * catalog_name (optional): Catalog label to filter by (e.g. "Marketplace", "D2C").
 * Omit to return rows across all catalogs.
 *
 * Returns:
 * Response with metadata (timestamp, catalog) and payload (list of flat catalog rows).
 */
export const productsV3ExportCatalogOptions = (options?: Options<ProductsV3ExportCatalogData>) => queryOptions<ProductsV3ExportCatalogResponse, DefaultError, ProductsV3ExportCatalogResponse, ReturnType<typeof productsV3ExportCatalogQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await productsV3ExportCatalog({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: productsV3ExportCatalogQueryKey(options)
});

export const productsV3ExportCatalog2QueryKey = (options: Options<ProductsV3ExportCatalog2Data>) => createQueryKey('productsV3ExportCatalog2', options);

/**
 * Export Flat Catalog
 *
 * Returns a flat list of every billable product × HCPC configuration.
 * Each row contains catalog, category, bundle name, product name, description, and HCPC code.
 *
 * Optionally filtered to a single catalog by name (case-sensitive, must match DB label).
 *
 * Path Parameters:
 * catalog_name (optional): Catalog label to filter by (e.g. "Marketplace", "D2C").
 * Omit to return rows across all catalogs.
 *
 * Returns:
 * Response with metadata (timestamp, catalog) and payload (list of flat catalog rows).
 */
export const productsV3ExportCatalog2Options = (options: Options<ProductsV3ExportCatalog2Data>) => queryOptions<ProductsV3ExportCatalog2Response, DefaultError, ProductsV3ExportCatalog2Response, ReturnType<typeof productsV3ExportCatalog2QueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await productsV3ExportCatalog2({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: productsV3ExportCatalog2QueryKey(options)
});

export const productsV3HeartbeatQueryKey = (options?: Options<ProductsV3HeartbeatData>) => createQueryKey('productsV3Heartbeat', options);

/**
 * Heartbeat
 *
 * Base validation for the heartbeat endpoint
 */
export const productsV3HeartbeatOptions = (options?: Options<ProductsV3HeartbeatData>) => queryOptions<ProductsV3HeartbeatResponse, DefaultError, ProductsV3HeartbeatResponse, ReturnType<typeof productsV3HeartbeatQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await productsV3Heartbeat({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: productsV3HeartbeatQueryKey(options)
});

export const schedulingV3GetSlotsQueryKey = (options: Options<SchedulingV3GetSlotsData>) => createQueryKey('schedulingV3GetSlots', options);

/**
 * Get available time slots for the specified date range.
 */
export const schedulingV3GetSlotsOptions = (options: Options<SchedulingV3GetSlotsData>) => queryOptions<SchedulingV3GetSlotsResponse, DefaultError, SchedulingV3GetSlotsResponse, ReturnType<typeof schedulingV3GetSlotsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await schedulingV3GetSlots({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: schedulingV3GetSlotsQueryKey(options)
});

export const schedulingV3GetSlotsInfiniteQueryKey = (options: Options<SchedulingV3GetSlotsData>): QueryKey<Options<SchedulingV3GetSlotsData>> => createQueryKey('schedulingV3GetSlots', options, true);

/**
 * Get available time slots for the specified date range.
 */
export const schedulingV3GetSlotsInfiniteOptions = (options: Options<SchedulingV3GetSlotsData>) => infiniteQueryOptions<SchedulingV3GetSlotsResponse, DefaultError, InfiniteData<SchedulingV3GetSlotsResponse>, QueryKey<Options<SchedulingV3GetSlotsData>>, string | Pick<QueryKey<Options<SchedulingV3GetSlotsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<SchedulingV3GetSlotsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                start: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await schedulingV3GetSlots({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: schedulingV3GetSlotsInfiniteQueryKey(options)
});

/**
 * Reserve a time slot.
 */
export const schedulingV3ReserveSlotMutation = (options?: Partial<Options<SchedulingV3ReserveSlotData>>): UseMutationOptions<SchedulingV3ReserveSlotResponse, DefaultError, Options<SchedulingV3ReserveSlotData>> => {
    const mutationOptions: UseMutationOptions<SchedulingV3ReserveSlotResponse, DefaultError, Options<SchedulingV3ReserveSlotData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await schedulingV3ReserveSlot({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Handle booking lifecycle webhook events.
 */
export const schedulingV3CalcomWebhookMutation = (options?: Partial<Options<SchedulingV3CalcomWebhookData>>): UseMutationOptions<SchedulingV3CalcomWebhookResponse, DefaultError, Options<SchedulingV3CalcomWebhookData>> => {
    const mutationOptions: UseMutationOptions<SchedulingV3CalcomWebhookResponse, DefaultError, Options<SchedulingV3CalcomWebhookData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await schedulingV3CalcomWebhook({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const sessionsV3PreviewSessionQueryKey = (options: Options<SessionsV3PreviewSessionData>) => createQueryKey('sessionsV3PreviewSession', options);

export const sessionsV3PreviewSessionOptions = (options: Options<SessionsV3PreviewSessionData>) => queryOptions<SessionsV3PreviewSessionResponse, DefaultError, SessionsV3PreviewSessionResponse, ReturnType<typeof sessionsV3PreviewSessionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await sessionsV3PreviewSession({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: sessionsV3PreviewSessionQueryKey(options)
});

export const sessionsV3SaveSessionMutation = (options?: Partial<Options<SessionsV3SaveSessionData>>): UseMutationOptions<SessionsV3SaveSessionResponse, DefaultError, Options<SessionsV3SaveSessionData>> => {
    const mutationOptions: UseMutationOptions<SessionsV3SaveSessionResponse, DefaultError, Options<SessionsV3SaveSessionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await sessionsV3SaveSession({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const sessionsV3VerifySessionMutation = (options?: Partial<Options<SessionsV3VerifySessionData>>): UseMutationOptions<SessionsV3VerifySessionResponse, DefaultError, Options<SessionsV3VerifySessionData>> => {
    const mutationOptions: UseMutationOptions<SessionsV3VerifySessionResponse, DefaultError, Options<SessionsV3VerifySessionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await sessionsV3VerifySession({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Check phone verification code.
 */
export const verifyV3CheckMutation = (options?: Partial<Options<VerifyV3CheckData>>): UseMutationOptions<VerifyV3CheckResponse, DefaultError, Options<VerifyV3CheckData>> => {
    const mutationOptions: UseMutationOptions<VerifyV3CheckResponse, DefaultError, Options<VerifyV3CheckData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await verifyV3Check({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Start phone verification by sending a code via SMS.
 */
export const verifyV3StartMutation = (options?: Partial<Options<VerifyV3StartData>>): UseMutationOptions<VerifyV3StartResponse, DefaultError, Options<VerifyV3StartData>> => {
    const mutationOptions: UseMutationOptions<VerifyV3StartResponse, DefaultError, Options<VerifyV3StartData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await verifyV3Start({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const insuranceV4PlansV4CreatePlanAdminMutation = (options?: Partial<Options<InsuranceV4PlansV4CreatePlanAdminData>>): UseMutationOptions<InsuranceV4PlansV4CreatePlanAdminResponse, DefaultError, Options<InsuranceV4PlansV4CreatePlanAdminData>> => {
    const mutationOptions: UseMutationOptions<InsuranceV4PlansV4CreatePlanAdminResponse, DefaultError, Options<InsuranceV4PlansV4CreatePlanAdminData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await insuranceV4PlansV4CreatePlanAdmin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const insuranceV4PlansV4SearchPlansAdminQueryKey = (options?: Options<InsuranceV4PlansV4SearchPlansAdminData>) => createQueryKey('insuranceV4PlansV4SearchPlansAdmin', options);

export const insuranceV4PlansV4SearchPlansAdminOptions = (options?: Options<InsuranceV4PlansV4SearchPlansAdminData>) => queryOptions<InsuranceV4PlansV4SearchPlansAdminResponse, DefaultError, InsuranceV4PlansV4SearchPlansAdminResponse, ReturnType<typeof insuranceV4PlansV4SearchPlansAdminQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await insuranceV4PlansV4SearchPlansAdmin({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: insuranceV4PlansV4SearchPlansAdminQueryKey(options)
});

export const insuranceV4PlansV4SearchPlansAdminInfiniteQueryKey = (options?: Options<InsuranceV4PlansV4SearchPlansAdminData>): QueryKey<Options<InsuranceV4PlansV4SearchPlansAdminData>> => createQueryKey('insuranceV4PlansV4SearchPlansAdmin', options, true);

export const insuranceV4PlansV4SearchPlansAdminInfiniteOptions = (options?: Options<InsuranceV4PlansV4SearchPlansAdminData>) => infiniteQueryOptions<InsuranceV4PlansV4SearchPlansAdminResponse, DefaultError, InfiniteData<InsuranceV4PlansV4SearchPlansAdminResponse>, QueryKey<Options<InsuranceV4PlansV4SearchPlansAdminData>>, number | Pick<QueryKey<Options<InsuranceV4PlansV4SearchPlansAdminData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<InsuranceV4PlansV4SearchPlansAdminData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await insuranceV4PlansV4SearchPlansAdmin({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: insuranceV4PlansV4SearchPlansAdminInfiniteQueryKey(options)
});

export const insuranceV4PlansV4GetPlanAdminQueryKey = (options: Options<InsuranceV4PlansV4GetPlanAdminData>) => createQueryKey('insuranceV4PlansV4GetPlanAdmin', options);

export const insuranceV4PlansV4GetPlanAdminOptions = (options: Options<InsuranceV4PlansV4GetPlanAdminData>) => queryOptions<InsuranceV4PlansV4GetPlanAdminResponse, DefaultError, InsuranceV4PlansV4GetPlanAdminResponse, ReturnType<typeof insuranceV4PlansV4GetPlanAdminQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await insuranceV4PlansV4GetPlanAdmin({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: insuranceV4PlansV4GetPlanAdminQueryKey(options)
});

export const insuranceV4PlansV4UpdatePlanAdminMutation = (options?: Partial<Options<InsuranceV4PlansV4UpdatePlanAdminData>>): UseMutationOptions<InsuranceV4PlansV4UpdatePlanAdminResponse, DefaultError, Options<InsuranceV4PlansV4UpdatePlanAdminData>> => {
    const mutationOptions: UseMutationOptions<InsuranceV4PlansV4UpdatePlanAdminResponse, DefaultError, Options<InsuranceV4PlansV4UpdatePlanAdminData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await insuranceV4PlansV4UpdatePlanAdmin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const ordersV4CreateOrderDtcEndpointMutation = (options?: Partial<Options<OrdersV4CreateOrderDtcEndpointData>>): UseMutationOptions<OrdersV4CreateOrderDtcEndpointResponse, DefaultError, Options<OrdersV4CreateOrderDtcEndpointData>> => {
    const mutationOptions: UseMutationOptions<OrdersV4CreateOrderDtcEndpointResponse, DefaultError, Options<OrdersV4CreateOrderDtcEndpointData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersV4CreateOrderDtcEndpoint({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * [DEPRECATED] Use POST /api/v1/orders with role=mcp instead.
 */
export const ordersV4CreateOrderMcpEndpointMutation = (options?: Partial<Options<OrdersV4CreateOrderMcpEndpointData>>): UseMutationOptions<OrdersV4CreateOrderMcpEndpointResponse, DefaultError, Options<OrdersV4CreateOrderMcpEndpointData>> => {
    const mutationOptions: UseMutationOptions<OrdersV4CreateOrderMcpEndpointResponse, DefaultError, Options<OrdersV4CreateOrderMcpEndpointData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersV4CreateOrderMcpEndpoint({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Endpoint to escalate an MCP order to the team. Adds an escalation tag to the Intercom conversation and posts a message to Slack.
 */
export const ordersV4EscalateMcpOrderMutation = (options?: Partial<Options<OrdersV4EscalateMcpOrderData>>): UseMutationOptions<OrdersV4EscalateMcpOrderResponse, DefaultError, Options<OrdersV4EscalateMcpOrderData>> => {
    const mutationOptions: UseMutationOptions<OrdersV4EscalateMcpOrderResponse, DefaultError, Options<OrdersV4EscalateMcpOrderData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersV4EscalateMcpOrder({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Close every Retell conversation recorded for an order.
 *
 * Reads the order's ``order_external_connections`` rows and ends each Retell
 * chat they reference. Chats Retell reports as no longer ongoing are reported
 * as ``already_closed`` without an end-chat call, so the endpoint is safe to
 * re-run. A chat Retell rejects is reported as ``failure`` and the response
 * status is 207; the remaining chats are still closed.
 */
export const ordersV4CloseRetellConversationsMutation = (options?: Partial<Options<OrdersV4CloseRetellConversationsData>>): UseMutationOptions<unknown, DefaultError, Options<OrdersV4CloseRetellConversationsData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<OrdersV4CloseRetellConversationsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersV4CloseRetellConversations({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const ordersV4PostConfirmationRequestMutation = (options?: Partial<Options<OrdersV4PostConfirmationRequestData>>): UseMutationOptions<OrdersV4PostConfirmationRequestResponse, DefaultError, Options<OrdersV4PostConfirmationRequestData>> => {
    const mutationOptions: UseMutationOptions<OrdersV4PostConfirmationRequestResponse, DefaultError, Options<OrdersV4PostConfirmationRequestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersV4PostConfirmationRequest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const ordersV4PatchConfirmationStatusMutation = (options?: Partial<Options<OrdersV4PatchConfirmationStatusData>>): UseMutationOptions<OrdersV4PatchConfirmationStatusResponse, DefaultError, Options<OrdersV4PatchConfirmationStatusData>> => {
    const mutationOptions: UseMutationOptions<OrdersV4PatchConfirmationStatusResponse, DefaultError, Options<OrdersV4PatchConfirmationStatusData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersV4PatchConfirmationStatus({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const ordersV4PatchManualVerificationMutation = (options?: Partial<Options<OrdersV4PatchManualVerificationData>>): UseMutationOptions<OrdersV4PatchManualVerificationResponse, DefaultError, Options<OrdersV4PatchManualVerificationData>> => {
    const mutationOptions: UseMutationOptions<OrdersV4PatchManualVerificationResponse, DefaultError, Options<OrdersV4PatchManualVerificationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersV4PatchManualVerification({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const productsV4GetProductAuditQueryKey = (options?: Options<ProductsV4GetProductAuditData>) => createQueryKey('productsV4GetProductAudit', options);

/**
 * Get Product Configuration Audit (v4)
 *
 * Read-only audit surfacing three classes of product misconfiguration:
 * missing coverage zones, missing fee schedules, and duplicate fee schedules.
 *
 * Optional product_uuid query param scopes per-product checks to one product.
 * Duplicate fee schedule check always runs globally.
 * Auth: conduit_employee only.
 */
export const productsV4GetProductAuditOptions = (options?: Options<ProductsV4GetProductAuditData>) => queryOptions<ProductsV4GetProductAuditResponse, DefaultError, ProductsV4GetProductAuditResponse, ReturnType<typeof productsV4GetProductAuditQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await productsV4GetProductAudit({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: productsV4GetProductAuditQueryKey(options)
});

export const productsV4GetCarriersQueryKey = (options: Options<ProductsV4GetCarriersData>) => createQueryKey('productsV4GetCarriers', options);

/**
 * Get Carriers (v4)
 *
 * Returns template carriers with an approved status and products in the given state.
 * Accepts an optional ?catalog param to restrict to carriers with products in that catalog.
 * Filters to carriers with a non-null frhc_id (Python-side, matching v2 behavior).
 */
export const productsV4GetCarriersOptions = (options: Options<ProductsV4GetCarriersData>) => queryOptions<ProductsV4GetCarriersResponse, DefaultError, ProductsV4GetCarriersResponse, ReturnType<typeof productsV4GetCarriersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await productsV4GetCarriers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: productsV4GetCarriersQueryKey(options)
});

export const productsV4GetCatalogProductsQueryKey = (options: Options<ProductsV4GetCatalogProductsData>) => createQueryKey('productsV4GetCatalogProducts', options);

/**
 * Get Catalog Products (v4)
 *
 * Carrier-scoped product list using the normalized product model.
 * Returns products in the v2 legacy_settings() shape so existing consumers receive
 * a structurally identical response.
 *
 * Required: carrier (slug), state (2-char abbreviation).
 * Optional: product_name, category_uuid, page, limit.
 */
export const productsV4GetCatalogProductsOptions = (options: Options<ProductsV4GetCatalogProductsData>) => queryOptions<ProductsV4GetCatalogProductsResponse, DefaultError, ProductsV4GetCatalogProductsResponse, ReturnType<typeof productsV4GetCatalogProductsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await productsV4GetCatalogProducts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: productsV4GetCatalogProductsQueryKey(options)
});

export const productsV4GetCatalogProductsInfiniteQueryKey = (options: Options<ProductsV4GetCatalogProductsData>): QueryKey<Options<ProductsV4GetCatalogProductsData>> => createQueryKey('productsV4GetCatalogProducts', options, true);

/**
 * Get Catalog Products (v4)
 *
 * Carrier-scoped product list using the normalized product model.
 * Returns products in the v2 legacy_settings() shape so existing consumers receive
 * a structurally identical response.
 *
 * Required: carrier (slug), state (2-char abbreviation).
 * Optional: product_name, category_uuid, page, limit.
 */
export const productsV4GetCatalogProductsInfiniteOptions = (options: Options<ProductsV4GetCatalogProductsData>) => infiniteQueryOptions<ProductsV4GetCatalogProductsResponse, DefaultError, InfiniteData<ProductsV4GetCatalogProductsResponse>, QueryKey<Options<ProductsV4GetCatalogProductsData>>, number | Pick<QueryKey<Options<ProductsV4GetCatalogProductsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ProductsV4GetCatalogProductsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await productsV4GetCatalogProducts({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: productsV4GetCatalogProductsInfiniteQueryKey(options)
});

export const productsV4GetCatalogProductQueryKey = (options: Options<ProductsV4GetCatalogProductData>) => createQueryKey('productsV4GetCatalogProduct', options);

/**
 * Get Single Catalog Product (v4)
 *
 * Returns one product in carrier/state context using the normalized model.
 * Returns 404 if the product is not found or not available in the given carrier/state.
 */
export const productsV4GetCatalogProductOptions = (options: Options<ProductsV4GetCatalogProductData>) => queryOptions<ProductsV4GetCatalogProductResponse, DefaultError, ProductsV4GetCatalogProductResponse, ReturnType<typeof productsV4GetCatalogProductQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await productsV4GetCatalogProduct({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: productsV4GetCatalogProductQueryKey(options)
});

export const productsV4GetCatalogProductInfiniteQueryKey = (options: Options<ProductsV4GetCatalogProductData>): QueryKey<Options<ProductsV4GetCatalogProductData>> => createQueryKey('productsV4GetCatalogProduct', options, true);

/**
 * Get Single Catalog Product (v4)
 *
 * Returns one product in carrier/state context using the normalized model.
 * Returns 404 if the product is not found or not available in the given carrier/state.
 */
export const productsV4GetCatalogProductInfiniteOptions = (options: Options<ProductsV4GetCatalogProductData>) => infiniteQueryOptions<ProductsV4GetCatalogProductResponse, DefaultError, InfiniteData<ProductsV4GetCatalogProductResponse>, QueryKey<Options<ProductsV4GetCatalogProductData>>, number | Pick<QueryKey<Options<ProductsV4GetCatalogProductData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ProductsV4GetCatalogProductData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await productsV4GetCatalogProduct({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: productsV4GetCatalogProductInfiniteQueryKey(options)
});

export const productsV4GetAllCategoriesQueryKey = (options?: Options<ProductsV4GetAllCategoriesData>) => createQueryKey('productsV4GetAllCategories', options);

/**
 * Get All Categories (v4)
 *
 * Returns ProductCategory records filtered by catalog (default: Marketplace).
 * Pass ``catalog=`` (empty) to return all categories regardless of catalog association.
 * Fixes the v2 bug where the role was 'marketplace_employee' (non-existent); v4
 * uses 'marketplace_user'.
 */
export const productsV4GetAllCategoriesOptions = (options?: Options<ProductsV4GetAllCategoriesData>) => queryOptions<ProductsV4GetAllCategoriesResponse, DefaultError, ProductsV4GetAllCategoriesResponse, ReturnType<typeof productsV4GetAllCategoriesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await productsV4GetAllCategories({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: productsV4GetAllCategoriesQueryKey(options)
});

export const productsV4SearchCategoriesQueryKey = (options?: Options<ProductsV4SearchCategoriesData>) => createQueryKey('productsV4SearchCategories', options);

/**
 * Search Categories (v4)
 *
 * Returns top-level product categories and their subcategories as a label-keyed dict.
 * No authentication required — mirrors v2 GET /products/categories/search behavior.
 * Cannot use @response decorator because the payload shape is variable (parent label →
 * list of subcategory labels). See D-8 in plan v5.
 */
export const productsV4SearchCategoriesOptions = (options?: Options<ProductsV4SearchCategoriesData>) => queryOptions<ProductsV4SearchCategoriesResponse, DefaultError, ProductsV4SearchCategoriesResponse, ReturnType<typeof productsV4SearchCategoriesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await productsV4SearchCategories({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: productsV4SearchCategoriesQueryKey(options)
});

export const productsV4GetCoverageZonesQueryKey = (options?: Options<ProductsV4GetCoverageZonesData>) => createQueryKey('productsV4GetCoverageZones', options);

/**
 * Get Coverage Zones (v4)
 *
 * Returns all CoverageZone records regardless of product availability.
 * Accepts an optional ?catalog param — when provided, filters to zones that have at least
 * one product in that catalog (mirrors v3 /products/coverage_zones/ behaviour).
 * Identical to v2 GET /insurance/coverage_zones/all when no catalog filter is applied.
 */
export const productsV4GetCoverageZonesOptions = (options?: Options<ProductsV4GetCoverageZonesData>) => queryOptions<ProductsV4GetCoverageZonesResponse, DefaultError, ProductsV4GetCoverageZonesResponse, ReturnType<typeof productsV4GetCoverageZonesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await productsV4GetCoverageZones({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: productsV4GetCoverageZonesQueryKey(options)
});

export const productsV4GetFeeScheduleQueryKey = (options: Options<ProductsV4GetFeeScheduleData>) => createQueryKey('productsV4GetFeeSchedule', options);

/**
 * Get Fee Schedule (v4)
 *
 * Returns fee/refill data for HCPC codes in a given carrier/state context.
 * Identical logic to v2 GET /insurance/fee_schedule/{carrier}/{state}.
 * No authentication required — matches v2 behavior.
 */
export const productsV4GetFeeScheduleOptions = (options: Options<ProductsV4GetFeeScheduleData>) => queryOptions<ProductsV4GetFeeScheduleResponse, DefaultError, ProductsV4GetFeeScheduleResponse, ReturnType<typeof productsV4GetFeeScheduleQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await productsV4GetFeeSchedule({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: productsV4GetFeeScheduleQueryKey(options)
});

export const productsV4SearchProductsQueryKey = (options?: Options<ProductsV4SearchProductsData>) => createQueryKey('productsV4SearchProducts', options);

/**
 * Search Products (v4 admin)
 *
 * Admin product search with filters for category, catalog, coverage zone, supplier, and
 * a free-text search term. Defaults to active/visible/approved products — the same scope
 * as v2 GET /products/search. Non-approved products are managed via Flask-admin directly.
 */
export const productsV4SearchProductsOptions = (options?: Options<ProductsV4SearchProductsData>) => queryOptions<ProductsV4SearchProductsResponse, DefaultError, ProductsV4SearchProductsResponse, ReturnType<typeof productsV4SearchProductsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await productsV4SearchProducts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: productsV4SearchProductsQueryKey(options)
});

export const productsV4SearchProductsInfiniteQueryKey = (options?: Options<ProductsV4SearchProductsData>): QueryKey<Options<ProductsV4SearchProductsData>> => createQueryKey('productsV4SearchProducts', options, true);

/**
 * Search Products (v4 admin)
 *
 * Admin product search with filters for category, catalog, coverage zone, supplier, and
 * a free-text search term. Defaults to active/visible/approved products — the same scope
 * as v2 GET /products/search. Non-approved products are managed via Flask-admin directly.
 */
export const productsV4SearchProductsInfiniteOptions = (options?: Options<ProductsV4SearchProductsData>) => infiniteQueryOptions<ProductsV4SearchProductsResponse, DefaultError, InfiniteData<ProductsV4SearchProductsResponse>, QueryKey<Options<ProductsV4SearchProductsData>>, number | Pick<QueryKey<Options<ProductsV4SearchProductsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ProductsV4SearchProductsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await productsV4SearchProducts({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: productsV4SearchProductsInfiniteQueryKey(options)
});

export const productsV4GetProductDetailQueryKey = (options: Options<ProductsV4GetProductDetailData>) => createQueryKey('productsV4GetProductDetail', options);

/**
 * Get Product Detail (v4 admin)
 *
 * Admin view of a single product across all carrier/state configurations.
 * Uses a direct query (not get_query()) so products without categories or CCZ records
 * are not silently 404'd — admin needs to see all products (D-9 in plan v5).
 *
 * Optional carrier/state params scope the response to a single carrier/state combination.
 * legacy_settings() slugifies carrier internally before matching (D-10 in plan v5).
 */
export const productsV4GetProductDetailOptions = (options: Options<ProductsV4GetProductDetailData>) => queryOptions<ProductsV4GetProductDetailResponse, DefaultError, ProductsV4GetProductDetailResponse, ReturnType<typeof productsV4GetProductDetailQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await productsV4GetProductDetail({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: productsV4GetProductDetailQueryKey(options)
});

export const schedulingV4GetAppointmentQueryKey = (options: Options<SchedulingV4GetAppointmentData>) => createQueryKey('schedulingV4GetAppointment', options);

/**
 * Fetch a Healthie appointment by ID for the scheduling UI.
 */
export const schedulingV4GetAppointmentOptions = (options: Options<SchedulingV4GetAppointmentData>) => queryOptions<SchedulingV4GetAppointmentResponse, DefaultError, SchedulingV4GetAppointmentResponse, ReturnType<typeof schedulingV4GetAppointmentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await schedulingV4GetAppointment({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: schedulingV4GetAppointmentQueryKey(options)
});

/**
 * Cancel a telehealth appointment.
 *
 * Updates the appointment status to cancelled in Healthie, which will trigger the appointment_updated webhook handling.
 */
export const schedulingV4CancelAppointmentMutation = (options?: Partial<Options<SchedulingV4CancelAppointmentData>>): UseMutationOptions<SchedulingV4CancelAppointmentResponse, DefaultError, Options<SchedulingV4CancelAppointmentData>> => {
    const mutationOptions: UseMutationOptions<SchedulingV4CancelAppointmentResponse, DefaultError, Options<SchedulingV4CancelAppointmentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await schedulingV4CancelAppointment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const schedulingV4GetDaysQueryKey = (options?: Options<SchedulingV4GetDaysData>) => createQueryKey('schedulingV4GetDays', options);

/**
 * Get days with available appointment slots from Healthie.
 */
export const schedulingV4GetDaysOptions = (options?: Options<SchedulingV4GetDaysData>) => queryOptions<SchedulingV4GetDaysResponse, DefaultError, SchedulingV4GetDaysResponse, ReturnType<typeof schedulingV4GetDaysQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await schedulingV4GetDays({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: schedulingV4GetDaysQueryKey(options)
});

/**
 * Reschedule a patient's appointment. The flow is:
 *
 * 1. Book a new appointment
 * 2. Mark any upcoming appointments of the same Healthie appointment-type as "Re-Scheduled"
 */
export const schedulingV4RescheduleAppointmentMutation = (options?: Partial<Options<SchedulingV4RescheduleAppointmentData>>): UseMutationOptions<SchedulingV4RescheduleAppointmentResponse, DefaultError, Options<SchedulingV4RescheduleAppointmentData>> => {
    const mutationOptions: UseMutationOptions<SchedulingV4RescheduleAppointmentResponse, DefaultError, Options<SchedulingV4RescheduleAppointmentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await schedulingV4RescheduleAppointment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Book a telehealth appointment for a self-scheduling patient.
 *
 * Re-verifies DOB, books the telehealth appointment, attaches it to the
 * order, and transitions the order to TELEHEALTH_UPCOMING.
 */
export const schedulingV4BookSelfScheduledAppointmentMutation = (options?: Partial<Options<SchedulingV4BookSelfScheduledAppointmentData>>): UseMutationOptions<SchedulingV4BookSelfScheduledAppointmentResponse, DefaultError, Options<SchedulingV4BookSelfScheduledAppointmentData>> => {
    const mutationOptions: UseMutationOptions<SchedulingV4BookSelfScheduledAppointmentResponse, DefaultError, Options<SchedulingV4BookSelfScheduledAppointmentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await schedulingV4BookSelfScheduledAppointment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Enqueue a CIO event inviting the patient to self-schedule a telehealth visit.
 */
export const schedulingV4RequestSelfScheduleMutation = (options?: Partial<Options<SchedulingV4RequestSelfScheduleData>>): UseMutationOptions<SchedulingV4RequestSelfScheduleResponse, DefaultError, Options<SchedulingV4RequestSelfScheduleData>> => {
    const mutationOptions: UseMutationOptions<SchedulingV4RequestSelfScheduleResponse, DefaultError, Options<SchedulingV4RequestSelfScheduleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await schedulingV4RequestSelfSchedule({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Verify a patient's identity before showing the self-scheduling UI.
 *
 * Checks the patient DOB against the order. Order status is not gated —
 * any status may verify. Returns context needed by the FE (state for slot
 * filtering).
 */
export const schedulingV4VerifyPatientBookingMutation = (options?: Partial<Options<SchedulingV4VerifyPatientBookingData>>): UseMutationOptions<SchedulingV4VerifyPatientBookingResponse, DefaultError, Options<SchedulingV4VerifyPatientBookingData>> => {
    const mutationOptions: UseMutationOptions<SchedulingV4VerifyPatientBookingResponse, DefaultError, Options<SchedulingV4VerifyPatientBookingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await schedulingV4VerifyPatientBooking({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Book or reschedule a telehealth appointment via order public ID.
 *
 * Looks up the order for DOB verification. Branches on whether the order
 * already has a Healthie ``booking_uid``:
 * - No booking (or prior booking already Occurred): books a new appointment via
 * the self-schedule path (b2b Healthie channel, matching ``/schedule``).
 * - Has an active booking: reschedules, deriving appointment_type_id and
 * patient_id from the stored booking via a Healthie lookup.
 *
 * Existing ``/schedule`` and ``/reschedule`` endpoints are not affected.
 */
export const schedulingV4ScheduleOrRescheduleAppointmentMutation = (options?: Partial<Options<SchedulingV4ScheduleOrRescheduleAppointmentData>>): UseMutationOptions<SchedulingV4ScheduleOrRescheduleAppointmentResponse, DefaultError, Options<SchedulingV4ScheduleOrRescheduleAppointmentData>> => {
    const mutationOptions: UseMutationOptions<SchedulingV4ScheduleOrRescheduleAppointmentResponse, DefaultError, Options<SchedulingV4ScheduleOrRescheduleAppointmentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await schedulingV4ScheduleOrRescheduleAppointment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const schedulingV4GetSlotsQueryKey = (options?: Options<SchedulingV4GetSlotsData>) => createQueryKey('schedulingV4GetSlots', options);

/**
 * Get available time slots from Healthie for the specified date range.
 */
export const schedulingV4GetSlotsOptions = (options?: Options<SchedulingV4GetSlotsData>) => queryOptions<SchedulingV4GetSlotsResponse, DefaultError, SchedulingV4GetSlotsResponse, ReturnType<typeof schedulingV4GetSlotsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await schedulingV4GetSlots({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: schedulingV4GetSlotsQueryKey(options)
});

export const schedulingV4GetSlotsInfiniteQueryKey = (options?: Options<SchedulingV4GetSlotsData>): QueryKey<Options<SchedulingV4GetSlotsData>> => createQueryKey('schedulingV4GetSlots', options, true);

/**
 * Get available time slots from Healthie for the specified date range.
 */
export const schedulingV4GetSlotsInfiniteOptions = (options?: Options<SchedulingV4GetSlotsData>) => infiniteQueryOptions<SchedulingV4GetSlotsResponse, DefaultError, InfiniteData<SchedulingV4GetSlotsResponse>, QueryKey<Options<SchedulingV4GetSlotsData>>, string | null | Pick<QueryKey<Options<SchedulingV4GetSlotsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<SchedulingV4GetSlotsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                start: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await schedulingV4GetSlots({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: schedulingV4GetSlotsInfiniteQueryKey(options)
});

export const trackingV4VerifyAndGetTrackingMutation = (options?: Partial<Options<TrackingV4VerifyAndGetTrackingData>>): UseMutationOptions<TrackingV4VerifyAndGetTrackingResponse, DefaultError, Options<TrackingV4VerifyAndGetTrackingData>> => {
    const mutationOptions: UseMutationOptions<TrackingV4VerifyAndGetTrackingResponse, DefaultError, Options<TrackingV4VerifyAndGetTrackingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await trackingV4VerifyAndGetTracking({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const ordersV5ListActionReasonsQueryKey = (options?: Options<OrdersV5ListActionReasonsData>) => createQueryKey('ordersV5ListActionReasons', options);

export const ordersV5ListActionReasonsOptions = (options?: Options<OrdersV5ListActionReasonsData>) => queryOptions<OrdersV5ListActionReasonsResponse, DefaultError, OrdersV5ListActionReasonsResponse, ReturnType<typeof ordersV5ListActionReasonsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await ordersV5ListActionReasons({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: ordersV5ListActionReasonsQueryKey(options)
});

/**
 * Billing order endpoint
 *
 * Send billing information to Candid Health.
 */
export const ordersV5BillingMutation = (options?: Partial<Options<OrdersV5BillingData>>): UseMutationOptions<unknown, DefaultError, Options<OrdersV5BillingData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<OrdersV5BillingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersV5Billing({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const ordersV5MessagesV5GetOrderMessageQueryKey = (options: Options<OrdersV5MessagesV5GetOrderMessageData>) => createQueryKey('ordersV5MessagesV5GetOrderMessage', options);

export const ordersV5MessagesV5GetOrderMessageOptions = (options: Options<OrdersV5MessagesV5GetOrderMessageData>) => queryOptions<OrdersV5MessagesV5GetOrderMessageResponse, DefaultError, OrdersV5MessagesV5GetOrderMessageResponse, ReturnType<typeof ordersV5MessagesV5GetOrderMessageQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await ordersV5MessagesV5GetOrderMessage({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: ordersV5MessagesV5GetOrderMessageQueryKey(options)
});

export const ordersV5MessagesV5GetOrderMessageInfiniteQueryKey = (options: Options<OrdersV5MessagesV5GetOrderMessageData>): QueryKey<Options<OrdersV5MessagesV5GetOrderMessageData>> => createQueryKey('ordersV5MessagesV5GetOrderMessage', options, true);

export const ordersV5MessagesV5GetOrderMessageInfiniteOptions = (options: Options<OrdersV5MessagesV5GetOrderMessageData>) => infiniteQueryOptions<OrdersV5MessagesV5GetOrderMessageResponse, DefaultError, InfiniteData<OrdersV5MessagesV5GetOrderMessageResponse>, QueryKey<Options<OrdersV5MessagesV5GetOrderMessageData>>, number | null | Pick<QueryKey<Options<OrdersV5MessagesV5GetOrderMessageData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<OrdersV5MessagesV5GetOrderMessageData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await ordersV5MessagesV5GetOrderMessage({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: ordersV5MessagesV5GetOrderMessageInfiniteQueryKey(options)
});

export const ordersV5MessagesV5CreateMessageMutation = (options?: Partial<Options<OrdersV5MessagesV5CreateMessageData>>): UseMutationOptions<OrdersV5MessagesV5CreateMessageResponse, DefaultError, Options<OrdersV5MessagesV5CreateMessageData>> => {
    const mutationOptions: UseMutationOptions<OrdersV5MessagesV5CreateMessageResponse, DefaultError, Options<OrdersV5MessagesV5CreateMessageData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersV5MessagesV5CreateMessage({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const ordersV5MessagesV5MarkMessagesSeenMutation = (options?: Partial<Options<OrdersV5MessagesV5MarkMessagesSeenData>>): UseMutationOptions<OrdersV5MessagesV5MarkMessagesSeenResponse, DefaultError, Options<OrdersV5MessagesV5MarkMessagesSeenData>> => {
    const mutationOptions: UseMutationOptions<OrdersV5MessagesV5MarkMessagesSeenResponse, DefaultError, Options<OrdersV5MessagesV5MarkMessagesSeenData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersV5MessagesV5MarkMessagesSeen({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const ordersV5MessagesV5DeleteMessageMutation = (options?: Partial<Options<OrdersV5MessagesV5DeleteMessageData>>): UseMutationOptions<OrdersV5MessagesV5DeleteMessageResponse, DefaultError, Options<OrdersV5MessagesV5DeleteMessageData>> => {
    const mutationOptions: UseMutationOptions<OrdersV5MessagesV5DeleteMessageResponse, DefaultError, Options<OrdersV5MessagesV5DeleteMessageData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersV5MessagesV5DeleteMessage({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const ordersV5NotificationsV5ListNotificationsQueryKey = (options?: Options<OrdersV5NotificationsV5ListNotificationsData>) => createQueryKey('ordersV5NotificationsV5ListNotifications', options);

export const ordersV5NotificationsV5ListNotificationsOptions = (options?: Options<OrdersV5NotificationsV5ListNotificationsData>) => queryOptions<OrdersV5NotificationsV5ListNotificationsResponse, DefaultError, OrdersV5NotificationsV5ListNotificationsResponse, ReturnType<typeof ordersV5NotificationsV5ListNotificationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await ordersV5NotificationsV5ListNotifications({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: ordersV5NotificationsV5ListNotificationsQueryKey(options)
});

export const ordersV5NotificationsV5ListNotificationsInfiniteQueryKey = (options?: Options<OrdersV5NotificationsV5ListNotificationsData>): QueryKey<Options<OrdersV5NotificationsV5ListNotificationsData>> => createQueryKey('ordersV5NotificationsV5ListNotifications', options, true);

export const ordersV5NotificationsV5ListNotificationsInfiniteOptions = (options?: Options<OrdersV5NotificationsV5ListNotificationsData>) => infiniteQueryOptions<OrdersV5NotificationsV5ListNotificationsResponse, DefaultError, InfiniteData<OrdersV5NotificationsV5ListNotificationsResponse>, QueryKey<Options<OrdersV5NotificationsV5ListNotificationsData>>, number | null | Pick<QueryKey<Options<OrdersV5NotificationsV5ListNotificationsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<OrdersV5NotificationsV5ListNotificationsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await ordersV5NotificationsV5ListNotifications({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: ordersV5NotificationsV5ListNotificationsInfiniteQueryKey(options)
});

export const ordersV5NotificationsV5MarkNotificationsSeenMutation = (options?: Partial<Options<OrdersV5NotificationsV5MarkNotificationsSeenData>>): UseMutationOptions<OrdersV5NotificationsV5MarkNotificationsSeenResponse, DefaultError, Options<OrdersV5NotificationsV5MarkNotificationsSeenData>> => {
    const mutationOptions: UseMutationOptions<OrdersV5NotificationsV5MarkNotificationsSeenResponse, DefaultError, Options<OrdersV5NotificationsV5MarkNotificationsSeenData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersV5NotificationsV5MarkNotificationsSeen({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const ordersV5TimelineV5GetOrderTimelineQueryKey = (options: Options<OrdersV5TimelineV5GetOrderTimelineData>) => createQueryKey('ordersV5TimelineV5GetOrderTimeline', options);

export const ordersV5TimelineV5GetOrderTimelineOptions = (options: Options<OrdersV5TimelineV5GetOrderTimelineData>) => queryOptions<OrdersV5TimelineV5GetOrderTimelineResponse, DefaultError, OrdersV5TimelineV5GetOrderTimelineResponse, ReturnType<typeof ordersV5TimelineV5GetOrderTimelineQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await ordersV5TimelineV5GetOrderTimeline({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: ordersV5TimelineV5GetOrderTimelineQueryKey(options)
});

export const ordersV5TriggerRentalClaimsEndpointMutation = (options?: Partial<Options<OrdersV5TriggerRentalClaimsEndpointData>>): UseMutationOptions<unknown, DefaultError, Options<OrdersV5TriggerRentalClaimsEndpointData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<OrdersV5TriggerRentalClaimsEndpointData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersV5TriggerRentalClaimsEndpoint({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Uncancel orders in bulk.
 *
 * Moves each cancelled order to the requested target status. Orders that are
 * not in the CANCELLED state are skipped with a failure reason and do not
 * block the rest of the batch. When a note is provided it is added to every
 * order that is successfully uncancelled.
 */
export const ordersV5UncancelOrdersMutation = (options?: Partial<Options<OrdersV5UncancelOrdersData>>): UseMutationOptions<unknown, DefaultError, Options<OrdersV5UncancelOrdersData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<OrdersV5UncancelOrdersData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersV5UncancelOrders({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const ordersV5OrderDetailsQueryKey = (options: Options<OrdersV5OrderDetailsData>) => createQueryKey('ordersV5OrderDetails', options);

/**
 * Get Order Details (v5)
 *
 * Identical response shape to GET /v1/orders/<order_id> with metadata.version = 5.
 * Replaces per-item product queries with two batch queries (Product + HCPC prefetch),
 * eliminating the N+1 pattern for orders with UUID product references.
 *
 * v1 remains live for orders with legacy product_id values.
 */
export const ordersV5OrderDetailsOptions = (options: Options<OrdersV5OrderDetailsData>) => queryOptions<OrdersV5OrderDetailsResponse, DefaultError, OrdersV5OrderDetailsResponse, ReturnType<typeof ordersV5OrderDetailsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await ordersV5OrderDetails({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: ordersV5OrderDetailsQueryKey(options)
});

export const ordersV5CancelOrderMutation = (options?: Partial<Options<OrdersV5CancelOrderData>>): UseMutationOptions<OrdersV5CancelOrderResponse, DefaultError, Options<OrdersV5CancelOrderData>> => {
    const mutationOptions: UseMutationOptions<OrdersV5CancelOrderResponse, DefaultError, Options<OrdersV5CancelOrderData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersV5CancelOrder({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create a new catalog product.
 */
export const productsV5CreateProductRouteMutation = (options?: Partial<Options<ProductsV5CreateProductRouteData>>): UseMutationOptions<ProductsV5CreateProductRouteResponse, DefaultError, Options<ProductsV5CreateProductRouteData>> => {
    const mutationOptions: UseMutationOptions<ProductsV5CreateProductRouteResponse, DefaultError, Options<ProductsV5CreateProductRouteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await productsV5CreateProductRoute({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove a child product from a parent bundle.
 */
export const productsV5DeleteBundleItemRouteMutation = (options?: Partial<Options<ProductsV5DeleteBundleItemRouteData>>): UseMutationOptions<ProductsV5DeleteBundleItemRouteResponse, DefaultError, Options<ProductsV5DeleteBundleItemRouteData>> => {
    const mutationOptions: UseMutationOptions<ProductsV5DeleteBundleItemRouteResponse, DefaultError, Options<ProductsV5DeleteBundleItemRouteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await productsV5DeleteBundleItemRoute({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Add a child product to a parent bundle.
 */
export const productsV5CreateBundleItemRouteMutation = (options?: Partial<Options<ProductsV5CreateBundleItemRouteData>>): UseMutationOptions<ProductsV5CreateBundleItemRouteResponse, DefaultError, Options<ProductsV5CreateBundleItemRouteData>> => {
    const mutationOptions: UseMutationOptions<ProductsV5CreateBundleItemRouteResponse, DefaultError, Options<ProductsV5CreateBundleItemRouteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await productsV5CreateBundleItemRoute({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const productsV5GetBundleTypesRouteQueryKey = (options?: Options<ProductsV5GetBundleTypesRouteData>) => createQueryKey('productsV5GetBundleTypesRoute', options);

/**
 * All product bundle types for the admin bundle item picker.
 *
 * Returns every type regardless of active/visible status — the flags are
 * included so the caller can present them. Ordered by label.
 */
export const productsV5GetBundleTypesRouteOptions = (options?: Options<ProductsV5GetBundleTypesRouteData>) => queryOptions<ProductsV5GetBundleTypesRouteResponse, DefaultError, ProductsV5GetBundleTypesRouteResponse, ReturnType<typeof productsV5GetBundleTypesRouteQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await productsV5GetBundleTypesRoute({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: productsV5GetBundleTypesRouteQueryKey(options)
});

export const productsV5GetAdminCatalogQueryKey = (options?: Options<ProductsV5GetAdminCatalogData>) => createQueryKey('productsV5GetAdminCatalog', options);

/**
 * Paginated admin product catalog with search, catalog, state, and plan filters.
 */
export const productsV5GetAdminCatalogOptions = (options?: Options<ProductsV5GetAdminCatalogData>) => queryOptions<ProductsV5GetAdminCatalogResponse, DefaultError, ProductsV5GetAdminCatalogResponse, ReturnType<typeof productsV5GetAdminCatalogQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await productsV5GetAdminCatalog({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: productsV5GetAdminCatalogQueryKey(options)
});

export const productsV5GetAdminCatalogInfiniteQueryKey = (options?: Options<ProductsV5GetAdminCatalogData>): QueryKey<Options<ProductsV5GetAdminCatalogData>> => createQueryKey('productsV5GetAdminCatalog', options, true);

/**
 * Paginated admin product catalog with search, catalog, state, and plan filters.
 */
export const productsV5GetAdminCatalogInfiniteOptions = (options?: Options<ProductsV5GetAdminCatalogData>) => infiniteQueryOptions<ProductsV5GetAdminCatalogResponse, DefaultError, InfiniteData<ProductsV5GetAdminCatalogResponse>, QueryKey<Options<ProductsV5GetAdminCatalogData>>, number | Pick<QueryKey<Options<ProductsV5GetAdminCatalogData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ProductsV5GetAdminCatalogData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await productsV5GetAdminCatalog({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: productsV5GetAdminCatalogInfiniteQueryKey(options)
});

export const productsV5GetAdminCategoriesQueryKey = (options?: Options<ProductsV5GetAdminCategoriesData>) => createQueryKey('productsV5GetAdminCategories', options);

/**
 * All product categories with catalog memberships for the admin product UI.
 *
 * Returns categories ordered by label, each enriched with its catalog
 * label memberships and parent info. Used to populate the multi-select
 * category picker in EditItemPanel, grouped by catalog.
 */
export const productsV5GetAdminCategoriesOptions = (options?: Options<ProductsV5GetAdminCategoriesData>) => queryOptions<ProductsV5GetAdminCategoriesResponse, DefaultError, ProductsV5GetAdminCategoriesResponse, ReturnType<typeof productsV5GetAdminCategoriesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await productsV5GetAdminCategories({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: productsV5GetAdminCategoriesQueryKey(options)
});

export const productsV5GetAdminPlansQueryKey = (options?: Options<ProductsV5GetAdminPlansData>) => createQueryKey('productsV5GetAdminPlans', options);

/**
 * Admin plan listing — paginated, filterable, sortable.
 *
 * Supports filtering by plan_uuid, state, catalog, name, plan_type,
 * is_active, is_visible, and free-text q.
 * Supports sorting by name, state, catalog, plan_type, is_active,
 * is_visible, created_at, modified_at.
 */
export const productsV5GetAdminPlansOptions = (options?: Options<ProductsV5GetAdminPlansData>) => queryOptions<ProductsV5GetAdminPlansResponse, DefaultError, ProductsV5GetAdminPlansResponse, ReturnType<typeof productsV5GetAdminPlansQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await productsV5GetAdminPlans({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: productsV5GetAdminPlansQueryKey(options)
});

export const productsV5GetAdminPlansInfiniteQueryKey = (options?: Options<ProductsV5GetAdminPlansData>): QueryKey<Options<ProductsV5GetAdminPlansData>> => createQueryKey('productsV5GetAdminPlans', options, true);

/**
 * Admin plan listing — paginated, filterable, sortable.
 *
 * Supports filtering by plan_uuid, state, catalog, name, plan_type,
 * is_active, is_visible, and free-text q.
 * Supports sorting by name, state, catalog, plan_type, is_active,
 * is_visible, created_at, modified_at.
 */
export const productsV5GetAdminPlansInfiniteOptions = (options?: Options<ProductsV5GetAdminPlansData>) => infiniteQueryOptions<ProductsV5GetAdminPlansResponse, DefaultError, InfiniteData<ProductsV5GetAdminPlansResponse>, QueryKey<Options<ProductsV5GetAdminPlansData>>, number | Pick<QueryKey<Options<ProductsV5GetAdminPlansData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ProductsV5GetAdminPlansData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await productsV5GetAdminPlans({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: productsV5GetAdminPlansInfiniteQueryKey(options)
});

export const productsV5GetAdminProductStatesQueryKey = (options?: Options<ProductsV5GetAdminProductStatesData>) => createQueryKey('productsV5GetAdminProductStates', options);

/**
 * Get active coverage zones for the catalog state filter dropdown.
 */
export const productsV5GetAdminProductStatesOptions = (options?: Options<ProductsV5GetAdminProductStatesData>) => queryOptions<ProductsV5GetAdminProductStatesResponse, DefaultError, ProductsV5GetAdminProductStatesResponse, ReturnType<typeof productsV5GetAdminProductStatesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await productsV5GetAdminProductStates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: productsV5GetAdminProductStatesQueryKey(options)
});

/**
 * Delete a product (hard delete with is_active fallback).
 *
 * Attempts a hard DELETE. If FK constraints prevent deletion, the product
 * is deactivated (is_active=False) instead. Always returns 200.
 */
export const productsV5DeleteProductRouteMutation = (options?: Partial<Options<ProductsV5DeleteProductRouteData>>): UseMutationOptions<ProductsV5DeleteProductRouteResponse, DefaultError, Options<ProductsV5DeleteProductRouteData>> => {
    const mutationOptions: UseMutationOptions<ProductsV5DeleteProductRouteResponse, DefaultError, Options<ProductsV5DeleteProductRouteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await productsV5DeleteProductRoute({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Partial update of a catalog product.
 */
export const productsV5UpdateProductRouteMutation = (options?: Partial<Options<ProductsV5UpdateProductRouteData>>): UseMutationOptions<ProductsV5UpdateProductRouteResponse, DefaultError, Options<ProductsV5UpdateProductRouteData>> => {
    const mutationOptions: UseMutationOptions<ProductsV5UpdateProductRouteResponse, DefaultError, Options<ProductsV5UpdateProductRouteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await productsV5UpdateProductRoute({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const productsV5GetProductBundleItemsQueryKey = (options: Options<ProductsV5GetProductBundleItemsData>) => createQueryKey('productsV5GetProductBundleItems', options);

/**
 * Return the bundle items (child components) of a product.
 */
export const productsV5GetProductBundleItemsOptions = (options: Options<ProductsV5GetProductBundleItemsData>) => queryOptions<ProductsV5GetProductBundleItemsResponse, DefaultError, ProductsV5GetProductBundleItemsResponse, ReturnType<typeof productsV5GetProductBundleItemsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await productsV5GetProductBundleItems({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: productsV5GetProductBundleItemsQueryKey(options)
});

/**
 * Upload a photo to a named slot on a catalog product.
 *
 * Accepts multipart/form-data with ``image`` (JPEG/PNG) and ``slot``
 * (``"square"`` or ``"thumbnail"``).  The file is proxied to S3 and the
 * resulting public URL is stored in ``product.media[slot]``.
 *
 * Returns the updated AdminCatalogItemSchema dict on success.
 * 404 if the product is not found, 422 if the slot or file type is invalid.
 */
export const productsV5PatchProductPhotosRouteMutation = (options?: Partial<Options<ProductsV5PatchProductPhotosRouteData>>): UseMutationOptions<ProductsV5PatchProductPhotosRouteResponse, DefaultError, Options<ProductsV5PatchProductPhotosRouteData>> => {
    const mutationOptions: UseMutationOptions<ProductsV5PatchProductPhotosRouteResponse, DefaultError, Options<ProductsV5PatchProductPhotosRouteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await productsV5PatchProductPhotosRoute({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove a photo slot from a catalog product.
 *
 * Clears ``product.media[slot]`` and returns the updated
 * AdminCatalogItemSchema dict on success.
 * 404 if the product is not found, 422 if the slot name is invalid.
 */
export const productsV5DeleteProductPhotoRouteMutation = (options?: Partial<Options<ProductsV5DeleteProductPhotoRouteData>>): UseMutationOptions<ProductsV5DeleteProductPhotoRouteResponse, DefaultError, Options<ProductsV5DeleteProductPhotoRouteData>> => {
    const mutationOptions: UseMutationOptions<ProductsV5DeleteProductPhotoRouteResponse, DefaultError, Options<ProductsV5DeleteProductPhotoRouteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await productsV5DeleteProductPhotoRoute({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
